<template>
  <div class="model-canvas-box">
    <div v-if="!isJingLuoSearchPage">
      <SettingButton></SettingButton>
      <div>
        <JinLuoCurrentTime></JinLuoCurrentTime>
      </div>
      <div class="main-page-button-main">
        <CustomButton @click.native="jingLuoSearch">经络查询</CustomButton>
        <CustomButton @click.native="normalDisease">常见疾病</CustomButton>
      </div>
    </div>
    <div v-else>
      <Return-button @click.native="returnButtonOnClick"></Return-button>
      <HomeButton></HomeButton>
      <div class="main-page-jingluo-search-main">
        <div class="main-page-jingluo-search-title" @click="searchTitleOnClick">
          {{ searchTitleName }}
        </div>
        <div>
          <div class="main-page-jingluo-search-list">
            <div v-if="isJingLuoSearch">
              <div v-for="(item,index) in jingLuoList" :key="index"
                   class="main-page-jingluo-search-element"
                   v-bind:class="{activeElement : index === currentJingMaiIndex}"
                   @click="jingMaiOnClick(index)">
                {{ item.jingMaiName }}
              </div>
            </div>
            <div v-else>
              <div v-for="(item,index) in jingLuoList[currentJingMaiIndex].xueweiList" :key="index"
                   @click="xueweiOnClicked(index)"
                   class="main-page-jingluo-search-element"
                   v-bind:class="{activeElement : index === currentXueweiIndex}">
                {{ item.xueweiName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <canvas class="box-3d-canvas" id="3d"></canvas>
  </div>
</template>

<script>
// @ is an alias to /src
import * as BABYLON from 'babylonjs';
import 'babylonjs-loaders';
import JinLuoCurrentTime from "@/components/JinLuoCurrentTime";
import CustomButton from "@/components/CustomButton";
import ReturnButton from "@/components/ReturnButton";
import HomeButton from "@/components/HomeButton";
import SettingButton from "@/components/SettingButton";
import CommonData from "@/assets/js/CommonData";

export default {
  name: 'Home',
  components: {
    HomeButton,
    ReturnButton,
    JinLuoCurrentTime,
    CustomButton,
    SettingButton,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      searchTitleName: "经络查询",
      jingLuoList: JSON.parse(JSON.stringify(CommonData.jingmaiList)),
      currentJingMaiIndex: 0,
      currentXueweiIndex: 0,
      isJingLuoSearch: true,
      isJingLuoSearchPage: false,
      firstTimeRefresh: false
    }
  },
  methods: {
    initPage: async function () {
      let canvas = document.getElementById("3d");
      // let gl2 = canvas.getContext('webgl2');
      // let ext = gl2.getExtension("OES_vertex_array_object");
      BABYLON.DefaultLoadingScreen.DefaultLogoUrl = require('../assets/image/loading.png');
      let loadingScreen = new BABYLON.DefaultLoadingScreen(canvas, "", "transparent");
      loadingScreen.DefaultLogoUrl = require('../assets/image/loading.png');
      let engine = this.engine = new BABYLON.Engine(canvas, true, {
        // doNotHandleContextLost: true
      });
      engine.loadingScreen = loadingScreen;
      engine.hideLoadingUI();
      let scene = this.scene = new BABYLON.Scene(engine);

      scene.enablePhysics(null, new BABYLON.AmmoJSPlugin());
      scene.collisionsEnabled = true;

      try {
        // engine.enableOfflineSupport = false;
        engine.hideLoadingUI();
        // let camera = this.camera = new BABYLON.FreeCamera("camera1", new BABYLON.Vector3(0, 1.3, 3), scene);
        let camera = this.camera = new BABYLON.ArcRotateCamera("camera1", Math.PI / 2, Math.PI / 2 - 0.3, 3, new BABYLON.Vector3(0, 1, 0), scene);
        // camera.setTarget(new BABYLON.Vector3(0, -20, -200));
        camera.inputs.clear();
        camera.inputs.addPointers();
        camera.attachControl(canvas, true);
        // camera.inputs.addKeyboard();
        // camera.inputs.addMouse();
        // camera.inputs.addTouch();
        // engine.displayLoadingUI();
      } catch (e) {
        console.log(e);
        engine.hideLoadingUI();
      }

      let material = this.material = new BABYLON.StandardMaterial("mat", scene);
      material.emissiveColor = new BABYLON.Color3(1, 0, 0);

      let whiteMaterial = this.whiteMaterial = new BABYLON.StandardMaterial("mat1", scene);
      whiteMaterial.emissiveColor = new BABYLON.Color3(1, 1, 1);

      let transparentMaterial = this.transparentMaterial = new BABYLON.StandardMaterial("mat2", scene);
      transparentMaterial.emissiveColor = new BABYLON.Color3(1, 1, 1);
      transparentMaterial.alpha = 0;

      BABYLON.SceneLoader.Append(`${this.publicPath}model/`, "1.glb", scene, function () {
        engine.hideLoadingUI();
        try {
          // let elevatorNormalTexture = new BABYLON.Texture(elevatorBlueTexture, scene, false, false);
          // let elevatorNormalMaterial = new BABYLON.StandardMaterial("elevatorNormalMaterial", scene);
          // elevatorNormalMaterial.emissiveTexture = elevatorNormalTexture;
          // scene.getMeshByName("_Group2009").material = elevatorNormalMaterial;
          console.log(scene.getMeshByName("_Group2009"));

          // let testMesh = scene.getMeshByName("test");
          // testMesh.physicsImpostor = new BABYLON.PhysicsImpostor(testMesh, BABYLON.PhysicsImpostor.BoxImpostor, {
          // mass: 1,
          // friction: 5,
          // restitution: 5
          // }, scene);

          // let mesh = scene.getMeshByName("_Group2009");
          // scene.getMeshByName("_Group2009").showBoundingBox = true;
          // mesh.setParent(null);
          // mesh.physicsImpostor = new BABYLON.PhysicsImpostor(mesh, BABYLON.PhysicsImpostor.NoImpostor, {
          //   mass: 0,
          //   friction: 5,
          //   restitution: 5
          // }, scene);
          // mesh.checkCollisions = true;

          // scene.getMeshByName("_Group2009").collisionsEnabled =true;
          //
          // let kuzi = new BABYLON.Texture(kuziiii, scene, false, false);
          // let kuziMaterial = new BABYLON.StandardMaterial("X3", scene);
          // kuziMaterial.emissiveTexture = kuzi;
          // scene.getMeshByName("Extract2:Group33607").material = kuziMaterial;
          //
          // console.log(scene.getMeshByName("_Group2009").material)
          // console.log("22222222222222222")
        } catch (e) {
          console.error(e);
          engine.hideLoadingUI();
        }

      });
      window.addEventListener('resize', function () {
        engine.resize();
      });
      scene.registerAfterRender(function () {
        // console.log(camera.getTarget())
        // console.log(camera._position)
      });
      engine.runRenderLoop(function () {
        scene.render();
      });
    },
    jingLuoSearch: function () {
      this.isJingLuoSearchPage = true;
      this.isJingLuoSearch = true;
      this.clearRedDotsAndLines();
      this.createLines();
    },
    normalDisease: function () {
      this.$router.push({
        path: '/diseaseMainPage',
        // query:{
        //   id:this.id ,
        // }
      })
    },
    jingMaiOnClick: function (index) {
      this.clearRedDotsAndLines();
      this.currentJingMaiIndex = index;
      this.currentXueweiIndex = -1;
      this.isJingLuoSearch = false;

      // let {x, y, z} = this.jingLuoList[this.currentJingMaiIndex].xueweiList[this.currentXueweiIndex].position;
      // this.redDots.push(this.createNewRedDot(x, y, z));
      // let gl = this.gl = new BABYLON.GlowLayer("glow", this.scene);
      // gl.intensity = 1;
      // gl.addExcludedMesh(this.lines);
      // let alpha = 0;
      // this.scene.registerBeforeRender(() => {
      //   alpha += 0.06;
      //   gl.intensity = Math.cos(alpha) * 2 + 2;
      // });
      this.createLines();
    },

    xueweiOnClicked: function (index) {
      this.currentXueweiIndex = index;
      this.clearRedDotsAndLines();
      let {x, y, z} = this.jingLuoList[this.currentJingMaiIndex].xueweiList[index].position;
      this.redDots.push(this.createNewRedDot(x, y, z));
      this.redDots.push(this.createNewEmptyDot(x, y, z))

      let gl = this.gl = new BABYLON.GlowLayer("glow", this.scene);
      gl.intensity = 50;
      gl.addExcludedMesh(this.lines);
      let alpha = 0;
      this.scene.registerBeforeRender(() => {
        alpha += 0.06;
        gl.intensity = Math.cos(alpha) * 2 + 3;
      });
      // this.$router.push({
      //   path: '/jingLuoDetailPage',
      //   // query:{
      //   //   id:this.id ,
      //   // }
      // })
    },
    searchTitleOnClick: function () {
      this.clearRedDotsAndLines();
      if (!this.isJingLuoSearch) {
        this.createLines();
        this.isJingLuoSearch = true;
      }
    },
    returnButtonOnClick: function () {
      this.clearRedDotsAndLines();
      this.isJingLuoSearch = false;
      this.isJingLuoSearchPage = false;
    },

    createNewRedDot: function (x, y, z) {
      let sphere = BABYLON.MeshBuilder.CreateSphere("sphere", {diameter: 0.015, segments: 8}, this.scene);
      sphere.position.x = x;
      sphere.position.y = y;
      sphere.position.z = z;
      sphere.material = this.material;

      // sphere.onPointerDownObservable.add(()=>{
      //   console.log("22222222222222")
      // })

      return sphere;
    },

    createNewEmptyDot: function (x, y, z) {
      let that = this;
      let sphere = BABYLON.MeshBuilder.CreateSphere("sphere", {diameter: 0.2, segments: 8}, this.scene);
      sphere.position.x = x;
      sphere.position.y = y;
      sphere.position.z = z;
      sphere.material = this.transparentMaterial;
      this.sphere = sphere;
      sphere.actionManager = new BABYLON.ActionManager(this.scene);
      sphere.actionManager.registerAction(
          new BABYLON.ExecuteCodeAction(
              BABYLON.ActionManager.OnPickDownTrigger,
              () => {
                if (that.currentJingMaiIndex >= 0 && that.currentXueweiIndex >= 0) {
                  that.$router.push({
                    path: '/jingLuoDetailPage',
                    query: {
                      currentJingMaiIndex: that.currentJingMaiIndex,
                      currentXueweiIndex: that.currentXueweiIndex,
                    }
                  })
                }
              }
          ));
    },

    createLines: function () {
      let linePoints = [];
      let redDots = this.redDots = [];
      this.jingLuoList[this.currentJingMaiIndex].xueweiList.forEach(xuewei => {
        let {x, y, z} = xuewei.position;
        let singlePoint = new BABYLON.Vector3(x, y, z);
        linePoints.push(singlePoint);

        if (xuewei.assistPoint && xuewei.assistPoint.length > 0) {
          xuewei.assistPoint.forEach(point => {
            let {x, y, z} = point.position;
            let singlePoint = new BABYLON.Vector3(x, y, z);
            linePoints.push(singlePoint);
          })
        }

        redDots.push(this.createNewRedDot(x, y, z));
      })
      this.lines = BABYLON.MeshBuilder.CreateTube("lines", {path: linePoints, radius: 0.0035}, this.scene);
      this.lines.material = this.whiteMaterial;
      for (let i = 0; i < linePoints.length - 1; i++) {
        let line = [];
        let stepX = -(linePoints[i + 1].x - linePoints[i].x) / 5;
        let stepY = -(linePoints[i + 1].y - linePoints[i].y) / 5;
        let stepZ = -(linePoints[i + 1].z - linePoints[i].z) / 5;
        for (let j = 0; j <= 5; j++) {
          line.push(new BABYLON.Vector3(linePoints[i + 1].x + stepX * j, linePoints[i + 1].y + stepY * j, linePoints[i + 1].z + stepZ * j));
        }

        // let myShape = [];
        // let radius = 0.0025;
        // for (let i = 0; i < 2 * Math.PI + 0.01; i += Math.PI / 8) {
        //   myShape.push(new BABYLON.Vector3(Math.cos(i), Math.sin(i), 0).scale(radius));
        // }

        // let rope = BABYLON.MeshBuilder.ExtrudeShape("ext" + i.toString(), {shape: myShape, path: line}, this.scene);
        // var ropeMat = new BABYLON.StandardMaterial("rope", this.scene);
        // ropeMat.diffuseColor = BABYLON.Color3.Red();
        // rope.material = ropeMat;
        //Create rope from lines
        // let rope = BABYLON.MeshBuilder.CreateLines("lines" + i.toString(), {points: line}, this.scene);
        // rope.color = BABYLON.Color3.White();
        // rope.physicsImpostor = new BABYLON.PhysicsImpostor(rope, BABYLON.PhysicsImpostor.RopeImpostor, {
        //   shape: myShape,
        //   path: line,
        //   fixedPoints: 4
        // }, this.scene);
        // rope.physicsImpostor.velocityIterations = 3000;
        // rope.physicsImpostor.positionIterations = 3000;
        // rope.physicsImpostor.stiffness = 100;
        // rope.checkCollisions = true;
      }
      // let box = BABYLON.MeshBuilder.CreateBox("box1", {size: 0.3}, this.scene);
      // box.position.y = 0.5;
      // box.physicsImpostor = new BABYLON.PhysicsImpostor(box, BABYLON.PhysicsImpostor.BoxImpostor, {
      //   mass: 0,
      //   friction: 0.5, restitution: 0.7
      // }, this.scene);
      // box.checkCollisions = true;

      // let box2 = BABYLON.MeshBuilder.CreateBox("box2", {size: 0.3}, this.scene);
      // box2.position.y = 3;
      // box2.physicsImpostor = new BABYLON.PhysicsImpostor(box2, BABYLON.PhysicsImpostor.BoxImpostor, {
      //   mass: 1,
      //   friction: 0.5, restitution: 0.7
      // }, this.scene);
      // box2.checkCollisions = true;
      // console.log(this.scene.meshes)
    },

    clearRedDotsAndLines: function () {
      if (this.lines !== null && this.lines !== undefined) {
        this.lines.dispose();
      }

      if (this.gl !== null && this.gl !== undefined) {
        this.gl.dispose();
      }

      if (this.sphere !== null && this.sphere !== undefined) {
        this.sphere.dispose();
      }

      if (this.redDots && this.redDots.length > 0) {
        this.redDots.forEach(dot => {
          if (dot !== null && dot !== undefined) {
            dot.dispose();
          }
        });
      }
      this.redDots = [];
    }
  },

  setMeshGroomLight: function () {

  },

  created() {
    this.firstTimeRefresh = true;
  },
  beforeMount() {
  },
  mounted() {
    if (this.firstTimeRefresh) {
      this.initPage();
      this.firstTimeRefresh = false;
      this.$route.meta.keepAlive = true;
    }

    // eslint-disable-next-line no-unused-vars
    let keshilist = [
      {
        "name": "心内科",
        "imgUrl": "xinneike",
        "clickedImgUrl": "xinneike2",
        "keShiCode": "xinneike",
        "disease": [
          {
            "name": "高血压"
          },
          {
            "name": "高脂血症"
          },
          {
            "name": "冠心病"
          },
          {
            "name": "胸闷"
          },
          {
            "name": "心悸"
          }
        ]
      },
      {
        "name": "呼吸科",
        "imgUrl": "huxike",
        "clickedImgUrl": "huxike2",
        "keShiCode": "huxike",
        "disease": [
          {
            "name": "感冒"
          },
          {
            "name": "咳嗽"
          },
          {
            "name": "哮喘"
          },
          {
            "name": "肺炎"
          },
          {
            "name": "慢性支气管炎"
          }
        ]
      },
      {
        "name": "消化科",
        "imgUrl": "xiaohuake",
        "clickedImgUrl": "xiaohuake2",
        "keShiCode": "xiaohuake",
        "disease": [
          {
            "name": "脂肪肝"
          },
          {
            "name": "慢性胆囊炎"
          },
          {
            "name": "打嗝"
          },
          {
            "name": "恶心呕吐"
          },
          {
            "name": "腹泻"
          },
          {
            "name": "肠鸣腹胀"
          },
          {
            "name": "慢性胃炎"
          },
          {
            "name": "胃下垂"
          },
          {
            "name": "十二指肠溃疡"
          }
        ]
      },
      {
        "name": "肛肠科",
        "imgUrl": "gangchangke",
        "clickedImgUrl": "gangchangke2",
        "keShiCode": "gangchangke",
        "disease": [
          {
            "name": "便秘"
          },
          {
            "name": "痔疮"
          }
        ]
      },
      {
        "name": "皮肤科",
        "imgUrl": "pifuke",
        "clickedImgUrl": "pifuke2",
        "keShiCode": "pifuke",
        "disease": [
          {
            "name": "皮肤瘙痒症"
          },
          {
            "name": "湿疹"
          },
          {
            "name": "痤疮"
          },
          {
            "name": "荨麻疹"
          },
          {
            "name": "黄褐斑"
          }
        ]
      },
      {
        "name": "骨伤科",
        "imgUrl": "gushangke",
        "clickedImgUrl": "gushangke2",
        "keShiCode": "gushangke",
        "disease": [
          {
            "name": "坐骨神经痛"
          },
          {
            "name": "颈椎病"
          },
          {
            "name": "腰椎间盘突出症"
          },
          {
            "name": "急性腰扭伤"
          },
          {
            "name": "肩周炎"
          },
          {
            "name": "腰肌劳损"
          },
          {
            "name": "小腿抽筋"
          },
          {
            "name": "足跟痛"
          }
        ]
      },
      {
        "name": "五官科",
        "imgUrl": "wuguanke",
        "clickedImgUrl": "wuguanke2",
        "keShiCode": "wuguanke",
        "disease": [
          {
            "name": "白内障"
          },
          {
            "name": "耳鸣"
          },
          {
            "name": "牙痛"
          },
          {
            "name": "咽喉肿痛"
          },
          {
            "name": "慢性咽炎"
          },
          {
            "name": "过敏性鼻炎"
          },
          {
            "name": "慢性鼻炎"
          }
        ]
      },
      {
        "name": "内分泌科",
        "imgUrl": "neifenbi",
        "clickedImgUrl": "neifenbi2",
        "keShiCode": "neifenbi",
        "disease": [
          {
            "name": "糖尿病"
          }
        ]
      },
      {
        "name": "风湿免疫科",
        "imgUrl": "fengshimianyike",
        "clickedImgUrl": "fengshimianyike2",
        "keShiCode": "fengshimianyike",
        "disease": [
          {
            "name": "类风湿性关节炎"
          }
        ]
      },
      {
        "name": "神经内科",
        "imgUrl": "shenjingneike",
        "clickedImgUrl": "shenjingneike2",
        "keShiCode": "shenjingneike",
        "disease": [
          {
            "name": "中风后遗症"
          },
          {
            "name": "头痛"
          },
          {
            "name": "头晕"
          },
          {
            "name": "失眠"
          },
          {
            "name": "神经衰弱"
          },
          {
            "name": "面神经麻痹"
          },
          {
            "name": "三叉神经痛"
          },
          {
            "name": "偏头痛"
          },
          {
            "name": ""
          }
        ]
      },
      {
        "name": "妇科",
        "imgUrl": "fuke",
        "clickedImgUrl": "fuke2",
        "keShiCode": "fuke",
        "disease": [
          {
            "name": "更年期综合征"
          },
          {
            "name": "乳腺增生"
          },
          {
            "name": "月经不调"
          },
          {
            "name": "痛经"
          },
          {
            "name": "闭经"
          }
        ]
      },
      {
        "name": "男科",
        "imgUrl": "nanke",
        "clickedImgUrl": "nanke2",
        "keShiCode": "nanke",
        "disease": [
          {
            "name": "阳痿"
          },
          {
            "name": "早泄"
          },
          {
            "name": "前列腺疾病"
          },
          {
            "name": "遗精"
          }
        ]
      }
    ];
    // eslint-disable-next-line no-unused-vars
    let jibinglist = [
      {
        "name": "糖尿病",
        "diseaseCode": "tangniaobing",
        "massageXueWeiList": [
          {
            "xueweiCode": "qihai",
            "xueweiName": "气海"
          },
          {
            "xueweiCode": "weiwanxiayu",
            "xueweiName": "胃脘下俞"
          },
          {
            "xueweiCode": "xuehai",
            "xueweiName": "血海"
          },
          {
            "xueweiCode": "yifeng",
            "xueweiName": "翳风"
          },
          {
            "xueweiCode": "quepen",
            "xueweiName": "缺盆"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "糖尿病1-气海",
            "description": "用食指、中指、无名指轻轻按摩气海2分钟，以产生酸胀感为宜。"
          },
          {
            "imgUrlName": "糖尿病2-胃脘下俞",
            "description": "用食指指端轻轻叩击胃脘下俞2分钟。"
          },
          {
            "imgUrlName": "糖尿病3-血海",
            "description": "用拇指指腹均衡用力按压血海1分钟，配合呼吸，效果更好。"
          },
          {
            "imgUrlName": "糖尿病4-翳风缺盆",
            "description": "用拇指指腹自上向下推桥弓（翳风与缺盆的连线）10-20次，左右交替进行。"
          }
        ],
        "classicalSymptom": "多尿、多饮、多食、消瘦。"
      },
      {
        "name": "高血压",
        "diseaseCode": "gaoxueya",
        "massageXueWeiList": [
          {
            "xueweiCode": "hegu",
            "xueweiName": "合谷"
          },
          {
            "xueweiCode": "neiguan",
            "xueweiName": "内关"
          },
          {
            "xueweiCode": "quchi",
            "xueweiName": "曲池"
          },
          {
            "xueweiCode": "taiyang",
            "xueweiName": "太阳"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "高血压1-合谷",
            "description": "用拇指指腹点按合谷30次，力度稍重。"
          },
          {
            "imgUrlName": "高血压2-内关",
            "description": "用拇指点揉内关3-5分钟，力度适中。"
          },
          {
            "imgUrlName": "高血压3-曲池",
            "description": "用食指中节按压曲池3分钟，力度稍重。"
          },
          {
            "imgUrlName": "高血压4-太阳",
            "description": "用双手掌根按揉两侧太阳，顺时针方向、逆时针方向各1分钟。"
          }
        ],
        "classicalSymptom": "头疼、眩晕、耳鸣、心悸。"
      },
      {
        "name": "高脂血症",
        "diseaseCode": "gaozhixuezheng",
        "massageXueWeiList": [
          {
            "xueweiCode": "shanzhong",
            "xueweiName": "膻中"
          },
          {
            "xueweiCode": "zhongwan",
            "xueweiName": "中脘"
          },
          {
            "xueweiCode": "fenglong",
            "xueweiName": "丰隆"
          },
          {
            "xueweiCode": "hegu",
            "xueweiName": "合谷"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "高脂血症1-膻中",
            "description": "用食指、中指、无名指指腹按揉膻中50次。"
          },
          {
            "imgUrlName": "高脂血症2-中脘",
            "description": "用拇指指端轻轻按压中脘20次。"
          },
          {
            "imgUrlName": "高脂血症3-丰隆",
            "description": "用拇指指端用力按揉丰隆2分钟。"
          },
          {
            "imgUrlName": "高脂血症4-合谷",
            "description": "用拇指指腹点按合谷30次，力度稍重。"
          }
        ],
        "classicalSymptom": "神疲乏力、失眠健忘、胸闷心悸。"
      },
      {
        "name": "冠心病",
        "diseaseCode": "guanxinbing",
        "massageXueWeiList": [
          {
            "xueweiCode": "xinyu",
            "xueweiName": "心俞"
          },
          {
            "xueweiCode": "neiguan",
            "xueweiName": "内关"
          },
          {
            "xueweiCode": "shenmen",
            "xueweiName": "神门"
          },
          {
            "xueweiCode": "jiquan",
            "xueweiName": "极泉"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "冠心病1-心俞",
            "description": "用食指指端轻轻叩击心俞2分钟，以产生酸胀感为宜。"
          },
          {
            "imgUrlName": "冠心病2-内关",
            "description": "用拇指点按内关30次，两手交替进行，力度适中。"
          },
          {
            "imgUrlName": "冠心病3-神门",
            "description": "用拇指和食指揉捏神门3-5分钟，两手交替进行，力度适中。"
          },
          {
            "imgUrlName": "冠心病4-极泉",
            "description": "用拇指按压极泉1分钟，其余四指扶住腋窝后方的肩膀。"
          }
        ],
        "classicalSymptom": "胸痛憋闷、心悸气短、脉搏不齐。"
      },
      {
        "name": "脂肪肝",
        "diseaseCode": "zhifanggan",
        "massageXueWeiList": [
          {
            "xueweiCode": "ganyu",
            "xueweiName": "肝俞"
          },
          {
            "xueweiCode": "piyu",
            "xueweiName": "脾俞"
          },
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "脂肪肝1-肝俞",
            "description": "用双手的拇指同时按压两侧肝俞20次，可边按边转圈。"
          },
          {
            "imgUrlName": "脂肪肝2-脾俞",
            "description": "用双手的拇指同时按压两侧脾俞20次，可边按边转圈。"
          },
          {
            "imgUrlName": "脂肪肝3-足三里",
            "description": "用拇指指腹重力按压足三里1-3分钟。"
          },
          {
            "imgUrlName": "脂肪肝4-三阴交",
            "description": "用拇指指腹均匀地按压三阴交2分钟。"
          }
        ],
        "classicalSymptom": "消化不良、肝区隐痛、神疲乏力。"
      },
      {
        "name": "慢性胆囊炎",
        "diseaseCode": "manxingdannangyan",
        "massageXueWeiList": [
          {
            "xueweiCode": "danyu",
            "xueweiName": "胆俞"
          },
          {
            "xueweiCode": "waiguan",
            "xueweiName": "外关"
          },
          {
            "xueweiCode": "yanglingquan",
            "xueweiName": "阳陵泉"
          },
          {
            "xueweiCode": "dannang",
            "xueweiName": "胆囊"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "慢性胆囊炎1-胆俞",
            "description": "用拇指指腹按揉胆俞1-3分钟。"
          },
          {
            "imgUrlName": "慢性胆囊炎2-外关",
            "description": "用拇指点按外关20次，力度适中。"
          },
          {
            "imgUrlName": "慢性胆囊炎3-阳陵泉",
            "description": "用拇指指端按揉阳陵泉100次，力度稍重。"
          },
          {
            "imgUrlName": "慢性胆囊炎4-胆囊",
            "description": "用拇指指端按揉胆囊3分钟，用力均衡。"
          }
        ],
        "classicalSymptom": "消化不良、胆囊绞痛。"
      },
      {
        "name": "更年期综合症",
        "diseaseCode": "gengnianqizonghezheng",
        "massageXueWeiList": [
          {
            "xueweiCode": "yintang",
            "xueweiName": "印堂"
          },
          {
            "xueweiCode": "piyu",
            "xueweiName": "脾俞"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          },
          {
            "xueweiCode": "baihui",
            "xueweiName": "百会"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "更年期综合症1-印堂",
            "description": "用食指指腹沿印堂向上推，反复做1分钟。"
          },
          {
            "imgUrlName": "更年期综合症2-脾俞",
            "description": "双手拇指用力按住脾俞，稍等片刻再猛然放开，反复做1分钟。"
          },
          {
            "imgUrlName": "更年期综合症3-三阴交",
            "description": "用拇指指腹按揉三阴交1分钟，适当用力。"
          },
          {
            "imgUrlName": "更年期综合症4-百会",
            "description": "用中间三指的指端叩击百会2-3分钟。"
          }
        ],
        "classicalSymptom": "面色潮红、自汗、多食、焦虑。"
      },
      {
        "name": "中风后遗症",
        "diseaseCode": "zhongfenghouyizheng",
        "massageXueWeiList": [
          {
            "xueweiCode": "quchi",
            "xueweiName": "曲池"
          },
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          },
          {
            "xueweiCode": "yongquan",
            "xueweiName": "涌泉"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "中风后遗症1-曲池",
            "description": "用拇指指腹按揉患侧曲池100次。"
          },
          {
            "imgUrlName": "中风后遗症2-足三里",
            "description": "用拇指点揉足三里1分钟，力度稍重。"
          },
          {
            "imgUrlName": "中风后遗症3-三阴交",
            "description": "用拇指点揉三阴交1分钟，力度适中。"
          },
          {
            "imgUrlName": "中风后遗症4-涌泉",
            "description": "用手掌反复搓擦涌泉3分钟至脚心发热。"
          }
        ],
        "classicalSymptom": "半边瘫痪、感觉减退、半边麻木。"
      },
      {
        "name": "白内障",
        "diseaseCode": "baineizhang",
        "massageXueWeiList": [
          {
            "xueweiCode": "taiyang",
            "xueweiName": "太阳"
          },
          {
            "xueweiCode": "taiyang",
            "xueweiName": "太阳"
          },
          {
            "xueweiCode": "fengchi",
            "xueweiName": "风池"
          },
          {
            "xueweiCode": "zanzhu",
            "xueweiName": "攒竹"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "白内障1-太阳",
            "description": "双手食指弯曲，从内向外抹刮眉弓至太阳，重复2分钟。"
          },
          {
            "imgUrlName": "白内障2-太阳",
            "description": "中指和无名指并拢，用二指的指腹按揉两侧太阳2分钟。"
          },
          {
            "imgUrlName": "白内障3-风池",
            "description": "用双手拇指按揉风池2分钟，力度以酸胀透遍全身为宜。"
          },
          {
            "imgUrlName": "白内障4-攒竹",
            "description": "用双手食指按压攒竹30次，力度宜轻。"
          }
        ],
        "classicalSymptom": "视物模糊、视物重影、视物变形。"
      },
      {
        "name": "头痛",
        "diseaseCode": "toutong",
        "massageXueWeiList": [
          {
            "xueweiCode": "baihui",
            "xueweiName": "百会"
          },
          {
            "xueweiCode": "taiyang",
            "xueweiName": "太阳"
          },
          {
            "xueweiCode": "taichong",
            "xueweiName": "太冲"
          },
          {
            "xueweiCode": "hegu",
            "xueweiName": "合谷"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "头痛1-百会",
            "description": "用食指指腹适当用力按揉百会1分钟。"
          },
          {
            "imgUrlName": "头痛2-太阳",
            "description": "用双手的指腹按揉两侧太阳1分钟。"
          },
          {
            "imgUrlName": "头痛3-太冲",
            "description": "用拇指指腹点按太冲1分钟，力度适中。"
          },
          {
            "imgUrlName": "头痛4-合谷",
            "description": "用拇指和食指夹住合谷，用力按揉1分钟。"
          }
        ],
        "classicalSymptom": "头部疼痛、有重压感、面红多汗。"
      },
      {
        "name": "耳鸣",
        "diseaseCode": "erming",
        "massageXueWeiList": [
          {
            "xueweiCode": "tinggong",
            "xueweiName": "听宫"
          },
          {
            "xueweiCode": "zhongzhu",
            "xueweiName": "中渚"
          },
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          },
          {
            "xueweiCode": "taixi",
            "xueweiName": "太溪"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "耳鸣1-听宫",
            "description": "用双手中指指腹按压听宫1分钟。"
          },
          {
            "imgUrlName": "耳鸣2-中渚",
            "description": "用拇指和食指揉捏中渚1分钟。"
          },
          {
            "imgUrlName": "耳鸣3-足三里",
            "description": "用拇指指腹按压足三里20-30次，力度稍重。"
          },
          {
            "imgUrlName": "耳鸣4-太溪",
            "description": "用拇指指腹按压太溪10-15次，力度稍重。"
          }
        ],
        "classicalSymptom": "耳聋、眩晕、头痛。"
      },
      {
        "name": "头晕",
        "diseaseCode": "touyun",
        "massageXueWeiList": [
          {
            "xueweiCode": "shenmen",
            "xueweiName": "神门"
          },
          {
            "xueweiCode": "fengchi",
            "xueweiName": "风池"
          },
          {
            "xueweiCode": "yanglingquan",
            "xueweiName": "阳陵泉"
          },
          {
            "xueweiCode": "yongquan",
            "xueweiName": "涌泉"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "头晕1-神门",
            "description": "用拇指按揉神门2分钟，力度适中。"
          },
          {
            "imgUrlName": "头晕2-风池",
            "description": "用双手拇指指端按揉风池1-2分钟，用力适中。"
          },
          {
            "imgUrlName": "头晕3-阳陵泉",
            "description": "用拇指指尖点按阳陵泉，双侧各按摩20次。"
          },
          {
            "imgUrlName": "头晕4-涌泉",
            "description": "用手掌反复搓涌泉3分钟，直至脚心发热。"
          }
        ],
        "classicalSymptom": "头昏脑胀、头重脚轻、视物旋转。"
      },
      {
        "name": "胸闷",
        "diseaseCode": "xiongmen",
        "massageXueWeiList": [
          {
            "xueweiCode": "neiguan",
            "xueweiName": "内关"
          },
          {
            "xueweiCode": "waiguan",
            "xueweiName": "外关"
          },
          {
            "xueweiCode": "shanzhong",
            "xueweiName": "膻中"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "胸闷1-内关",
            "description": "用拇指指腹按揉内关20-30次。"
          },
          {
            "imgUrlName": "胸闷2-外关",
            "description": "用拇指指腹按压外关2分钟，力度适中。"
          },
          {
            "imgUrlName": "胸闷3-膻中",
            "description": "中间三指并拢，用指腹按压膻中，力度要轻，直至胸闷缓解。"
          },
          {
            "imgUrlName": "胸闷4-三阴交",
            "description": "用拇指指腹按揉三阴交2分钟，左右交替进行，力度适中。"
          }
        ],
        "classicalSymptom": "呼吸费力、气不够用、全身乏力。"
      },
      {
        "name": "心悸",
        "diseaseCode": "xinji",
        "massageXueWeiList": [
          {
            "xueweiCode": "juque",
            "xueweiName": "巨阙"
          },
          {
            "xueweiCode": "xinyu",
            "xueweiName": "心俞"
          },
          {
            "xueweiCode": "qiemen",
            "xueweiName": "郄门"
          },
          {
            "xueweiCode": "quze",
            "xueweiName": "曲泽"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "心悸1-巨阙",
            "description": "用大鱼际从腹部巨阙处向下轻轻推摩30次。"
          },
          {
            "imgUrlName": "心悸2-心俞",
            "description": "右手握拳面轻轻叩击心俞1-3分钟。"
          },
          {
            "imgUrlName": "心悸3-郄门",
            "description": "用拇指指腹按压郄门3分钟，力度适中。"
          },
          {
            "imgUrlName": "心悸4-曲泽",
            "description": "用拇指按压曲泽30次，力度适中。"
          }
        ],
        "classicalSymptom": "心悸心慌、时作时息、善惊易恐、坐卧不安。"
      },
      {
        "name": "失眠",
        "diseaseCode": "shimian",
        "massageXueWeiList": [
          {
            "xueweiCode": "qianfajixian",
            "xueweiName": "前发际线"
          },
          {
            "xueweiCode": "taiyang",
            "xueweiName": "太阳"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          },
          {
            "xueweiCode": "yongquan",
            "xueweiName": "涌泉"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "失眠1-前发际线",
            "description": "双手五指张开，从前发际至后发际反复拿捏10次。"
          },
          {
            "imgUrlName": "失眠2-太阳",
            "description": "双手食指弯曲，抹刮眉弓至太阳2分钟。"
          },
          {
            "imgUrlName": "失眠3-三阴交",
            "description": "用拇指揉按三阴交2分钟，两侧可同时进行。"
          },
          {
            "imgUrlName": "失眠4-涌泉",
            "description": "用小鱼际擦热涌泉2分钟，力度稍重。"
          }
        ],
        "classicalSymptom": "入睡困难、不能熟睡、多梦早醒。"
      },
      {
        "name": "牙痛",
        "diseaseCode": "yatong",
        "massageXueWeiList": [
          {
            "xueweiCode": "xiaguan",
            "xueweiName": "下关"
          },
          {
            "xueweiCode": "jiache",
            "xueweiName": "颊车"
          },
          {
            "xueweiCode": "hegu",
            "xueweiName": "合谷"
          },
          {
            "xueweiCode": "xiangu",
            "xueweiName": "陷谷"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "牙痛1-下关",
            "description": "用食指指腹按揉下关2分钟。"
          },
          {
            "imgUrlName": "牙痛2-颊车",
            "description": "用食指指腹按揉颊车2分钟。"
          },
          {
            "imgUrlName": "牙痛3-合谷",
            "description": "用拇指用力按压合谷1分钟。"
          },
          {
            "imgUrlName": "牙痛4-陷谷",
            "description": "用拇指指端按揉陷谷1-2分钟，力度稍重。"
          }
        ],
        "classicalSymptom": "牙龈红肿、颌面疼痛、口渴口臭。"
      },
      {
        "name": "感冒",
        "diseaseCode": "ganmao",
        "massageXueWeiList": [
          {
            "xueweiCode": "yingxiang",
            "xueweiName": "迎香"
          },
          {
            "xueweiCode": "fengchi",
            "xueweiName": "风池"
          },
          {
            "xueweiCode": "jianjing",
            "xueweiName": "肩井"
          },
          {
            "xueweiCode": "quchi",
            "xueweiName": "曲池"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "感冒1-迎香",
            "description": "双手食指置于迎香处，上下搓擦1分钟，直至用鼻呼吸通畅。"
          },
          {
            "imgUrlName": "感冒2-风池",
            "description": "双手抱拢头部，用双手拇指在颈后的风池处揉捻1分钟。"
          },
          {
            "imgUrlName": "感冒3-肩井",
            "description": "用右手中间三指按揉左侧肩井1分钟，然后左手按右侧肩井，力度宜重。"
          },
          {
            "imgUrlName": "感冒4-曲池",
            "description": "用食指中节叩压曲池1分钟，力度稍大，双侧交替进行。"
          }
        ],
        "classicalSymptom": "喷嚏、鼻塞、流涕、咽痛。"
      },
      {
        "name": "咳嗽",
        "diseaseCode": "kesou",
        "massageXueWeiList": [
          {
            "xueweiCode": "feiyu",
            "xueweiName": "肺俞"
          },
          {
            "xueweiCode": "chize",
            "xueweiName": "尺泽"
          },
          {
            "xueweiCode": "lieque",
            "xueweiName": "列缺"
          },
          {
            "xueweiCode": "taixi",
            "xueweiName": "太溪"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "咳嗽1-肺俞",
            "description": "用中指端按揉肺俞1分钟，力度适中。"
          },
          {
            "imgUrlName": "咳嗽2-尺泽",
            "description": "用拇指指腹按压尺泽1-3分钟，力度适中。"
          },
          {
            "imgUrlName": "咳嗽3-列缺",
            "description": "用拇指指端压捻列缺2分钟，逐渐加力。"
          },
          {
            "imgUrlName": "咳嗽4-太溪",
            "description": "用拇指指腹按压太溪10-15次，力度适中。"
          }
        ],
        "classicalSymptom": "咳痰、气喘。"
      },
      {
        "name": "哮喘",
        "diseaseCode": "xiaochuan",
        "massageXueWeiList": [
          {
            "xueweiCode": "tiantu",
            "xueweiName": "天突"
          },
          {
            "xueweiCode": "renying",
            "xueweiName": "人迎"
          },
          {
            "xueweiCode": "dingchuan",
            "xueweiName": "定喘"
          },
          {
            "xueweiCode": "taiyuan",
            "xueweiName": "太渊"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "哮喘1-天突",
            "description": "用食指和中指轻轻按压天突1-2分钟。"
          },
          {
            "imgUrlName": "哮喘2-人迎",
            "description": "用拇指和食指同时按压两侧人迎1-3分钟。"
          },
          {
            "imgUrlName": "哮喘3-定喘",
            "description": "哮喘急性发作时，用拇指指端重按定喘30-50次。"
          },
          {
            "imgUrlName": "哮喘4-太渊",
            "description": "用拇指指腹按压太渊1-3分钟。"
          }
        ],
        "classicalSymptom": "咳嗽、喘息、胸闷、咳痰。"
      },
      {
        "name": "咽喉肿痛",
        "diseaseCode": "yanhouzhongtong",
        "massageXueWeiList": [
          {
            "xueweiCode": "tiantu",
            "xueweiName": "天突"
          },
          {
            "xueweiCode": "renying",
            "xueweiName": "人迎"
          },
          {
            "xueweiCode": "yuji",
            "xueweiName": "鱼际"
          },
          {
            "xueweiCode": "zhaohai",
            "xueweiName": "照海"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "咽喉肿痛1-天突",
            "description": "用食指按压天突3分钟，力度以感到酸胀为宜。"
          },
          {
            "imgUrlName": "咽喉肿痛2-人迎",
            "description": "用拇指和食指同时按压两侧的人迎1-3分钟。"
          },
          {
            "imgUrlName": "咽喉肿痛3-鱼际",
            "description": "用拇指指端按压鱼际3分钟，力度适中。"
          },
          {
            "imgUrlName": "咽喉肿痛4-照海",
            "description": "用拇指指端点揉照海3分钟，力度以产生酸胀感为宜。"
          }
        ],
        "classicalSymptom": "咽肿喉痛、吞咽困难、舌红苔黄。"
      },
      {
        "name": "慢性咽炎",
        "diseaseCode": "manxingyanyan",
        "massageXueWeiList": [
          {
            "xueweiCode": "yifeng",
            "xueweiName": "翳风"
          },
          {
            "xueweiCode": "renying",
            "xueweiName": "人迎"
          },
          {
            "xueweiCode": "neiguan",
            "xueweiName": "内关"
          },
          {
            "xueweiCode": "zhaohai",
            "xueweiName": "照海"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "慢性咽炎1-翳风",
            "description": "双手食指同时按压翳风1分钟，力度较轻。"
          },
          {
            "imgUrlName": "慢性咽炎2-人迎",
            "description": "用拇指和食指同时按压两侧的人迎1分钟。"
          },
          {
            "imgUrlName": "慢性咽炎3-内关",
            "description": "用拇指指端按压内关1-3分钟，适当用力。"
          },
          {
            "imgUrlName": "慢性咽炎4-照海",
            "description": "用拇指指端点按照海50-100次，力度以局部酸胀为宜。"
          }
        ],
        "classicalSymptom": "咽部不适、干咳恶心、白色痰液。"
      },
      {
        "name": "肺炎",
        "diseaseCode": "feiyan",
        "massageXueWeiList": [
          {
            "xueweiCode": "dazhui",
            "xueweiName": "大椎"
          },
          {
            "xueweiCode": "shanzhong",
            "xueweiName": "膻中"
          },
          {
            "xueweiCode": "fengchi",
            "xueweiName": "风池"
          },
          {
            "xueweiCode": "chize",
            "xueweiName": "尺泽"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "肺炎1-大椎",
            "description": "用拇指按揉大椎1分钟，力度要轻。"
          },
          {
            "imgUrlName": "肺炎2-膻中",
            "description": "用中间三指的指腹轻轻按压膻中1分钟。"
          },
          {
            "imgUrlName": "肺炎3-风池",
            "description": "用两手拇指抵住风池，左右同时按压1-3分钟"
          },
          {
            "imgUrlName": "肺炎4-尺泽",
            "description": "用拇指指端按揉尺泽3分钟，力度适中。"
          }
        ],
        "classicalSymptom": "呼吸急促、持久干咳、单边胸痛。"
      },
      {
        "name": "慢性支气管炎",
        "diseaseCode": "manxingzhiqiguanyan",
        "massageXueWeiList": [
          {
            "xueweiCode": "feiyu",
            "xueweiName": "肺俞"
          },
          {
            "xueweiCode": "shenyu",
            "xueweiName": "肾俞"
          },
          {
            "xueweiCode": "zhongfu",
            "xueweiName": "中府"
          },
          {
            "xueweiCode": "hegu",
            "xueweiName": "合谷"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "慢性支气管炎1-肺俞",
            "description": "用拇指按揉肺俞3分钟，力度适中。"
          },
          {
            "imgUrlName": "慢性支气管炎2-肾俞",
            "description": "用双手拇指点按肾俞30次，力度适中。"
          },
          {
            "imgUrlName": "慢性支气管炎3-中府",
            "description": "中间三指并拢，轻轻按揉中府2-3分钟。"
          },
          {
            "imgUrlName": "慢性支气管炎4-合谷",
            "description": "用拇指和食指捏按合谷30次，适当加力。"
          }
        ],
        "classicalSymptom": "终年咳嗽、咳痰不停、冬秋加剧。"
      },
      {
        "name": "过敏性鼻炎",
        "diseaseCode": "guominxingbiyan",
        "massageXueWeiList": [
          {
            "xueweiCode": "taiyang",
            "xueweiName": "太阳"
          },
          {
            "xueweiCode": "yintang",
            "xueweiName": "印堂"
          },
          {
            "xueweiCode": "yingxiang",
            "xueweiName": "迎香"
          },
          {
            "xueweiCode": "fengchi",
            "xueweiName": "风池"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "过敏性鼻炎1-太阳",
            "description": "用食指指腹按揉太阳2分钟。"
          },
          {
            "imgUrlName": "过敏性鼻炎2-印堂",
            "description": "用双手中指指腹交替推印堂100次。"
          },
          {
            "imgUrlName": "过敏性鼻炎3-迎香",
            "description": "用食指和中指指端上下推擦迎香2分钟。"
          },
          {
            "imgUrlName": "过敏性鼻炎4-风池",
            "description": "双手拇指按揉风池2分钟。"
          }
        ],
        "classicalSymptom": "喷嚏、鼻痒、流涕、鼻塞。"
      },
      {
        "name": "慢性鼻炎",
        "diseaseCode": "manxingbiyan",
        "massageXueWeiList": [
          {
            "xueweiCode": "baihui",
            "xueweiName": "百会"
          },
          {
            "xueweiCode": "yingxiang",
            "xueweiName": "迎香"
          },
          {
            "xueweiCode": "yintang",
            "xueweiName": "印堂"
          },
          {
            "xueweiCode": "biyi",
            "xueweiName": "鼻翼"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "慢性鼻炎1-百会",
            "description": "用食指指腹顺时针揉百会1分钟。"
          },
          {
            "imgUrlName": "慢性鼻炎2-迎香",
            "description": "用双手食指同时按压迎香1分钟。"
          },
          {
            "imgUrlName": "慢性鼻炎3-印堂",
            "description": "用食指指腹按压印堂1分钟，力度要轻。"
          },
          {
            "imgUrlName": "慢性鼻炎4-鼻翼",
            "description": "用食指和中指指腹推擦两侧鼻翼100次。"
          }
        ],
        "classicalSymptom": "鼻塞、多涕。"
      },
      {
        "name": "打嗝",
        "diseaseCode": "dage",
        "massageXueWeiList": [
          {
            "xueweiCode": "zhongwan",
            "xueweiName": "中脘"
          },
          {
            "xueweiCode": "quepen",
            "xueweiName": "缺盆"
          },
          {
            "xueweiCode": "neiguan",
            "xueweiName": "内关"
          },
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "打嗝1-中脘",
            "description": "用拇指指端轻轻按压中脘20次。"
          },
          {
            "imgUrlName": "打嗝2-缺盆",
            "description": "用食指指腹按揉对侧缺盆1-3分钟。"
          },
          {
            "imgUrlName": "打嗝3-内关",
            "description": "用食指和拇指夹住手腕的内关，掐按3分钟。"
          },
          {
            "imgUrlName": "打嗝4-足三里",
            "description": "用拇指指腹按压足三里1-3分钟。"
          }
        ],
        "classicalSymptom": "持续、反复打嗝。"
      },
      {
        "name": "恶心呕吐",
        "diseaseCode": "exinoutu",
        "massageXueWeiList": [
          {
            "xueweiCode": "shanzhong",
            "xueweiName": "膻中"
          },
          {
            "xueweiCode": "tianshu",
            "xueweiName": "天枢"
          },
          {
            "xueweiCode": "neiguan",
            "xueweiName": "内关"
          },
          {
            "xueweiCode": "weiyu",
            "xueweiName": "胃俞"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "恶心呕吐1-膻中",
            "description": "用中间三指的指腹推下膻中100次。"
          },
          {
            "imgUrlName": "恶心呕吐2-天枢",
            "description": "用拇指指腹按揉天枢1分钟，适当用力。"
          },
          {
            "imgUrlName": "恶心呕吐3-内关",
            "description": "用拇指指端掐按内关20次，力度适中。"
          },
          {
            "imgUrlName": "恶心呕吐4-胃俞",
            "description": "用拇指指端按压胃俞20次。"
          }
        ],
        "classicalSymptom": "皮肤苍白、出汗流涎、两眼发黑。"
      },
      {
        "name": "腹泻",
        "diseaseCode": "fuxie",
        "massageXueWeiList": [
          {
            "xueweiCode": "dazhui",
            "xueweiName": "大椎"
          },
          {
            "xueweiCode": "zhongwan",
            "xueweiName": "中脘"
          },
          {
            "xueweiCode": "shenque",
            "xueweiName": "神阙"
          },
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          },
          {
            "xueweiCode": "shanglian",
            "xueweiName": "上廉"
          },
          {
            "xueweiCode": "xialian",
            "xueweiName": "下廉"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "腹泻1-大椎",
            "description": "用拇指指腹按揉大椎20次，其余四指置于脖间，力度要轻。"
          },
          {
            "imgUrlName": "腹泻2-中脘神阙",
            "description": "用掌心在中脘穴和神阙周围揉摩1-3分钟，直至腹部发热。"
          },
          {
            "imgUrlName": "腹泻3-足三里",
            "description": "用拇指指腹按压足三里20次，力度稍重。"
          },
          {
            "imgUrlName": "腹泻4-上廉下廉",
            "description": "用拇指指腹按揉上廉、下廉1-3分钟。"
          }
        ],
        "classicalSymptom": "发热、腹痛、腹胀、呕吐。"
      },
      {
        "name": "肠鸣腹胀",
        "diseaseCode": "changmingfuzhang",
        "massageXueWeiList": [
          {
            "xueweiCode": "zhongwan",
            "xueweiName": "中脘"
          },
          {
            "xueweiCode": "shenque",
            "xueweiName": "神阙"
          },
          {
            "xueweiCode": "tianshu",
            "xueweiName": "天枢"
          },
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          },
          {
            "xueweiCode": "gongsun",
            "xueweiName": "公孙"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "肠鸣腹胀1-中脘",
            "description": "用拇指或中指轻轻点按中脘1分钟。"
          },
          {
            "imgUrlName": "肠鸣腹胀2-神阙天枢",
            "description": "用掌心按摩神阙、天枢，直至腹部发热。"
          },
          {
            "imgUrlName": "肠鸣腹胀3-足三里",
            "description": "用拇指重力按压足三里20次。"
          },
          {
            "imgUrlName": "肠鸣腹胀4-公孙",
            "description": "用拇指指腹按揉两侧公孙100次，两侧可同时进行。"
          }
        ],
        "classicalSymptom": "嗳气、呕吐、便秘、矢气。"
      },
      {
        "name": "便秘",
        "diseaseCode": "bianmi",
        "massageXueWeiList": [
          {
            "xueweiCode": "tianshu",
            "xueweiName": "天枢"
          },
          {
            "xueweiCode": "dachangyu",
            "xueweiName": "大肠俞"
          },
          {
            "xueweiCode": "zhigou",
            "xueweiName": "支沟"
          },
          {
            "xueweiCode": "shangjuxu",
            "xueweiName": "上巨虚"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "便秘1-天枢",
            "description": "用拇指指腹按揉天枢1分钟，可两侧同时按压。"
          },
          {
            "imgUrlName": "便秘2-大肠俞",
            "description": "用双手拇指点按大肠俞20次，力度适中。"
          },
          {
            "imgUrlName": "便秘3-支沟",
            "description": "用拇指指腹按揉支沟1分钟，以产生酸胀感为宜，双手交替进行。"
          },
          {
            "imgUrlName": "便秘4-上巨虚",
            "description": "用拇指略微用力按压上巨虚，以略感疼痛为佳，按住5秒后松开，反复10次。"
          }
        ],
        "classicalSymptom": "粪质干燥、排出困难、次数减少。"
      },
      {
        "name": "痔疮",
        "diseaseCode": "zhichuang",
        "massageXueWeiList": [
          {
            "xueweiCode": "zhangqiang",
            "xueweiName": "长强"
          },
          {
            "xueweiCode": "chengshan",
            "xueweiName": "承山"
          },
          {
            "xueweiCode": "baihui",
            "xueweiName": "百会"
          },
          {
            "xueweiCode": "yongquan",
            "xueweiName": "涌泉"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "痔疮1-长强",
            "description": "用中指指端按揉长强3分钟。"
          },
          {
            "imgUrlName": "痔疮2-承山",
            "description": "取跪姿，将拳头放在承山的位置，然后用大腿夹紧，刺激3-5分钟。"
          },
          {
            "imgUrlName": "痔疮3-百会",
            "description": "用食指和中指指端按揉百会约3分钟。"
          },
          {
            "imgUrlName": "痔疮4-涌泉",
            "description": "用手掌搓擦足底涌泉3-5分钟，直至脚心发热。"
          }
        ],
        "classicalSymptom": "无痛性便血。痔块脱垂时，可有胀痛。"
      },
      {
        "name": "慢性胃炎",
        "diseaseCode": "manxingweiyan",
        "massageXueWeiList": [
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          },
          {
            "xueweiCode": "zhongwan",
            "xueweiName": "中脘"
          },
          {
            "xueweiCode": "weiyu",
            "xueweiName": "胃俞"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "慢性胃炎1-足三里",
            "description": "用拇指指端按压足三里，左右各3分钟。"
          },
          {
            "imgUrlName": "慢性胃炎2-三阴交",
            "description": "用拇指指端用力按压三阴交，左右各3分钟。"
          },
          {
            "imgUrlName": "慢性胃炎3-中脘",
            "description": "中间三指并拢，用指腹按揉中脘3分钟。"
          },
          {
            "imgUrlName": "慢性胃炎4-胃俞",
            "description": "双手拇指用力按压背部的胃俞10次。"
          }
        ],
        "classicalSymptom": "上腹隐痛、食欲减退、餐后饱胀。"
      },
      {
        "name": "胃下垂",
        "diseaseCode": "weixiachui",
        "massageXueWeiList": [
          {
            "xueweiCode": "shenque",
            "xueweiName": "神阙"
          },
          {
            "xueweiCode": "qihai",
            "xueweiName": "气海"
          },
          {
            "xueweiCode": "weiyu",
            "xueweiName": "胃俞"
          },
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "胃下垂1-神阙",
            "description": "两手掌相叠，自神阙向左上腹推抹100次。"
          },
          {
            "imgUrlName": "胃下垂2-气海",
            "description": "中间三指并拢，用指腹按揉腹部气海1分钟。"
          },
          {
            "imgUrlName": "胃下垂3-胃俞",
            "description": "用双手拇指用力按压胃俞20次。"
          },
          {
            "imgUrlName": "胃下垂4-足三里",
            "description": "用拇指按压两侧足三里各1分钟。"
          }
        ],
        "classicalSymptom": "胃痛、恶心、腹胀、嗳气。"
      },
      {
        "name": "十二指肠溃疡",
        "diseaseCode": "shierzhichangkuiyang",
        "massageXueWeiList": [
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          },
          {
            "xueweiCode": "weiyu",
            "xueweiName": "胃俞"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          },
          {
            "xueweiCode": "zhongwan",
            "xueweiName": "中脘"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "十二指肠溃疡1-足三里",
            "description": "用拇指指端重按足三里100次。"
          },
          {
            "imgUrlName": "十二指肠溃疡2-胃俞",
            "description": "双手拇指同时按压胃俞20次。"
          },
          {
            "imgUrlName": "十二指肠溃疡3-三阴交",
            "description": "拇指用力按压三阴交20次。"
          },
          {
            "imgUrlName": "十二指肠溃疡4-中脘",
            "description": "用中间三指的指腹摩中脘2-3分钟。"
          }
        ],
        "classicalSymptom": "饥饿不适、饱胀嗳气、上腹疼痛。"
      },
      {
        "name": "神经衰弱",
        "diseaseCode": "shenjingshuairuo",
        "massageXueWeiList": [
          {
            "xueweiCode": "baihui",
            "xueweiName": "百会"
          },
          {
            "xueweiCode": "fengchi",
            "xueweiName": "风池"
          },
          {
            "xueweiCode": "laogong",
            "xueweiName": "劳宫"
          },
          {
            "xueweiCode": "shenmen",
            "xueweiName": "神门"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "神经衰弱1-百会",
            "description": "用中指的指腹轻轻按压百会1分钟。"
          },
          {
            "imgUrlName": "神经衰弱2-风池",
            "description": "用拇指和食指拿捏风池30次，力度适中。"
          },
          {
            "imgUrlName": "神经衰弱3-劳宫",
            "description": "用拇指指腹按揉劳宫3分钟，力度适中。"
          },
          {
            "imgUrlName": "神经衰弱4-神门",
            "description": "用拇指和食指揉捏神门3分钟，力度适中。"
          }
        ],
        "classicalSymptom": "烦躁易怒、神疲乏力、睡眠障碍。"
      },
      {
        "name": "坐骨神经痛",
        "diseaseCode": "zuogushenjingtong",
        "massageXueWeiList": [
          {
            "xueweiCode": "huantiao",
            "xueweiName": "环跳"
          },
          {
            "xueweiCode": "yanglingquan",
            "xueweiName": "阳陵泉"
          },
          {
            "xueweiCode": "weizhong",
            "xueweiName": "委中"
          },
          {
            "xueweiCode": "chengshan",
            "xueweiName": "承山"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "坐骨神经痛1-环跳",
            "description": "用中间三指的指端按揉患侧环跳100次，用力稍重。"
          },
          {
            "imgUrlName": "坐骨神经痛2-阳陵泉",
            "description": "用拇指用力点按阳陵泉100次。"
          },
          {
            "imgUrlName": "坐骨神经痛3-委中",
            "description": "用拇指点按委中30次，力度以可以耐受为度。"
          },
          {
            "imgUrlName": "坐骨神经痛4-承山",
            "description": "用拇指指腹按揉承山100次，用力稍重。"
          }
        ],
        "classicalSymptom": "患侧疼痛、感觉减退、夜间加剧。"
      },
      {
        "name": "面神经麻痹",
        "diseaseCode": "mianshenjingmabi",
        "massageXueWeiList": [
          {
            "xueweiCode": "sizhukong",
            "xueweiName": "丝竹空"
          },
          {
            "xueweiCode": "sibai",
            "xueweiName": "四白"
          },
          {
            "xueweiCode": "dicang",
            "xueweiName": "地仓"
          },
          {
            "xueweiCode": "yifeng",
            "xueweiName": "翳风"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "面神经麻痹1-丝竹空",
            "description": "用双手食指轻轻按揉丝竹空1-3分钟。"
          },
          {
            "imgUrlName": "面神经麻痹2-四白",
            "description": "用双手食指轻轻按压四白1-3分钟。"
          },
          {
            "imgUrlName": "面神经麻痹3-地仓",
            "description": "用双手食指按揉地仓1-3分钟。"
          },
          {
            "imgUrlName": "面神经麻痹4-翳风",
            "description": "用食指指腹轻轻揉按翳风1-3分钟。"
          }
        ],
        "classicalSymptom": "面颊不灵、口眼歪斜、眼裂扩大。"
      },
      {
        "name": "三叉神经痛",
        "diseaseCode": "sanchashenjingtong",
        "massageXueWeiList": [
          {
            "xueweiCode": "sibai",
            "xueweiName": "四白"
          },
          {
            "xueweiCode": "quanliao",
            "xueweiName": "颧髎"
          },
          {
            "xueweiCode": "xiaguan",
            "xueweiName": "下关"
          },
          {
            "xueweiCode": "yifeng",
            "xueweiName": "翳风"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "三叉神经痛1-四白",
            "description": "用双手食指轻轻按揉四白1分钟。"
          },
          {
            "imgUrlName": "三叉神经痛2-颧髎",
            "description": "用食指指腹轻轻按压颧髎1-3分钟。"
          },
          {
            "imgUrlName": "三叉神经痛3-下关",
            "description": "用双手食指指腹按揉下关1分钟，力度适中。"
          },
          {
            "imgUrlName": "三叉神经痛4-翳风",
            "description": "用双手食指同时按压翳风1分钟。"
          }
        ],
        "classicalSymptom": "骤然发作、没有先兆、多为一侧。"
      },
      {
        "name": "偏头痛",
        "diseaseCode": "piantoutong",
        "massageXueWeiList": [
          {
            "xueweiCode": "taiyang",
            "xueweiName": "太阳"
          },
          {
            "xueweiCode": "lügu",
            "xueweiName": "率谷"
          },
          {
            "xueweiCode": "jianjing",
            "xueweiName": "肩井"
          },
          {
            "xueweiCode": "taichong",
            "xueweiName": "太冲"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "偏头痛1-太阳",
            "description": "用双手大鱼际按揉两侧太阳1分钟。"
          },
          {
            "imgUrlName": "偏头痛2-率谷",
            "description": "用大鱼际向后推率谷100次。"
          },
          {
            "imgUrlName": "偏头痛3-肩井",
            "description": "用手指按揉同侧肩井3-5分钟。"
          },
          {
            "imgUrlName": "偏头痛4-太冲",
            "description": "用食指指腹按压太冲5次，力度稍大。"
          }
        ],
        "classicalSymptom": "恶心、呕吐、畏光、畏声。"
      },
      {
        "name": "皮肤瘙痒症",
        "diseaseCode": "pifusaoyangzheng",
        "massageXueWeiList": [
          {
            "xueweiCode": "quchi",
            "xueweiName": "曲池"
          },
          {
            "xueweiCode": "shenmen",
            "xueweiName": "神门"
          },
          {
            "xueweiCode": "xuehai",
            "xueweiName": "血海"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "皮肤瘙痒症1-曲池",
            "description": "用拇指指腹用力按压曲池3-5分钟。"
          },
          {
            "imgUrlName": "皮肤瘙痒症2-神门",
            "description": "用拇指指腹按揉神门2分钟。"
          },
          {
            "imgUrlName": "皮肤瘙痒症3-血海",
            "description": "用拇指指腹按揉血海100次。"
          },
          {
            "imgUrlName": "皮肤瘙痒症4-三阴交",
            "description": "用拇指掐按三阴交50次，力度稍大。"
          }
        ],
        "classicalSymptom": "皮肤瘙痒、抓后留痕、色素沉着。"
      },
      {
        "name": "湿疹",
        "diseaseCode": "shizhen",
        "massageXueWeiList": [
          {
            "xueweiCode": "piyu",
            "xueweiName": "脾俞"
          },
          {
            "xueweiCode": "yinlingquan",
            "xueweiName": "阴陵泉"
          },
          {
            "xueweiCode": "quchi",
            "xueweiName": "曲池"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "湿疹1-脾俞",
            "description": "用双手拇指按压脾俞1-3分钟，力度适中。"
          },
          {
            "imgUrlName": "湿疹2-阴陵泉",
            "description": "双手的拇指同时按压两侧的阴陵泉100次。"
          },
          {
            "imgUrlName": "湿疹3-曲池",
            "description": "用拇指指端点按曲池1分钟，力度稍大。"
          },
          {
            "imgUrlName": "湿疹4-三阴交",
            "description": "用拇指用力按揉三阴交1分钟，两侧可同时进行。"
          }
        ],
        "classicalSymptom": "成片红斑、密集丘疹、重则水疱。"
      },
      {
        "name": "痤疮",
        "diseaseCode": "cuochuang",
        "massageXueWeiList": [
          {
            "xueweiCode": "xiaguan",
            "xueweiName": "下关"
          },
          {
            "xueweiCode": "chize",
            "xueweiName": "尺泽"
          },
          {
            "xueweiCode": "tianshu",
            "xueweiName": "天枢"
          },
          {
            "xueweiCode": "neiting",
            "xueweiName": "内庭"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "痤疮1-下关",
            "description": "用双手食指指腹轻轻按揉下关1分钟。"
          },
          {
            "imgUrlName": "痤疮2-尺泽",
            "description": "用拇指指腹按揉尺泽100次。"
          },
          {
            "imgUrlName": "痤疮3-天枢",
            "description": "用双手的拇指指腹同时按揉两侧天枢1分钟。"
          },
          {
            "imgUrlName": "痤疮4-内庭",
            "description": "用拇指指腹重力按压内庭1-3分钟。"
          }
        ],
        "classicalSymptom": "粉刺、丘疹、脓疱。"
      },
      {
        "name": "荨麻疹",
        "diseaseCode": "qianmazhen",
        "massageXueWeiList": [
          {
            "xueweiCode": "quchi",
            "xueweiName": "曲池"
          },
          {
            "xueweiCode": "hegu",
            "xueweiName": "合谷"
          },
          {
            "xueweiCode": "yinlingquan",
            "xueweiName": "阴陵泉"
          },
          {
            "xueweiCode": "xuehai",
            "xueweiName": "血海"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "荨麻疹1-曲池",
            "description": "用拇指指端按揉曲池2-3分钟。"
          },
          {
            "imgUrlName": "荨麻疹2-合谷",
            "description": "用拇指和食指夹住合谷，用力按揉1-3分钟。"
          },
          {
            "imgUrlName": "荨麻疹3-阴陵泉",
            "description": "用拇指指腹按压阴陵泉20次，力度适中。"
          },
          {
            "imgUrlName": "荨麻疹4-血海",
            "description": "用拇指指腹按揉血海100-300次。"
          }
        ],
        "classicalSymptom": "风疹发痒、此起彼伏、伴麻刺感、全身不适。"
      },
      {
        "name": "黄褐斑",
        "diseaseCode": "huangheban",
        "massageXueWeiList": [
          {
            "xueweiCode": "shenyu",
            "xueweiName": "肾俞"
          },
          {
            "xueweiCode": "xuehai",
            "xueweiName": "血海"
          },
          {
            "xueweiCode": "fuliu",
            "xueweiName": "复溜"
          },
          {
            "xueweiCode": "taichong",
            "xueweiName": "太冲"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "黄褐斑1-肾俞",
            "description": "用双手的拇指指端按压肾俞20次"
          },
          {
            "imgUrlName": "黄褐斑2-血海",
            "description": "用拇指指腹按压血海1-3分钟。"
          },
          {
            "imgUrlName": "黄褐斑3-复溜",
            "description": "用拇指指腹按揉复溜1分钟。"
          },
          {
            "imgUrlName": "黄褐斑4-太冲",
            "description": "用食指指腹按压太冲1分钟，力度稍大。"
          }
        ],
        "classicalSymptom": "枯暗无泽、表面光滑、无痛无痒。"
      },
      {
        "name": "颈椎病",
        "diseaseCode": "jingzhuibing",
        "massageXueWeiList": [
          {
            "xueweiCode": "fengchi",
            "xueweiName": "风池"
          },
          {
            "xueweiCode": "dazhui",
            "xueweiName": "大椎"
          },
          {
            "xueweiCode": "jianjing",
            "xueweiName": "肩井"
          },
          {
            "xueweiCode": "shousanli",
            "xueweiName": "手三里"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "颈椎病1-风池",
            "description": "用两手拇指同时按揉两侧风池1-3分钟，力度以全身酸透为宜。"
          },
          {
            "imgUrlName": "颈椎病2-大椎",
            "description": "用拇指和食指沿风池穴向下拿捏至大椎，约1分钟。"
          },
          {
            "imgUrlName": "颈椎病3-肩井",
            "description": "用双手中指指腹按压同侧肩井，由轻到重按压10次。"
          },
          {
            "imgUrlName": "颈椎病4-手三里",
            "description": "用拇指指腹按揉手三里1-3分钟。"
          }
        ],
        "classicalSymptom": "颈部僵硬、手臂酸麻、或伴头晕。"
      },
      {
        "name": "腰椎间盘突出症",
        "diseaseCode": "yaozhuijianpantuchuzheng",
        "massageXueWeiList": [
          {
            "xueweiCode": "dachangyu",
            "xueweiName": "大肠俞"
          },
          {
            "xueweiCode": "weizhong",
            "xueweiName": "委中"
          },
          {
            "xueweiCode": "yanglingquan",
            "xueweiName": "阳陵泉"
          },
          {
            "xueweiCode": "yaotongdian",
            "xueweiName": "腰痛点"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "腰椎间盘突出症1-大肠俞",
            "description": "用双手拇指分别按压两侧的大肠俞20次。"
          },
          {
            "imgUrlName": "腰椎间盘突出症2-委中",
            "description": "用拇指点按委中30次，力度以可以耐受为度。"
          },
          {
            "imgUrlName": "腰椎间盘突出症3-阳陵泉",
            "description": "用拇指点按阳陵泉30次，力度适中。"
          },
          {
            "imgUrlName": "腰椎间盘突出症4-腰痛点",
            "description": "疼痛发作时，用拇指揉按手背的腰痛点3分钟。"
          }
        ],
        "classicalSymptom": "腰腿疼痛、下肢麻木、下肢发凉。"
      },
      {
        "name": "急性腰扭伤",
        "diseaseCode": "jixingyaoniushang",
        "massageXueWeiList": [
          {
            "xueweiCode": "weizhong",
            "xueweiName": "委中"
          },
          {
            "xueweiCode": "yaotongdian",
            "xueweiName": "腰痛点"
          },
          {
            "xueweiCode": "taixi",
            "xueweiName": "太溪"
          },
          {
            "xueweiCode": "kunlun",
            "xueweiName": "昆仑"
          },
          {
            "xueweiCode": "huantiao",
            "xueweiName": "环跳"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "急性腰扭伤1-委中",
            "description": "用拇指点按委中30次，力度以能够耐受为度。"
          },
          {
            "imgUrlName": "急性腰扭伤2-腰痛点",
            "description": "用拇指揉按手背的腰痛点3分钟。"
          },
          {
            "imgUrlName": "急性腰扭伤3-太溪昆仑",
            "description": "用拇指、中指和食指指腹同时拿捏太溪和昆仑30次，力度要重。"
          },
          {
            "imgUrlName": "急性腰扭伤4-环跳",
            "description": "用双手拇指指腹点按环跳3分钟。"
          }
        ],
        "classicalSymptom": "腰部僵硬、疼痛剧烈、不能活动。"
      },
      {
        "name": "肩周炎",
        "diseaseCode": "jianzhouyan",
        "massageXueWeiList": [
          {
            "xueweiCode": "jianyu",
            "xueweiName": "肩髃"
          },
          {
            "xueweiCode": "jianzhen",
            "xueweiName": "肩贞"
          },
          {
            "xueweiCode": "jianliao",
            "xueweiName": "肩髎"
          },
          {
            "xueweiCode": "jianjing",
            "xueweiName": "肩井"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "肩周炎1-肩髃",
            "description": "用食指和中指指腹点按肩髃30次，力度适中。"
          },
          {
            "imgUrlName": "肩周炎2-肩贞",
            "description": "用食指和中指指腹点按肩贞30次，力度适中。"
          },
          {
            "imgUrlName": "肩周炎3-肩髎",
            "description": "食指和中指并拢，用二指指腹点按肩髎30次。"
          },
          {
            "imgUrlName": "肩周炎4-肩井",
            "description": "用中指指腹揉按肩井3分钟。"
          }
        ],
        "classicalSymptom": "肩部疼痛、活动受限、患侧怕冷。"
      },
      {
        "name": "腰肌劳损",
        "diseaseCode": "yaojilaosun",
        "massageXueWeiList": [
          {
            "xueweiCode": "yaotongdian",
            "xueweiName": "腰痛点"
          },
          {
            "xueweiCode": "yanglingquan",
            "xueweiName": "阳陵泉"
          },
          {
            "xueweiCode": "yaoyan",
            "xueweiName": "腰眼"
          },
          {
            "xueweiCode": "shenyu",
            "xueweiName": "肾俞"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "腰肌劳损1-腰痛点",
            "description": "用拇指指端按揉手背第4、第5掌骨间的腰痛点，左右各30次。"
          },
          {
            "imgUrlName": "腰肌劳损2-阳陵泉",
            "description": "用拇指指端点按阳陵泉，双侧各按摩20次。"
          },
          {
            "imgUrlName": "腰肌劳损3-腰眼",
            "description": "用双手拇指点压腰眼1分钟。"
          },
          {
            "imgUrlName": "腰肌劳损4-肾俞",
            "description": "双手五指并拢，掌根自上而下反复斜擦两侧肾俞30-50次。"
          }
        ],
        "classicalSymptom": "腰部疼痛、时轻时重、缠绵不愈。"
      },
      {
        "name": "小腿抽筋",
        "diseaseCode": "xiaotuichoujin",
        "massageXueWeiList": [
          {
            "xueweiCode": "chengshan",
            "xueweiName": "承山"
          },
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          },
          {
            "xueweiCode": "yanglingquan",
            "xueweiName": "阳陵泉"
          },
          {
            "xueweiCode": "taixi",
            "xueweiName": "太溪"
          },
          {
            "xueweiCode": "kunlun",
            "xueweiName": "昆仑"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "小腿抽筋1-承山",
            "description": "用拇指点揉承山约2分钟，以有酸胀感为宜。"
          },
          {
            "imgUrlName": "小腿抽筋2-足三里",
            "description": "用拇指点按足三里30次，力度稍重，两侧可同时进行。"
          },
          {
            "imgUrlName": "小腿抽筋3-阳陵泉",
            "description": "用拇指顺时针方向按揉阳陵泉1分钟，力度适中。"
          },
          {
            "imgUrlName": "小腿抽筋4-太溪昆仑",
            "description": "以拇指与食中指相对用力拿捏腓肠肌至跟腱太溪、昆仑处，重复3-5遍。"
          }
        ],
        "classicalSymptom": "肌肉强直、痉挛僵硬、疼痛骤作。"
      },
      {
        "name": "足跟痛",
        "diseaseCode": "zugentong",
        "massageXueWeiList": [
          {
            "xueweiCode": "dazhong",
            "xueweiName": "大钟"
          },
          {
            "xueweiCode": "kunlun",
            "xueweiName": "昆仑"
          },
          {
            "xueweiCode": "taixi",
            "xueweiName": "太溪"
          },
          {
            "xueweiCode": "pucan",
            "xueweiName": "仆参"
          },
          {
            "xueweiCode": "yongquan",
            "xueweiName": "涌泉"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "足跟痛1-大钟",
            "description": "用拇指点按大钟50次，力度适中。"
          },
          {
            "imgUrlName": "足跟痛2-昆仑太溪",
            "description": "以拇指与食中指相对用力，同时拿捏昆仑、太溪1-2分钟。"
          },
          {
            "imgUrlName": "足跟痛3-仆参",
            "description": "用拇指指端点按仆参1-2分钟。"
          },
          {
            "imgUrlName": "足跟痛4-涌泉",
            "description": "用拇指指腹从涌泉向足趾方向推行6-8次。"
          }
        ],
        "classicalSymptom": "足跟疼痛、不红不肿、行走不便。"
      },
      {
        "name": "类风湿性关节炎",
        "diseaseCode": "leifengshixingguanjieyan",
        "massageXueWeiList": [
          {
            "xueweiCode": "fengchi",
            "xueweiName": "风池"
          },
          {
            "xueweiCode": "yangchi",
            "xueweiName": "阳池"
          },
          {
            "xueweiCode": "yinlingquan",
            "xueweiName": "阴陵泉"
          },
          {
            "xueweiCode": "kunlun",
            "xueweiName": "昆仑"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "类风湿性关节炎1-风池",
            "description": "用两手拇指同时按压两侧风池1-3分钟。"
          },
          {
            "imgUrlName": "类风湿性关节炎2-阳池",
            "description": "用中指指腹按揉阳池1分钟，力度适中。"
          },
          {
            "imgUrlName": "类风湿性关节炎3-阴陵泉",
            "description": "用拇指点按阴陵泉1分钟，力度适中。"
          },
          {
            "imgUrlName": "类风湿性关节炎4-昆仑",
            "description": "用拇指指尖按压昆仑3分钟。"
          }
        ],
        "classicalSymptom": "关节疼痛、僵硬肿大、手足麻木。"
      },
      {
        "name": "阳痿",
        "diseaseCode": "yangwei",
        "massageXueWeiList": [
          {
            "xueweiCode": "guanyuan",
            "xueweiName": "关元"
          },
          {
            "xueweiCode": "shenyu",
            "xueweiName": "肾俞"
          },
          {
            "xueweiCode": "huiyin",
            "xueweiName": "会阴"
          },
          {
            "xueweiCode": "taichong",
            "xueweiName": "太冲"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "阳痿1-关元",
            "description": "用中间三指指腹按揉关元150次，动作轻柔。"
          },
          {
            "imgUrlName": "阳痿2-肾俞",
            "description": "用双手拇指指端按压两侧肾俞100次。"
          },
          {
            "imgUrlName": "阳痿3-会阴",
            "description": "用拇指指端重力按压会阴10次。"
          },
          {
            "imgUrlName": "阳痿4-太冲",
            "description": "用拇指指端重力按压太冲30次。"
          }
        ],
        "classicalSymptom": "不能勃起、焦虑急躁、身心疲劳。"
      },
      {
        "name": "早泄",
        "diseaseCode": "zaoxie",
        "massageXueWeiList": [
          {
            "xueweiCode": "shenyu",
            "xueweiName": "肾俞"
          },
          {
            "xueweiCode": "guanyuan",
            "xueweiName": "关元"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          },
          {
            "xueweiCode": "taixi",
            "xueweiName": "太溪"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "早泄1-肾俞",
            "description": "用双手拇指指端按压两侧肾俞50次。"
          },
          {
            "imgUrlName": "早泄2-关元",
            "description": "用拇指点按关元30次，力度适中。"
          },
          {
            "imgUrlName": "早泄3-三阴交",
            "description": "用指指腹按揉两侧三阴交50次。"
          },
          {
            "imgUrlName": "早泄4-太溪",
            "description": "用拇指指腹刮按太溪3分钟。"
          }
        ],
        "classicalSymptom": "五心烦热、腰膝酸软、阴茎易勃。"
      },
      {
        "name": "前列腺疾病",
        "diseaseCode": "qianliexianjibing",
        "massageXueWeiList": [
          {
            "xueweiCode": "zhongji",
            "xueweiName": "中极"
          },
          {
            "xueweiCode": "bangguangyu",
            "xueweiName": "膀胱俞"
          },
          {
            "xueweiCode": "yinlingquan",
            "xueweiName": "阴陵泉"
          },
          {
            "xueweiCode": "tianjing",
            "xueweiName": "天井"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "前列腺疾病1-中极",
            "description": "用双手中指同时按压中极1分钟。"
          },
          {
            "imgUrlName": "前列腺疾病2-膀胱俞",
            "description": "用拇指指腹按揉膀胱俞1-2分钟。"
          },
          {
            "imgUrlName": "前列腺疾病3-阴陵泉",
            "description": "用拇指指腹按揉阴陵泉1分钟。"
          },
          {
            "imgUrlName": "前列腺疾病4-天井",
            "description": "以中指指端勾点天井30-50次。"
          }
        ],
        "classicalSymptom": "排尿不适、性欲减退、头晕乏力。"
      },
      {
        "name": "遗精",
        "diseaseCode": "yijing",
        "massageXueWeiList": [
          {
            "xueweiCode": "guanyuan",
            "xueweiName": "关元"
          },
          {
            "xueweiCode": "shenyu",
            "xueweiName": "肾俞"
          },
          {
            "xueweiCode": "taixi",
            "xueweiName": "太溪"
          },
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "遗精1-关元",
            "description": "用中间三指指腹摩揉关元3-5分钟。"
          },
          {
            "imgUrlName": "遗精2-肾俞",
            "description": "用双手拇指指端按压肾俞20次。"
          },
          {
            "imgUrlName": "遗精3-太溪",
            "description": "用拇指按揉太溪2分钟，力度适中。"
          },
          {
            "imgUrlName": "遗精4-足三里",
            "description": "用拇指按揉足三里20次，力度稍大。"
          }
        ],
        "classicalSymptom": "精液外泄、精神委靡、头晕耳鸣。"
      },
      {
        "name": "乳腺增生",
        "diseaseCode": "ruxianzengsheng",
        "massageXueWeiList": [
          {
            "xueweiCode": "jianjing",
            "xueweiName": "肩井"
          },
          {
            "xueweiCode": "shaofu",
            "xueweiName": "少府"
          },
          {
            "xueweiCode": "taichong",
            "xueweiName": "太冲"
          },
          {
            "xueweiCode": "dabao",
            "xueweiName": "大包"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "乳腺增生1-肩井",
            "description": "用拇指和其余四指拿捏肩井处肌肉30次。"
          },
          {
            "imgUrlName": "乳腺增生2-少府",
            "description": "用拇指指腹按揉少府3-5分钟。"
          },
          {
            "imgUrlName": "乳腺增生3-太冲",
            "description": "用食指指端按揉太冲30次，用力略重。"
          },
          {
            "imgUrlName": "乳腺增生4-大包",
            "description": "用中指指端勾点大包50-100次，用力稍重。"
          }
        ],
        "classicalSymptom": "乳房肿胀、乳腺肿块、伴有疼痛。"
      },
      {
        "name": "月经不调",
        "diseaseCode": "yuejingbudiao",
        "massageXueWeiList": [
          {
            "xueweiCode": "shenyu",
            "xueweiName": "肾俞"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          },
          {
            "xueweiCode": "xuehai",
            "xueweiName": "血海"
          },
          {
            "xueweiCode": "diji",
            "xueweiName": "地机"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "月经不调1-肾俞",
            "description": "用两手叉腰，拇指按揉两侧肾俞1分钟。"
          },
          {
            "imgUrlName": "月经不调2-三阴交",
            "description": "用拇指指腹点按三阴交1分钟。"
          },
          {
            "imgUrlName": "月经不调3-血海",
            "description": "用拇指指端点按血海1分钟，力度要均衡。"
          },
          {
            "imgUrlName": "月经不调4-地机",
            "description": "用拇指指腹按揉地机1分钟，力度适中。"
          }
        ],
        "classicalSymptom": "周期异常、出血量少、痛经、抑郁。"
      },
      {
        "name": "痛经",
        "diseaseCode": "tongjing",
        "massageXueWeiList": [
          {
            "xueweiCode": "qihai",
            "xueweiName": "气海"
          },
          {
            "xueweiCode": "shenyu",
            "xueweiName": "肾俞"
          },
          {
            "xueweiCode": "xuehai",
            "xueweiName": "血海"
          },
          {
            "xueweiCode": "ligou",
            "xueweiName": "蠡沟"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "痛经1-气海",
            "description": "中间三指并拢，用手掌顺时针方向在气海按摩30圈。"
          },
          {
            "imgUrlName": "痛经2-肾俞",
            "description": "双手叉腰，用拇指点压两侧肾俞1分钟。"
          },
          {
            "imgUrlName": "痛经3-血海",
            "description": "用拇指指腹按压血海2分钟，力度适度。"
          },
          {
            "imgUrlName": "痛经4-蠡沟",
            "description": "以拇指指端用力点按蠡沟20次。"
          }
        ],
        "classicalSymptom": "腰腹疼痛、痛及腰骶、手足厥冷。"
      },
      {
        "name": "闭经",
        "diseaseCode": "bijing",
        "massageXueWeiList": [
          {
            "xueweiCode": "shenyu",
            "xueweiName": "肾俞"
          },
          {
            "xueweiCode": "xuehai",
            "xueweiName": "血海"
          },
          {
            "xueweiCode": "sanyinjiao",
            "xueweiName": "三阴交"
          },
          {
            "xueweiCode": "zusanli",
            "xueweiName": "足三里"
          }
        ],
        "massageInfo": [
          {
            "imgUrlName": "闭经1-肾俞",
            "description": "双手叉腰，用拇指点压肾俞20次。"
          },
          {
            "imgUrlName": "闭经2-血海",
            "description": "用拇指指腹用力均衡地按压血海20次。"
          },
          {
            "imgUrlName": "闭经3-三阴交",
            "description": "用拇指指腹按压三阴交20次。"
          },
          {
            "imgUrlName": "闭经4-足三里",
            "description": "用拇指指腹按揉足三里50次。"
          }
        ],
        "classicalSymptom": "经少色淡、初潮较迟、面色无华。"
      }
    ];

    // keshilist.forEach(keshi => {
    //   keshi.disease.forEach(singleDisease => {
    //     jibinglist.find(jibing1 => {
    //       if (jibing1.name === singleDisease.name) {
    //         Object.assign(singleDisease, jibing1);
    //       }
    //     })
    //   })
    // })

    // console.log(JSON.stringify(keshilist));

    // eslint-disable-next-line no-unused-vars
    let jingmaiList = [
      {
        "detailTitle": "中府：胸闷咳嗽中府收",
        "detailDescription": "中，指中焦；府，处所。肺经起于中焦，是中焦脾胃之气聚汇肺经之处。",
        "cure": "宣肺止咳。主治肺炎、哮喘、胸痛、肺结核、支气管扩张。",
        "position": "在胸部，横平第1肋间隙，锁骨下窝外侧，前正中线旁开6寸。",
        "quickFind": "正立，双手叉腰，锁骨外侧端下方有一凹陷，该处再向下1横指即是。",
        "massage": "咳嗽不止时，点按中府和肺俞各200次，有即时止咳的功效。每天坚持按摩，可强化淋巴循环，减轻胸闷、肩背痛。",
        "xueweiName": "中府"
      },
      {
        "detailTitle": "云门：胸痛肩痛全拿下",
        "detailDescription": "云，云雾，指肺气；门，门户。穴在胸上部，如肺气出入的门户。",
        "cure": "理气止痛。主治咳嗽、气喘、胸痛、肩痛、肩关节内侧痛等。",
        "position": "在胸部，锁骨下窝凹陷中，肩胛骨喙突内缘，前正中线旁开6寸。",
        "quickFind": "正立，双手叉腰，锁骨外侧端下方的三角形凹陷处即是。",
        "massage": "每天早晚用中指指腹点揉云门1~3分钟，坚持按摩，可远离咳嗽痰多等症状。云门还可辅助降压，高血压患者可常按揉。",
        "xueweiName": "云门"
      },
      {
        "detailTitle": "天府：鼻炎鼻塞都不见",
        "detailDescription": "天，天空，指上而言；府，处所。本穴是肺气聚集之处。",
        "cure": "止咳化痰。主治咳嗽、气喘、鼻塞、上臂内侧疼痛等。",
        "position": "在臂前部，腋前纹头下3寸，肱二头肌桡侧缘处。",
        "quickFind": "臂向前平举，俯头，鼻尖接触上臂内侧处即是。",
        "massage": "常用中指指腹揉按天府，每次左右各按1~3分钟，对鼻部有保健作用，可预防鼻塞、鼻炎等。",
        "xueweiName": "天府"
      },
      {
        "detailTitle": "侠白：缓解肋间神经痛",
        "detailDescription": "侠，通“夹”；白，白色属肺。两臂下垂，本穴夹于肺之两旁。",
        "cure": "宽胸和胃，宣肺理气。主治咳嗽、气喘、干呕、肋间神经痛。",
        "position": "在臂前部，腋前纹头下4寸，肱二头肌桡侧缘处。",
        "quickFind": "先找到天府，向下1横指处即是。",
        "massage": "常用中指指腹揉按侠白，每次左右各按1~3分钟，对肺有保健作用。精神极度衰弱时揉侠白3~5分钟，可很快安心宁神。",
        "xueweiName": "侠白"
      },
      {
        "detailTitle": "尺泽：清肺泻热止疼痛",
        "detailDescription": "尺，指尺部（腕至肘之前臂）；泽，沼泽。穴在尺部肘窝陷中，脉气流注入此，如水注沼泽。",
        "cure": "清泻肺热，通络止痛。主治气管炎、咳嗽、咳血、咽喉肿痛、过敏、湿疹、肘臂痉挛疼痛、膝关节疼痛。",
        "position": "在肘部，肘横纹上，肱二头肌腱桡侧缘凹陷中。",
        "quickFind": "屈肘时，触及肌腱，其外侧缘即是。",
        "massage": "弯曲拇指，以指腹按压，每次左右手各按压1~3分钟。坚持按摩可补益肺肾，调节身体虚实。",
        "xueweiName": "尺泽"
      },
      {
        "detailTitle": "孔最：咳血特效此穴神",
        "detailDescription": "孔，孔隙；最，副词。意指本穴孔隙最深。",
        "cure": "清热止血，润肺理气。主治气管炎、咳嗽、咳血、咽喉肿痛、肘臂痛、痔疮。",
        "position": "在前臂内侧面，腕掌侧远端横纹上7寸，尺泽与太渊连线上。",
        "quickFind": "手臂向前，仰掌向上，另手握住手臂中段处，拇指指甲垂直下压即是。",
        "massage": "用拇指指腹按压孔最1~3分钟，可防止咳血。",
        "xueweiName": "孔最"
      },
      {
        "detailTitle": "列缺：偏正头痛都不怕",
        "detailDescription": "列，指陈列、裂开；缺，指缺口、空隙。古称闪电为列缺。穴在腕上之裂隙与衣袖之边缘处，所经之气常如闪电也。",
        "cure": "止咳平喘，通络止痛，利水通淋。主治咳嗽气喘，偏、正头痛，咽喉痛，落枕。",
        "position": "腕掌侧远端横纹上1.5寸，拇短伸肌腱与拇长展肌腱之间。",
        "quickFind": "两手虎口相交，一手食指压另一手桡骨茎突上，食指指尖到达处即是。",
        "massage": "每天用食指指腹揉按列缺，每次1~3分钟，可治疗腱鞘炎、头痛等病症。",
        "xueweiName": "列缺"
      },
      {
        "detailTitle": "经渠：赶走咳嗽的困扰",
        "detailDescription": "经，经过；渠，沟渠。经脉通过的渠道。",
        "cure": "宣肺平喘。主治咳嗽、气喘、咽喉肿痛、牙痛、无脉症。",
        "position": "在前臂内侧面，腕掌侧远端横纹上1寸，桡骨茎突与桡动脉之间。",
        "quickFind": "伸手，掌心向上，用一手给另一手把脉，中指所在位置即是。",
        "massage": "经常按揉经渠穴，可防治老年慢性支气管炎。",
        "xueweiName": "经渠"
      },
      {
        "detailTitle": "太渊：气血通畅心肺好",
        "detailDescription": "太，高大与尊贵之意；渊，深水、深潭。太渊，口中津液名，意思是经气深如潭水。",
        "cure": "通调血脉，止咳化痰。主治脉管炎、肺炎、心动过速、神经性皮炎。",
        "position": "在腕部，桡骨茎突与舟状骨之间，拇长展肌腱尺侧凹陷中。",
        "quickFind": "掌心向上，腕横纹外侧摸到桡动脉，其外侧即是。",
        "massage": "用拇指指腹用力点揉太渊3分钟，直至穴位处有酸胀感，能很快缓解咳喘。用拇指及指甲尖掐按太渊，每次1~3分钟，可预防心肺疾病。",
        "xueweiName": "太渊"
      },
      {
        "detailTitle": "鱼际：痰热咳嗽莫担心",
        "detailDescription": "鱼，指拇掌肌肉的形状；际，边际。手掌拇指侧肌肉肥厚，其形似鱼，穴位位于它的边际。",
        "cure": "清热利咽。咳嗽、哮喘、咳血、发热、咽喉肿痛、失音、腹泻、拇指根部疼痛、心悸。",
        "position": "在手外侧，第1掌骨桡侧中点赤白肉际处。",
        "quickFind": "一手轻握另手手背，弯曲拇指，指尖垂直下按第1掌骨中点肉际处即是。",
        "massage": "每天早晚各按揉鱼际200次。按摩时用拇指指腹在鱼际处用力向下按压，并配合左右按揉，以有酸胀感为宜，可治痰热咳嗽。",
        "xueweiName": "鱼际"
      },
      {
        "detailTitle": "少商：感冒咽痛不再烦",
        "detailDescription": "少，幼小、微小之意；商，古代五音之一，属金，属肺。少商，是商的高音，意为金气所止或为金气初生之处也。",
        "cure": "泻热开窍，通利咽喉。咳嗽、咽喉肿痛、慢性咽炎、扁桃体炎、中风昏迷、小儿惊风、热病、中暑、感冒。",
        "position": "在手指，拇指末节桡侧，指甲根角侧上方0.1寸。",
        "quickFind": "一手拇指伸直，另手拇、食指轻握，拇指弯曲掐按伸直的拇指指甲角边缘处即是。",
        "massage": "用指甲使劲掐一掐少商，可以减轻咽喉肿痛的症状。打嗝时，用拇指按压少商，以感觉酸痛为度，持续半分钟，即可止嗝。",
        "xueweiName": "少商"
      },
      {
        "detailTitle": "商阳：调节肠胃无烦恼",
        "detailDescription": "商，古代五音之一，属金；阳，阴阳之阳。大肠属金，在音为商；阳，指阳经，商阳为手阳明大肠经首穴。",
        "cure": "清热解表，苏厥开窍。主治咽喉肿痛、昏厥、呕吐、扁桃体炎、便秘。",
        "position": "在食指末节桡侧，指甲根角侧上方0.1寸。",
        "quickFind": "食指末节指甲根角，靠拇指侧的位置。",
        "massage": "用双手刺激商阳，可调节肠胃功能，缓解急性胃肠炎症状。",
        "xueweiName": "商阳"
      },
      {
        "detailTitle": "二间：治鼻出血有奇效",
        "detailDescription": "二，第二；间，间隙，指穴。此为大肠经第二穴。",
        "cure": "清热泻火，解表利咽。主治牙痛、咽喉肿痛、鼻出血、目痛、腹胀。",
        "position": "在手指，第2掌指关节桡侧远端赤白肉际处。",
        "quickFind": "自然弯曲食指，第2掌指关节前缘，靠拇指侧，触之有凹陷处即是。",
        "massage": "在手上二间处刮痧，一般痧一出，可止鼻出血。",
        "xueweiName": "二间"
      },
      {
        "detailTitle": "三间：肠炎肠鸣一按消",
        "detailDescription": "三，第三；间，间隙，指穴。此为大肠经第三穴。",
        "cure": "泻热止痛，利咽。主治牙痛、咽喉肿痛、身热胸闷、痔疮、哮喘。",
        "position": "在手背，第2掌指关节桡侧近端凹陷中。",
        "quickFind": "微握拳，食指第2掌指关节后缘，触之有凹陷处即是。",
        "massage": "常用拇指指腹揉按此穴，每次1~3分钟，可调和胃肠，改善肠炎肠鸣症状。",
        "xueweiName": "三间"
      },
      {
        "detailTitle": "合谷：头面疼痛一扫光",
        "detailDescription": "合，结合；谷，山谷。穴在第1、第2掌骨之间，局部呈山谷样凹陷。",
        "cure": "镇静止痛，疏经通络，清热解表。主治外感发热、头痛目眩、鼻塞、牙痛、便秘、月经不调、荨麻疹、昏迷、中风、三叉神经痛、过敏性鼻炎、咽喉肿痛、口腔溃疡、黄褐斑、高血压、高脂血症。",
        "position": "在手背，第1、第2掌骨之间，约平第2掌骨中点处。",
        "quickFind": "轻握拳，拇、食指指尖轻触，另手握拳外，拇指指腹垂直下压即是。",
        "massage": "用拇指掐捏合谷，持续2~3分钟，可缓解头痛、牙痛、咽喉肿痛。",
        "xueweiName": "合谷"
      },
      {
        "detailTitle": "阳溪：头痛手痛皆可治",
        "detailDescription": "阳，指阳经；溪，山洼流水之沟。指本穴在手背之阳的两筋凹陷明显处。",
        "cure": "清热散风，通利关节。主治头痛、耳鸣、耳聋、牙痛、目赤肿痛。",
        "position": "在腕部，腕背侧远端横纹桡侧，桡骨茎突远端，解剖学“鼻烟窝”凹陷中。",
        "quickFind": "手掌侧放，拇指伸直向上翘起，腕背桡侧有一凹陷处即是。",
        "massage": "以拇指指腹按压半分钟以上，可迅速缓解头痛。经常用拇指尖垂直掐按此穴，每次1~3分钟，可以有效防治中风和手腕肿痛等症。",
        "xueweiName": "阳溪"
      },
      {
        "detailTitle": "偏历：专治耳鸣与耳聋",
        "detailDescription": "偏，偏离；历，行经。大肠经从这里分出络脉，偏行肺经。",
        "cure": "清热利尿，通经活络。主治耳聋、耳鸣、鼻出血、目赤、牙痛、肠鸣、腹痛。",
        "position": "在前臂，腕背侧远端横纹上3寸，阳溪与曲池连线上。",
        "quickFind": "两手虎口垂直交叉，中指端落于前臂背面处有一凹陷即是。",
        "massage": "经常用拇指指腹揉按偏历数次，每次1~3分钟，可预防耳鸣耳聋。",
        "xueweiName": "偏历"
      },
      {
        "detailTitle": "温溜：肩背酸痛按摩消",
        "detailDescription": "温，温暖；溜，流通。本穴有温通经脉之功，善治肩背酸痛。",
        "cure": "清热理气。主治寒热头痛、面赤面肿、口舌痛、肩背疼痛。",
        "position": "在前臂，腕横纹上5寸，阳溪与曲池连线上。",
        "quickFind": "先确定阳溪和曲池的位置，两穴连线的中点处即是。",
        "massage": "肩背酸痛时，用拇指按揉温溜，可缓解酸痛。",
        "xueweiName": "温溜"
      },
      {
        "detailTitle": "下廉：肘臂健康守护神",
        "detailDescription": "下，下方；廉，边缘。穴在前臂背面近桡侧缘，上廉之下。",
        "cure": "调理肠胃，通经活络。主治眩晕、腹痛、上肢不遂、手肘肩无力。",
        "position": "在前臂，肘横纹下4寸，阳溪与曲池连线上。",
        "quickFind": "侧腕屈肘，以手掌按另一手臂，拇指位于肘弯处，小指所在位置即是。",
        "massage": "将食指与中指并拢，以指腹垂直按压下廉，左右臂各1~3分钟，可减轻肘臂疼痛。",
        "xueweiName": "下廉"
      },
      {
        "detailTitle": "上廉：可清肠毒治便秘",
        "detailDescription": "上，上方；廉，边缘。穴在前臂背面近桡侧缘，下廉穴之上。",
        "cure": "调理肠胃，通经活络。主治腹痛、腹胀、肠鸣、上肢肿痛、上肢不遂。",
        "position": "在前臂，肘横纹下3寸，阳溪与曲池连线上。",
        "quickFind": "先找到阳溪、曲池，两者连线中点向上量取4横指处即是。",
        "massage": "常配合按摩上廉、下廉，每次1~3分钟，可清肠毒、治便秘。",
        "xueweiName": "上廉"
      },
      {
        "detailTitle": "手三里：腰背疼痛快速消",
        "detailDescription": "手，上肢；三，数词；里，古代有以里为寸之说。穴在上肢，因距手臂肘端三寸，故名手三里。",
        "cure": "调理肠胃，清热明目。主治腹痛、腹泻、肩周炎、上肢不遂、牙痛。",
        "position": "在前臂，肘横纹下2寸，阳溪与曲池连线上。",
        "quickFind": "先找到阳溪、曲池，两者连线上曲池下3横指即是。",
        "massage": "常用拇指揉手三里，每次1~3分钟；也可用艾灸法，每次灸5~10分钟，可治疗腰背痛。",
        "xueweiName": "手三里"
      },
      {
        "detailTitle": "曲池：感冒发热不用愁",
        "detailDescription": "曲，弯曲；池，水的围合之处、汇合之所。穴在肘臂屈曲时肘横纹端凹陷处，经气至此，有如水之入池。",
        "cure": "清热和营，祛风通络。主治感冒、外感发热、咳嗽、气喘、腹痛、脂肪肝、手臂肿痛、瘗疮、皮肤瘙痒、湿疹、白瘢风、半身不遂。",
        "position": "在肘部，尺泽与肱骨外上髁连线的中点处。",
        "quickFind": "屈肘成直角，先找到肘横纹终点，再找到肱骨外上髁，两者连线中点处。",
        "massage": "发热感冒及咳嗽、哮喘时，可用刮疔板刮曲池；或按揉3〜5分钟，可迅速解表、退热。",
        "xueweiName": "曲池"
      },
      {
        "detailTitle": "肘髎：肘部疾病的克星",
        "detailDescription": "肘，肘部；髎，骨隙。穴在肘部，靠近骨隙处。",
        "cure": "舒筋活络。主治肩臂肘疼痛、上肢麻木、拘挛。",
        "position": "在肘部，肱骨外上髁上缘，髁上嵴的前缘。",
        "quickFind": "先找到曲池，向上量取1横指处即是。",
        "massage": "每天早晚用拇指指腹按揉肘髎，每次1~3分钟，长期坚持，可预防网球肘。",
        "xueweiName": "肘髎"
      },
      {
        "detailTitle": "手五里：上肢不遂有奇效",
        "detailDescription": "手，上肢；五，数词；里，古代有以里为寸之说。穴在上肢，当天府下5寸，手三里上5寸处。",
        "cure": "理气散结，疏经活络。主治肩周炎、手臂肿痛、上肢不遂、疟疾。",
        "position": "在臂部，肘横纹上3寸，曲池与肩髃连线上。",
        "quickFind": "手臂外侧曲池上4横指处。",
        "massage": "手五里位于骨头上，通经活络的效果非常强，尤其能治上肢麻木疼痛等疾病，按摩时可用食指按压，每次3~5分钟。",
        "xueweiName": "手五里"
      },
      {
        "detailTitle": "臂臑：眼睛专属保健师",
        "detailDescription": "臂，通指上肢；上臂肌肉隆起处。穴在上肢肌肉隆起处。",
        "cure": "清热明目，通络止痛。主治眼部疾病、手臂肿痛、上肢不遂、肩周炎。",
        "position": "在臂部，曲池上7寸，三角肌下端。",
        "quickFind": "屈肘紧握拳，使三角肌隆起，三角肌下端偏内侧，按压有酸胀感处即是。",
        "massage": "将艾灸条对准臂隔，距皮肤2~3厘米，每次灸5~10分钟，对白内障、视神经萎缩有辅助疗效；按揉臂臑3~5分钟，可缓解颈、肩部酸痛。",
        "xueweiName": "臂臑"
      },
      {
        "detailTitle": "肩髃：缓解肩臂疼与痛",
        "detailDescription": "肩，肩部；髃，隅角。穴在肩角部。",
        "cure": "疏经活络，疏散风热。主治肩臂疼痛、肩周炎、肩痛、上肢不遂。",
        "position": "在肩峰前下方，当肩峰与肱骨大结节之间凹陷处。",
        "quickFind": "正坐，屈肘抬臂与肩同高，另一手中指按压肩尖下，肩前呈现凹陷处即是。",
        "massage": "中指和食指并拢，以指腹垂直按压穴位，两肩按摩方法相同，每日早晚按摩，左右各按揉1〜3分钟。可治肩臂疼痛、手臂挛急等疾病。",
        "xueweiName": "肩髃"
      },
      {
        "detailTitle": "巨骨：缓解预防肩周炎",
        "detailDescription": "巨，大；骨，骨骼。古称锁骨为巨骨。穴近锁骨肩峰端。",
        "cure": "通络止痛，滑利关节。主治肩背及上臂疼痛、手臂挛急、半身不遂。",
        "position": "在肩部，锁骨肩峰端与肩胛冈之间凹陷中。",
        "quickFind": "沿着锁骨向外摸至肩峰端，再找背部肩胛冈，两者之间凹陷处即是。",
        "massage": "肩臂拘挛时可用对侧手的中指指腹按揉患侧巨骨，直至患侧感到热或局部有酸麻感，可缓解症状；常按揉巨骨，可助肩周炎患者上肢上举活动改善。",
        "xueweiName": "巨骨"
      },
      {
        "detailTitle": "天鼎：扁桃体炎按之消",
        "detailDescription": "天，天空，指上面而言；鼎，古器物名。头形似鼎，穴在耳下颈部。",
        "cure": "利喉清咽，理气散结。主治咳嗽、气喘、咽喉肿痛、扁桃体炎、梅核气、瘿瘤（甲状腺肿瘤）。",
        "position": "在颈部，横平环状软骨，胸锁乳突肌后缘，扶突直下1寸处。",
        "quickFind": "先找到扶突，再找到锁骨上窝中央，两者连线中点处即是。",
        "massage": "用力按压天鼎50次，可缓解扁桃体红肿所造成的疼痛及喉咙阻塞等症状。",
        "xueweiName": "天鼎"
      },
      {
        "detailTitle": "扶突：咳嗽气喘效果好",
        "detailDescription": "",
        "cure": "利咽消肿，理气降逆。主治咳嗽、气喘、咽喉肿痛、打嗝。",
        "position": "在胸锁乳突肌区，横平喉结，当胸锁乳突肌的前、后缘中间。",
        "quickFind": "拇指弯曲，其余四指并拢，手心向内，小指放喉结旁，食指所在处即是。",
        "massage": "食指和中指并拢，以指腹按压扶突，每次左右各按压3分钟，可缓解咳嗽气喘。",
        "xueweiName": "扶突"
      },
      {
        "detailTitle": "口禾髎：抛掉鼻炎的烦恼",
        "detailDescription": "口，口部；禾，谷物；髎，间隙。谷物从口入胃，穴在口旁骨隙中。",
        "cure": "祛风清热，牵正通窍。主治鼻塞流涕、鼻出血、口眼歪斜。",
        "position": "在面部，横平人中沟上1/3与下2/3交点，鼻孔外缘直下。",
        "quickFind": "鼻孔外缘直下，平鼻唇沟上1/3水沟处即是。",
        "massage": "用食指指腹按压口禾髎，每次5~10分钟，以有酸痛感为宜，可治过敏性鼻炎、鼻前庭炎和慢性鼻炎等。",
        "xueweiName": "口禾髎"
      },
      {
        "detailTitle": "迎香：鼻部疾病第一穴",
        "detailDescription": "迎，迎接；香，香气。本穴在鼻旁，能治鼻病，改善嗅觉，进而迎来香气。",
        "cure": "祛风通窍，理气止痛。主治鼻塞、过敏性鼻炎、鼻出血、面神经麻痹、黄褐斑、酒糟鼻。",
        "position": "在面部，鼻翼外缘中点，鼻唇沟中。",
        "quickFind": "双手轻握拳，食指和中指并拢，中指指尖贴鼻翼两侧，食指指尖处即是。",
        "massage": "遇到伤风引起的流鼻涕、鼻塞，或者过敏性鼻炎，按摩迎香至发热，立刻见效。",
        "xueweiName": "迎香"
      },
      {
        "detailTitle": "承泣：预防消退黑眼圈",
        "detailDescription": "承，承受；泣，泪水。穴在目下，犹如承受泪水的部位。",
        "cure": "散风清热，明目止泪。主治目赤肿痛、视力模糊、白内障、口眼歪斜。",
        "position": "在面部，眼球与眶下缘之间，瞳孔直下。",
        "quickFind": "食指和中指伸直并拢，中指贴于鼻侧，食指指尖位于下眼眶边缘处即是。",
        "massage": "用食指指腹揉承泣1~3分钟，可以促进眼部血液循环，预防黑眼圈。",
        "xueweiName": "承泣"
      },
      {
        "detailTitle": "四白：眼保健操的主穴",
        "detailDescription": "四，四方；白，光明。穴在目下，能治眼病，改善视觉，明见四方。",
        "cure": "祛风明目，通经活络。主治近视、目赤痛痒、迎风流泪、白内障、面瘫。",
        "position": "在面部，双眼平视时，瞳孔直下，当眶下孔凹陷处。",
        "quickFind": "食指和中指伸直并拢，中指指腹贴两侧鼻翼，食指指尖所按凹陷处即是。",
        "massage": "双手食指伸直，以食指指腹揉按左右四白，有酸痛感，每次1~3分钟，可以缓解眼疲劳、眼干涩等。",
        "xueweiName": "四白"
      },
      {
        "detailTitle": "巨髎：主治面神经麻痹",
        "detailDescription": "巨，大也；髎，孔隙。指穴在上颌骨与颧骨交接之巨大孔隙中，泛指面部髎孔之巨大者。",
        "cure": "清热熄风，明目退翳。主治口眼歪斜、鼻出血、牙痛、面痛、面神经麻痹。",
        "position": "在面部，瞳孔直下，横平鼻翼下缘，颤弓下缘凹陷处。",
        "quickFind": "直视前方，沿瞳孔直下垂直线向下，与鼻翼下缘水平线交点凹陷处即是。",
        "massage": "以两手拇指指腹点按巨髎3~5分钟，可纠正口眼歪斜。",
        "xueweiName": "巨髎"
      },
      {
        "detailTitle": "地仓：面部松弛有奇效",
        "detailDescription": "地，指土地所产之谷物；仓，仓廩、仓库。意为口腔犹如谷物仓库的组成部分。",
        "cure": "祛风止痛，舒筋活络。主治口角歪斜、牙痛、流涎、眼睑跳动不止。",
        "position": "在面部，当口角旁开0.4寸（指寸）。",
        "quickFind": "轻闭口，举两手，用食指指甲垂直下压唇角外侧两旁即是。",
        "massage": "每天按揉地仓2次，每次1~3分钟，可刺激口轮匝肌，有改善面部松弛、提拉嘴角的功效。常按揉地仓，可防治流涎。",
        "xueweiName": "地仓"
      },
      {
        "detailTitle": "大迎：三叉神经疼痛消",
        "detailDescription": "大，大小之大；迎，迎接。穴在大迎脉（面动脉）旁。",
        "cure": "祛风通络，消肿止痛。主治口角歪斜、失音、颊肿、牙痛。",
        "position": "在面部，下颌角前方，咬肌附着部前缘凹陷中，面动脉搏动处。",
        "quickFind": "正坐，闭口鼓气，下颌角前下方有一凹陷，下端按之有搏动感处即是。",
        "massage": "用食指指腹按揉大迎，每次1~3分钟，可以促进面部血液循环，预防和调理三叉神经痛等面部疾病。",
        "xueweiName": "大迎"
      },
      {
        "detailTitle": "颊车：面颊肿痛一按消",
        "detailDescription": "颊，面颊，此处指上颌骨；车，车轮，指下颌骨。颊车，即下颌关节可以转动之处。",
        "cure": "祛风清热，开关通络。主治口眼歪斜、牙关紧闭、牙痛、面部痉挛。",
        "position": "在面部，下颌角前上方1横指（中指）。",
        "quickFind": "上下牙关咬紧时，会隆起一个咬肌高点，按之有凹陷处即是。",
        "massage": "用中指指腹压在咬肌隆起处揉按，以有酸胀感为宜，可治面颊疼痛、牙关不利等症。",
        "xueweiName": "颊车"
      },
      {
        "detailTitle": "下关：治疗牙痛与耳鸣",
        "detailDescription": "下，与上相对；关，机关、关节。穴在下颌关节颧弓下方，与上关互相对峙。",
        "cure": "消肿止痛，聪耳通络。主治牙痛、口眼歪斜、面痛、耳鸣。",
        "position": "在面部，颧弓下缘中央与下颌切迹之间凹陷处。",
        "quickFind": "闭口，食指和中指并拢，食指贴于耳垂旁，中指指腹处即是。",
        "massage": "用双手食指指腹按压下关3分钟，可立即消除耳鸣症状，止牙痛；常按此穴，可防治三叉神经痛。",
        "xueweiName": "下关"
      },
      {
        "detailTitle": "头维：明目还可止头痛",
        "detailDescription": "头，头部；维，隅角、维系、维护。谓穴居头之隅角，是维系头冠之处。",
        "cure": "清头明目，止痛镇痉。主治面肌痉挛，偏、正头痛，迎风流泪，目眩，口眼歪斜。",
        "position": "在头部，额角发际直上0.5寸，头正中线旁开4.5寸处。",
        "quickFind": "在头部，额角发际直上半横指，头正中线旁开6横指。",
        "massage": "用双手拇指指腹强压头维，每秒钟按压1次，如此重复10-20次，以有酸胀感为宜，可治面部痉挛、疼痛等疾病。",
        "xueweiName": "头维"
      },
      {
        "detailTitle": "人迎：调节血压效果好",
        "detailDescription": "人，指人体与生命；迎，接受。谓喉结两旁之动脉，可迎受天地五脏之气以养人也。",
        "cure": "利咽散结，理气降逆。主治胸满气逆、咽喉肿痛、食欲不振、高血压。",
        "position": "在颈部，横平喉结，胸锁乳突肌前缘，颈总动脉搏动处。",
        "quickFind": "正坐，头微侧，从喉结往外侧量约2横指，可感胸锁乳突肌前缘颈部动脉搏动即是。",
        "massage": "常用拇指指腹轻轻上下按压人迎，每次1〜3分钟，可促进血液循环，调节血压，清咽利喉。",
        "xueweiName": "人迎"
      },
      {
        "detailTitle": "水突：清咽润喉肿痛消",
        "detailDescription": "水，水谷；突，穿过。穴在颈部，邻近通过食物的食管。",
        "cure": "清热利咽，降逆平喘。主治呼吸喘鸣、咽喉肿痛、慢性咽炎、打嗝。",
        "position": "在颈部，胸锁乳突肌的前缘，当胸锁乳突肌的胸骨头与锁骨头和锁骨所构成的凹陷处。",
        "quickFind": "找到人迎、气舍，两者连线中点即是。",
        "massage": "用拇指指腹轻轻按揉水突100次，以有酸胀感为佳，可利咽润喉开音。",
        "xueweiName": "水突"
      },
      {
        "detailTitle": "气舍：保养肺脏咳嗽消",
        "detailDescription": "气，指肺胃之气；舍，宅舍。穴在气管旁，犹如气之宅舍。",
        "cure": "宣肺定喘，理气散结。主治咽喉肿痛、打嗝、瘿瘤（甲状腺肿瘤）。",
        "position": "在胸锁乳突肌区，锁骨上小窝，锁骨内侧端上缘，胸锁乳突肌的胸骨头与锁骨头中间的凹陷中。",
        "quickFind": "先找到人迎，直下，锁骨上缘处即是。",
        "massage": "用中指指腹按揉气舍，每次1~3分钟，力度适中，可保护肺脏，缓解咳嗽。",
        "xueweiName": "气舍"
      },
      {
        "detailTitle": "缺盆：咳嗽喘息不再愁",
        "detailDescription": "缺，空缺与空虚，与残缺之意有别；盆，阔口容器。古代解剖名，如无盖之盆，指穴位于缺盆处也。",
        "cure": "宽胸利膈，止咳平喘。主治咳嗽、哮喘、胸痛、咽喉肿痛、慢性咽炎。",
        "position": "在颈外侧部，前正中线旁开4寸，锁骨上缘凹陷中。",
        "quickFind": "正坐，乳中线直上锁骨上方有一凹陷，凹陷中点按有酸胀处即是。",
        "massage": "用拇指指腹按压对侧缺盆，每次左右各按压3分钟可缓解咳嗽、气喘症状。",
        "xueweiName": "缺盆"
      },
      {
        "detailTitle": "气户：咳嗽气喘好帮手",
        "detailDescription": "气，指肺胃之气；户，门户。穴在胸上部，故喻为气的门户。",
        "cure": "理气宽胸，止咳平喘。主治咳嗽胸痛、呼吸喘鸣、咽喉肿痛。",
        "position": "在胸部，锁骨下缘，前正中线旁开4寸。",
        "quickFind": "正坐仰靠，乳中线与锁骨下缘相交的凹陷，按压有酸胀感处即是。",
        "massage": "按摩时用双手食指指端点按气户，以上胸部有胀痛感为宜，可治疗咳嗽气喘、胸胁胀满。",
        "xueweiName": "气户"
      },
      {
        "detailTitle": "库房：气喘咳嗽按按它",
        "detailDescription": "库，府库；房，房室。呼吸之气存于肺如储存库；从上至下，犹如从门户进入房室。",
        "cure": "理气宽胸，清热化痰。主治胸满气逆、气喘、胸胁胀痛、咳嗽。",
        "position": "在胸部，第1肋间隙，前正中线旁开4寸。",
        "quickFind": "正坐或仰卧，从乳头沿垂直线向上推3个肋间隙，按压有酸胀感处即是。",
        "massage": "用食指点揉库房1~2分钟，也可用艾条灸，灸时距皮肤2~3厘米，每次10分钟左右，可治胸胁胀痛、气喘等症。",
        "xueweiName": "库房"
      },
      {
        "detailTitle": "屋翳：乳腺增生保健穴",
        "detailDescription": "屋，深室；翳，隐蔽。穴在胸中部，呼吸之气至此如达深室隐蔽。",
        "cure": "消痈止痒，止咳化痰。主治乳痈、乳腺增生、胸满气逆、咳嗽喘息。",
        "position": "在胸部，第2肋间隙，前正中线旁开4寸。",
        "quickFind": "正坐或仰卧，从乳头沿垂直线向上推2个肋间隙，按压有酸胀感处即是。",
        "massage": "治疗乳腺炎、乳腺增生时，可用手掌小鱼际或大鱼际，在屋翳施以轻揉手法，反复揉压数次。",
        "xueweiName": "屋翳"
      },
      {
        "detailTitle": "膺窗：胸部疼痛特效穴",
        "detailDescription": "膺，胸膺；窗，窗户。穴在胸膺部，犹如胸室之窗。",
        "cure": "止咳宁嗽，消肿清热。主治胸满气逆、呼吸喘鸣、咳嗽喘息、乳痈。",
        "position": "在胸部，第3肋间隙，前正中线旁开4寸。",
        "quickFind": "正坐或仰卧，从乳头沿垂直线向上推1个肋间隙，按压有酸胀感处即是。",
        "massage": "胸部疼痛、肋间神经痛或产后母乳不畅等症，都可以通过按摩膺窗来治疗，每次按摩1~3分钟。",
        "xueweiName": "膺窗"
      },
      {
        "detailTitle": "乳中：乳房保健就靠它",
        "detailDescription": "乳，乳头；中，正中。穴在乳头正中。",
        "cure": "调气醒神。主治癫痫、产后乳少、乳痈。",
        "position": "在胸部，乳头中央。",
        "quickFind": "将食指指腹放于胸部乳头中央，食指指腹处即是。",
        "massage": "每天用大拇指和食指捏拉乳头，每次1~3分钟，可治乳痈，并可助乳房健美。",
        "xueweiName": "乳中"
      },
      {
        "detailTitle": "乳根：乳汁不足就按它",
        "detailDescription": "乳，乳房；根，根部。穴在乳房根部。",
        "cure": "宣肺止咳，宽胸增乳。主治胸痛、胸闷、咳喘、乳汁不足、乳房肿痛。",
        "position": "在胸部，第5肋间隙，前正中线旁开4寸。",
        "quickFind": "拇指在乳房上，其余四指在乳房下，食指贴于乳房边缘，食指指腹处。",
        "massage": "用中指和食指指腹着力按压乳根，每天早晚各揉按3~5分钟。对乳痈、乳痛、乳腺炎、乳汁不足等具有很好的疗效。",
        "xueweiName": "乳根"
      },
      {
        "detailTitle": "不容：腹胀呕吐按之消",
        "detailDescription": "不，不可；容，容纳。穴在上腹部，意指胃纳水谷达到的最高处，不可再纳。",
        "cure": "调中和胃，理气止痛。主治腹胀、胃痛、呕吐、食欲不振。",
        "position": "在上腹部，脐中上6寸，前正中线旁开2寸。",
        "quickFind": "仰卧，先取中脘穴，再取中院与胸剑联合的中点作水平线，再取锁骨中线与前正中线之间的中点作垂直线，其交叉点按压有酸胀感处即是。",
        "massage": "用右食指指腹按压不容，每次3~5分钟，以有酸痛感为宜。对呕吐、胃痛和腹胀均有较好疗效。",
        "xueweiName": "不容"
      },
      {
        "detailTitle": "承满：主治胃痛和胃炎",
        "detailDescription": "承，承受；满，充满。穴在上腹部，意指胃纳水谷至此充满。",
        "cure": "理气和胃，降逆止呕。主治胃痛、呕吐、腹胀、胃十二指肠溃疡。",
        "position": "在上腹部，脐中上5寸，前正中线旁开2寸。",
        "quickFind": "仰卧，先找到不容，垂直向下量1横指，按压有酸胀感处即是。",
        "massage": "用食指指腹按压承满，每次3~5分钟，以有酸痛感为宜，可治疗胃痛、胃炎、肋间神经痛等疾病。",
        "xueweiName": "承满"
      },
      {
        "detailTitle": "梁门：预防治疗胃下垂",
        "detailDescription": "梁，指谷梁；门，门户。穴在上腹部，寓意饮食入胃之门户。",
        "cure": "和胃理气，健脾调中。主治胃痛、呕吐、腹胀、食欲不振、便溏、呕血。",
        "position": "在上腹部，脐中上4寸，前正中线旁开2寸。",
        "quickFind": "仰卧，取肚脐与胸剑联合连线的中点，再水平旁开3横指处即是。",
        "massage": "用食指指腹按压梁门，每次3~5分钟，以有酸痛感为宜，可治胃痛、呕吐和胃下垂。",
        "xueweiName": "梁门"
      },
      {
        "detailTitle": "关门：胃肠不适就找它",
        "detailDescription": "关，关隘；门，门户。穴近胃腕下部，约当胃肠交界之关，有开有关，如同门户。",
        "cure": "调理肠胃，利水消肿。主治胃痛、呕吐、腹胀、食欲不振、便秘、遗尿。",
        "position": "在上腹部，脐中上3寸，前正中线旁开2寸。",
        "quickFind": "仰卧，从肚脐沿前正中线向上量4横指，再水平旁开3横指处即是。",
        "massage": "用食指指腹按压关门，每次3~5分钟，以有酸痛感为宜，可辅助治疗腹胀、腹泻、胃肠虚弱等症。",
        "xueweiName": "关门"
      },
      {
        "detailTitle": "太乙：胃炎恶心按太乙",
        "detailDescription": "太，甚大；乙，十天干之一。古以中央为太乙。脾土居中，寓腹中央为太乙。穴在胃腕下部，约当腹中央。",
        "cure": "清心安神，化痰和胃。主治癫狂、吐舌、胃痛、呕吐、腹胀、食欲不振。",
        "position": "在上腹部，脐中上2寸，前正中线旁开2寸。",
        "quickFind": "仰卧，取中脘与脐之中点，再水平旁开3横指处即是。",
        "massage": "每次按揉太乙3~5分钟，以有酸痛感为宜。可治胃病，如胃肠虚弱、恶心等。",
        "xueweiName": "太乙"
      },
      {
        "detailTitle": "滑肉门：主治腹痛与腹胀",
        "detailDescription": "滑，美好；肉，肌肉；门，门户。穴平脐上1寸，食物至此已分清泌浊，犹如精细食物通过之门户。",
        "cure": "镇惊安神，和胃止吐。主治癫狂、胃痛、呕吐、腹胀、食欲不振、月经不调。",
        "position": "在上腹部，脐中上1寸，前正中线旁开2寸。",
        "quickFind": "仰卧，从肚脐沿前正中线向上量1横指，再水平旁开3横指处即是。",
        "massage": "用中间三指指腹垂直下按，再向上托，用力揉按1~3分钟，可辅助治疗慢性胃肠病、呕吐、胃下垂等疾病。",
        "xueweiName": "滑肉门"
      },
      {
        "detailTitle": "天枢：腹泻便秘全搞定",
        "detailDescription": "天，天空；枢，枢纽。脐上为天属阳，脐下为地属阴。穴位平脐，犹如天地之枢纽。",
        "cure": "理气调畅，调经止痛。主治呕吐、腹胀肠鸣、腹泻不止、痢疾、便秘、口腔溃疡、月经不调。",
        "position": "在腹部，横平脐中，前正中线旁开2寸。",
        "quickFind": "仰卧，肚脐旁开3横指，按压有酸胀感处即是。",
        "massage": "仰卧，用食指和中指按揉天枢2分钟，可缓解消化不良、便秘、胃胀、腹泻、腹痛等症，效果明显。",
        "xueweiName": "天枢"
      },
      {
        "detailTitle": "外陵：下腹疼痛按之消",
        "detailDescription": "外，内外之外；陵，山陵。穴位局部隆起如山陵。",
        "cure": "和胃化湿，理气止痛。主治胃痛、腹痛、腹胀、疝气、痛经。",
        "position": "在下腹部，脐中下1寸，前正中线旁开2寸。",
        "quickFind": "仰卧，从肚脐沿前正中线向下量1横指，再水平旁开3横指处即是。",
        "massage": "仰卧，用中间三个手指按揉外陵1~3分钟，可治疗下腹痛、痛经、胃下垂。",
        "xueweiName": "外陵"
      },
      {
        "detailTitle": "大巨：关爱男性保健穴",
        "detailDescription": "大，大小之大；巨，巨大。穴在腹壁最大隆起的部位。",
        "cure": "调肠胃，固肾气。主治便秘、腹痛、遗精、早泄、阳痿、小便不利。",
        "position": "在下腹部，脐中下2寸，前正中线旁开2寸。",
        "quickFind": "仰卧，从肚脐沿前正中线向下量3横指，再水平旁开3横指处即是。",
        "massage": "仰卧，用中间三个手指按揉大巨1~3分钟，可治疗遗精、早泄、小便不利等男科疾病，可调理男性性功能障碍等疾病。",
        "xueweiName": "大巨"
      },
      {
        "detailTitle": "水道：女人保健第一穴",
        "detailDescription": "水，水液；道，道路。穴位深部相当于小肠并靠近膀胱，属下焦。为水道之所出。",
        "cure": "利水消肿，调经止痛。主治便秘、腹痛、小腹胀痛、痛经、膀胱炎。",
        "position": "在下腹部，脐中下3寸，前正中线旁开2寸。",
        "quickFind": "仰卧，从肚脐沿前正中线向下量4横指，再水平旁开3横指处即是。",
        "massage": "仰卧，用中间三指按揉水道1~3分钟，可治痛经、不孕等妇科疾病。",
        "xueweiName": "水道"
      },
      {
        "detailTitle": "归来：男女生殖问题消",
        "detailDescription": "归，归回；来，到来。本穴能治宫脱、疝气等，有归复还纳之功。",
        "cure": "活血化瘀，调经止痛。主治腹痛、不孕、闭经、阳痿、白带过多。",
        "position": "在下腹部，脐中下4寸，前正中线旁开2寸。",
        "quickFind": "仰卧，从耻骨联合上缘沿前正中线向上量1横指，再水平旁开3横指处即是。",
        "massage": "以中间三指指腹垂直下按，由内而外揉按归来，每日早晚各揉按1~3分钟，可治月经不调、不孕、阳痿等疾病。",
        "xueweiName": "归来"
      },
      {
        "detailTitle": "气冲：男女问题就找它",
        "detailDescription": "气，指经气；冲，冲要。穴在经气流注之冲要。",
        "cure": "调经血，舒宗筋，理气止痛。主治阳痿、疝气、不孕、腹痛、月经不调。",
        "position": "在腹股沟区，耻骨联合上缘，前正中线旁开2寸，动脉搏动处。",
        "quickFind": "仰卧，从耻骨联合上缘中点水平旁开3横指处即是。",
        "massage": "以食指指腹揉按，每日早晚各揉按1~3分钟，可治疗疝气、月经不调、不孕、阳痿、阴肿等症。",
        "xueweiName": "气冲"
      },
      {
        "detailTitle": "髀关：改善下肢疼与麻",
        "detailDescription": "髀，指股部及下肢；关，机关。穴处乃下肢运动之机关也。",
        "cure": "强腰膝，通经络。主治腰膝疼痛、下肢酸软麻木、膝寒。",
        "position": "在股前部，股直肌近端、缝匠肌与阔筋膜张肌3条肌肉之间凹陷中。",
        "quickFind": "仰卧屈股，大腿前骼前上棘与餘底外缘连线和会阴相平的连线交点处即是。",
        "massage": "用力按揉髀关5分钟，可治腰膝疼痛、下肢酸软麻木、膝寒、股内筋急不得屈伸等症。",
        "xueweiName": "髀关"
      },
      {
        "detailTitle": "伏兔：解除膝冷与腰疼",
        "detailDescription": "伏，俯伏；兔，兽名。指穴位于股前方肌肉丰厚之处，形如兔伏，故名伏兔。",
        "cure": "散寒化湿，疏通经络。主治腰膝疼痛、下肢酸软麻木、腹胀。",
        "position": "在股前部，髌底上6寸，髂前上棘与髌底外侧端的连线上。",
        "quickFind": "屈膝90°，手指并拢压腿上，掌后第1横纹中点按在髌骨上缘中点，中指尖端处即是。",
        "massage": "按揉伏兔最好采取指压带揉动的方式，每个点按压时间约3分钟，可缓解腰膝疼痛、下肢酸软麻木、腹胀、足麻不仁等症。",
        "xueweiName": "伏兔"
      },
      {
        "detailTitle": "阴市：降低血糖好帮手",
        "detailDescription": "阴，阴阳之阴，指寒邪；市，集市，聚散之意。穴能疏散膝部寒气。",
        "cure": "散寒除湿，理气止痛。主治腿膝冷痛、麻痹，下肢不遂，脚气，糖尿病。",
        "position": "在股前区，髌底上3寸，股直肌肌腱外侧缘。",
        "quickFind": "正坐屈膝，髌底外侧直上量4横指，按压有痛感处即是。",
        "massage": "下半身寒冷的人可多按揉阴市，最好采取指压带揉动的方式，每次1~3分钟。也可经常用拇指指腹轻轻按揉阴市，每次1~3分钟，可降血糖。",
        "xueweiName": "阴市"
      },
      {
        "detailTitle": "梁丘：对付胃痛最有效",
        "detailDescription": "梁，山梁；丘，丘陵。形如山梁丘陵，穴当其处。",
        "cure": "理气和胃，通经活络。主治胃痛、肠鸣腹泻、膝关节炎、乳肿痛。",
        "position": "在股前区，髌骨外缘上2寸，股外侧肌与股直肌肌腱之间。",
        "quickFind": "坐位，下肢用力蹬直，髌骨外上缘上方凹陷正中处即是。",
        "massage": "梁丘治疗急性病效果好。如急性胃炎、肠胃炎引发的突然乳房痛，或者突然膝盖痛时，赶紧揉一下梁丘，就会马上缓解。",
        "xueweiName": "梁丘"
      },
      {
        "detailTitle": "犊鼻：治疗膝关节炎症",
        "detailDescription": "犊，小牛；鼻，口鼻。膝盖形如牛鼻，穴在膝眼中，故名。",
        "cure": "消肿止痛，通经活络。主治膝痛、腰痛、足跟痛、脚气。",
        "position": "在膝前区，髌韧带外侧凹陷中。",
        "quickFind": "坐位，下肢用力蹬直，膝盖下面外侧凹陷处即是。",
        "massage": "揉按犊鼻5分钟，可减轻剧烈运动造成的膝关节疼痛。长期坚持用中指指腹按摩犊鼻，每次1~3分钟，可以改善膝部疼痛、酸软等症。",
        "xueweiName": "犊鼻"
      },
      {
        "detailTitle": "足三里：天然滋补此穴强",
        "detailDescription": "足，下肢；三，数词；里，古代有以里为寸之说。穴在下肢，位于外膝眼下三寸。",
        "cure": "健脾和胃，通经活络。主治胃痛、呕吐、腹胀、腹泻、便秘、高脂血症、头痛、眩晕、鼻塞、癫痫、半身不遂、脾胃虚弱、贫血、手足怕冷、湿疹、荨麻疹、小儿咳嗽、小儿发热。",
        "position": "在小腿前外侧，犊鼻下3寸，犊鼻与解溪连线上。",
        "quickFind": "站位弯腰，同侧手虎口围住髌骨上外缘，余四指向下，中指指尖处即是。",
        "massage": "每天用拇指或中指按压足三里5~10分钟，每分钟按压15~20次，长期坚持，可使人精神焕发，精力充沛，益寿延年。",
        "xueweiName": "足三里"
      },
      {
        "detailTitle": "上巨虚：艾灸可治肠胃病",
        "detailDescription": "上，上方；巨，巨大；虚，中空，胫骨和腓骨之间形成的较大空隙，即中空。穴在此空隙上方。",
        "cure": "调和肠胃，通经活络。主治肠胃炎、腹泻、便秘、腹胀、高血压。",
        "position": "在小腿外侧，犊鼻下6寸，犊鼻与解溪连线上。",
        "quickFind": "坐位屈膝，先找到足三里，向下量4指凹陷处即是。",
        "massage": "按揉上巨虚主治消化系统疾病，如阑尾炎、肠胃炎、腹泻等。用艾灸法效果最好，将艾条对准穴位，距皮肤2~3厘米，灸5~10分钟。",
        "xueweiName": "上巨虚"
      },
      {
        "detailTitle": "条口：让肠胃更加强健",
        "detailDescription": "条，长条；口，空隙。穴在腓骨和胫骨之间的长条隙之中。",
        "cure": "理气和中，舒筋活络。主治肩背痛、小腿肿痛、胃肠疾病、脚气。",
        "position": "在小腿外侧，犊鼻下8寸，胫骨前延外1寸。",
        "quickFind": "坐位屈膝，犊鼻与外踝尖之间的中点，胫骨外1横指处。",
        "massage": "用力按揉条口，可治肩关节剧痛、急痛，将艾条对准条口，距皮肤2~3厘米，灸5~10分钟，可治胃肠虚弱、肩臂疼痛、下肢痿痹等疾病。",
        "xueweiName": "条口"
      },
      {
        "detailTitle": "下巨虚：主治肠胃系统病",
        "detailDescription": "下，下方；巨，巨大；虚，中空。胫骨和腓骨之间形成的较大空隙，即中空。穴在此空隙下方。",
        "cure": "调肠胃，通经络，安神志。主治小腹疼痛、胃痛、胰腺炎、下肢浮肿。",
        "position": "在小腿外侧，犊鼻下9寸，犊鼻与解溪连线上。",
        "quickFind": "坐位屈膝，先找到条口，向下量1横指凹陷处即是。",
        "massage": "按揉下巨虚，可治腹痛、腹泻、便秘等症，将艾条对准下巨虚，距皮肤2〜3厘米，灸5~10分钟，可治消化系统疾病。",
        "xueweiName": "下巨虚"
      },
      {
        "detailTitle": "丰隆：除湿化痰常刮痧",
        "detailDescription": "丰，丰满；隆，隆盛。胃经谷气隆盛，至此处丰满溢出于大络。",
        "cure": "和胃气，化痰湿，清神志。主治呕吐、便秘、水肿、头痛、眩晕、痰多、癫狂、下肢痿痹等。",
        "position": "在小腿外侧，外踝尖上8寸，胫骨前肌的外缘。",
        "quickFind": "坐位屈膝，先找到足三里，向下量6横指凹陷处即是。",
        "massage": "当出现哮喘、咳嗽、痰多时，宜多揉丰隆，用刮痧的方式更有效，可以促进人体的新陈代谢，从而达到除湿化痰的效果。",
        "xueweiName": "丰隆"
      },
      {
        "detailTitle": "解溪：腹胀眩晕一起消",
        "detailDescription": "解，分解；溪，沟溪，指体表较小凹陷。穴在踝关节前骨节分解凹陷中。",
        "cure": "清胃化痰，镇惊安神，舒筋活络。主治面部浮肿、腹胀、下剧中痛、头痛、眩晕、癫狂。",
        "position": "在踝部，踝关节前面中央凹陷中，拇长伸肌腱与趾长伸肌腱之间。",
        "quickFind": "足背与小腿交界处的横纹中央凹陷处，足背两条肌腱之间即是。",
        "massage": "经常用拇指指腹向内用力按压解溪，每次1~3分钟，可以强壮内脏器官，健胃益脑。",
        "xueweiName": "解溪"
      },
      {
        "detailTitle": "冲阳：除腹胀又增食欲",
        "detailDescription": "冲，冲要；阳，阴阳之阳。穴在冲阳脉（足背动脉）所在之处。",
        "cure": "和胃化痰，通络宁神。主治腹胀、口眼歪斜、牙痛、精神病。",
        "position": "在足背，第2跖骨基底部与中间楔状骨关节处，足背动脉搏动处。",
        "quickFind": "足背最高处，两条肌腱之间，按之有动脉搏动感处即是。",
        "massage": "以中指指腹用力按压冲阳，每天早晚各按1次，每次1~3分钟，可治消化系统疾病。",
        "xueweiName": "冲阳"
      },
      {
        "detailTitle": "陷谷：专治胃炎胃下垂",
        "detailDescription": "陷，凹陷；谷，山谷，指体表凹陷。穴在第2、第3跖骨间隙凹陷中。",
        "cure": "清热解表，和胃止痛。主治慢性胃炎、面部浮肿、腹痛、足背肿痛。",
        "position": "在足背，第2、第3跖骨间，第28石趾关节近端凹陷中。",
        "quickFind": "足背第2、第3跖骨结合部前方凹陷处，按压有酸胀感处即是。",
        "massage": "弯曲拇指，用指尖下压揉按陷谷，早晚各1次，先左后右，各揉按1~3分钟，可治胃炎、胃下垂、肠炎、结膜炎等疾病。",
        "xueweiName": "陷谷"
      },
      {
        "detailTitle": "内庭：口腔上火最有效",
        "detailDescription": "内，里边；庭，庭院。本穴在厉兑之里，犹如门内的庭院。",
        "cure": "清胃泻火，理气止痛。主治腹痛、腹泻、牙痛、头面痛、咽喉肿痛。",
        "position": "在足背，第2、第3趾，趾蹼缘后方赤白肉际处。",
        "quickFind": "足背第2、第3趾之间，皮肤颜色深浅交界处即是。",
        "massage": "用一手拇指指腹放在对侧内庭上，适当用力上下推动，有消肿止痛的功效。可治口腔溃疡、鼻出血等上火症状。",
        "xueweiName": "内庭"
      },
      {
        "detailTitle": "厉兑：快速止吐有奇效",
        "detailDescription": "厉，指胃；兑，代表门。本穴在趾端，犹如胃经之门户。",
        "cure": "清热和胃，苏厥醒神，通经活络。主治晕厥、呕吐、胃痛、水肿、牙痛、足背肿痛。",
        "position": "在足趾，第2趾末节外侧，趾甲根角侧后方0.1寸（指寸）。",
        "quickFind": "足背第2趾趾甲外侧缘与趾甲下缘各作一垂线，交点处即是。",
        "massage": "用拇指指甲尖垂直掐按厉兑，有刺痛感，每次左右各掐按1~3分钟，可以有效缓解呕吐症状。",
        "xueweiName": "厉兑"
      },
      {
        "detailTitle": "隐白：艾灸止血速度快",
        "detailDescription": "隐，隐蔽；白，白色。穴在隐蔽之处，其处色白。",
        "cure": "调经统血，健脾宁神。主治月经过多、崩漏、腹胀、便血、中风、昏迷。",
        "position": "在足趾，大趾末节内侧，趾甲根角侧后方0.1寸（指寸）。",
        "quickFind": "足大趾趾甲内侧缘与下缘各作一垂线，其交点处即是。",
        "massage": "月经过多或崩漏可用艾条灸隐白，一般15分钟可见效。该穴位还可治慢性崩漏，每天灸1次，每次3分钟，掐按10~20次。",
        "xueweiName": "隐白"
      },
      {
        "detailTitle": "大都：抽筋不怕按大都",
        "detailDescription": "大，大小之大；都，都会。穴在大趾，为经气聚散之处。",
        "cure": "健脾利湿、和胃镇惊。主治腹胀、腹痛、呕吐、便秘、胃痛、小儿惊风。",
        "position": "在足趾，第1跖趾关节远端赤白肉际凹陷中。",
        "quickFind": "足大趾与足掌所构成的关节，前下方掌背交界线凹陷处即是。",
        "massage": "常用大拇指指腹按揉大都，每次300下，可有效缓解抽筋。",
        "xueweiName": "大都"
      },
      {
        "detailTitle": "太白：健脾化湿就按它",
        "detailDescription": "太，甚大；白，白色。穴在大趾白肉上；此处之白肉更为开阔。",
        "cure": "清热化湿，健脾和胃。主治脾胃虚弱、胃痛、腹胀、腹痛、腰痛、肠鸣。",
        "position": "在跖区，第1跖趾关节近端赤白肉际凹陷中。",
        "quickFind": "足大趾与足掌所构成的关节，后下方掌背交界线凹陷处即是。",
        "massage": "顺时针或逆时针方向反复揉按太白，每次2~3分钟。可治呕吐、消化不良、腹痛、肠鸣、便血、便秘等症。",
        "xueweiName": "太白"
      },
      {
        "detailTitle": "公孙：摆平腹胀与胸痛",
        "detailDescription": "公，有通的意思；孙，孙络，在此特指络脉，脾经之络脉是从此通向胃经的。",
        "cure": "健脾益胃、通调冲脉。主治呕吐、腹痛、胃痛、失眠、小儿腹泻、小儿厌食。",
        "position": "在跖区，当第1跖骨底的前下缘赤白肉际处。",
        "quickFind": "足大趾与足掌所构成的关节内侧，弓形骨后端下缘凹陷处即是。",
        "massage": "用中指指腹向内按压公孙，以有酸痛感为宜，可辅助治疗腹胀、腹痛、心痛、胃痛、胸痛等症。",
        "xueweiName": "公孙"
      },
      {
        "detailTitle": "三阴交：妇科病首选穴位",
        "detailDescription": "三阴，指足之三阴经而言；交，指交会与交接。为足太阴、足少阴、足厥阴三条阴经气血物质之交会处。",
        "cure": "健脾益胃，调肝补肾，调理经带。主治脾胃虚弱、腹泻、胃痛、痛经、月经不调、月经过多、小便不利、阳痿、失眠、糖尿病、更年期综合征、白带过多、前列腺炎、早泄。",
        "position": "在小腿内侧，内踝尖上3寸，胫骨内侧缘后际。",
        "quickFind": "手四指并拢，小指下缘靠内踝尖上，食指上缘所在水平线与胫骨后缘交点处即是。",
        "massage": "用拇指指尖垂直按压三阴交，每天早晚各1次，每次左右足各1~3分钟，可改善女性各种病症；孕妇禁按，有引发流产的危险。",
        "xueweiName": "三阴交"
      },
      {
        "detailTitle": "商丘：扭伤康复就揉它",
        "detailDescription": "商，五音之一，属金；丘，丘陵。此为足太阴脾经经穴，属金，在丘陵样内踝的下方。",
        "cure": "健脾化湿，通调肠胃。主治腹胀、肠鸣、痔疮、两足无力、足踝痛。",
        "position": "在踝部，内踝前下方，舟骨粗隆与内踝尖连线中点的凹陷中。",
        "quickFind": "足内踝前下方凹陷处即是。",
        "massage": "足踝痛、踝关节扭伤时可用推拿法按摩商丘。经常用拇指指腹用力揉按商丘，每次1~3分钟，长期坚持对踝关节有很好的保养作用。",
        "xueweiName": "商丘"
      },
      {
        "detailTitle": "漏谷：小便不畅按漏谷",
        "detailDescription": "漏，凹陷；谷，山谷。穴居胫骨后内侧缘山谷样凹陷中。",
        "cure": "健脾和胃，利尿除湿。主治腹胀、腹痛、水肿、小便不利、足踝肿痛。",
        "position": "在小腿内侧，内踝尖上6寸，胫骨内侧缘后际。",
        "quickFind": "胫骨内侧缘，内踝尖直上量两个4横指处即是。",
        "massage": "以拇指指尖垂直按压漏谷，每天早晚各1次，每次左右足各揉按1~3分钟，可缓解男性小便不利及前列腺问题。",
        "xueweiName": "漏谷"
      },
      {
        "detailTitle": "地机：改善胰岛素分泌",
        "detailDescription": "地，土地，指下肢；机，机要。穴在下肢，肌肉最为丰富，是小腿运动的机要部位。",
        "cure": "健脾渗湿，调经止带。主治腹胀腹痛、月经不调、遗精、糖尿病。",
        "position": "在小腿内侧，阴陵泉下3寸，胫骨内侧缘后际。",
        "quickFind": "先找到阴陵泉，直下量4横指即是。",
        "massage": "每天用中指指腹垂直用力按压1~3分钟，能调节胰岛素分泌，降低血糖。",
        "xueweiName": "地机"
      },
      {
        "detailTitle": "阴陵泉：下焦湿热的克星",
        "detailDescription": "阴，阴阳之阴；陵，山陵；泉，泉水。内为阴，穴在胫骨内上髁下缘凹陷中，如山陵下之水泉。",
        "cure": "清利湿热，健脾理气，益肾调经，通经活络。主治腹痛、膝痛、水肿、遗尿、中风、失眠。",
        "position": "在小腿内侧，胫骨内侧髁下缘与胫骨内侧缘之间的凹陷中。",
        "quickFind": "拇指沿小腿内侧骨内缘向上推，抵膝关节下，胫骨向内上弯曲凹陷处即是。",
        "massage": "双手轻握膝下处，屈曲拇指，指尖由下向上出力揉按阴陵泉，每次揉按1-3分钟，可缓解腹痛、膝痛等症。",
        "xueweiName": "阴陵泉"
      },
      {
        "detailTitle": "血海：祛瘀血又生新血",
        "detailDescription": "血，气血的血；海，海洋。本穴善治各种“血”症，犹如聚溢血重归于海。",
        "cure": "调经统血，健脾化湿。主治腹胀、月经不调、痛经、荨麻疹、贫血、白癜风。",
        "position": "在股前部，髌底内侧端上2寸，股内侧肌隆起处。",
        "quickFind": "屈膝90°，手掌伏于膝盖上，拇指与其他四指呈45°，拇指指尖处即是。",
        "massage": "每天早晚用拇指指尖按揉血海，每次1~3分钟，可使女人肌肤细腻、红润有光泽。",
        "xueweiName": "血海"
      },
      {
        "detailTitle": "箕门：湿疹遗尿皆可消",
        "detailDescription": "箕，簸箕；门，门户。两腿张开席地而坐，形如箕。穴在大腿内侧，左右对称，似箕之门户。",
        "cure": "健脾渗湿，通利下焦。主治两股生疮、阴囊湿痒、小便不利、遗尿。",
        "position": "在股前部，髌底内侧端与冲门连线上，髌底内侧端上8寸处。",
        "quickFind": "坐位绷腿，大腿内侧有一鱼状肌肉隆起，鱼尾凹陷处即是。",
        "massage": "每次各揉按左右箕门1~3分钟，先左后右，可治女性阴道瘙痒、男性阴囊湿疹。",
        "xueweiName": "箕门"
      },
      {
        "detailTitle": "冲门：妇科疾病不用愁",
        "detailDescription": "冲，冲要；门，门户。穴在气街部，为经气通过的重要门户。",
        "cure": "健脾化湿，理气解痉。主治腹痛、腹胀、小便不利、妊娠浮肿、崩漏。",
        "position": "在腹股沟斜纹中，髂外动脉搏动处的外侧，距耻骨联合中点上缘3.5寸。",
        "quickFind": "仰卧，腹股沟外侧可摸到搏动，搏动外侧按压有酸胀感处即是。",
        "massage": "仰卧，用中间三指按揉冲门1~3分钟，可治崩漏、带下等妇科病症。",
        "xueweiName": "冲门"
      },
      {
        "detailTitle": "府舍：腹痛腹胀不用愁",
        "detailDescription": "府，指脏腑；舍，宅舍。穴位深处是腹腔，为脏腑的宅舍。",
        "cure": "健脾理气，散结止痛。主治腹痛、腹中肿块、霍乱吐泻、疝气。",
        "position": "在下腹部，脐中下4.3寸，前正中线旁开4寸。",
        "quickFind": "仰卧，腹股沟外侧可摸到动脉搏动处，其外侧按压有酸胀感处即是。",
        "massage": "仰卧，用中间三个手指按揉穴位1〜3分钟，可治便秘、下腹疼痛、腹胀等病症。",
        "xueweiName": "府舍"
      },
      {
        "detailTitle": "腹结：腹泻便秘双调节",
        "detailDescription": "腹，腹部；结，结聚。本穴善治腹部结聚不通之症。",
        "cure": "健脾化湿，理气调肠。主治腹泻、便秘、胁痛、打嗝、疝气。",
        "position": "在下腹部，脐中下1.3寸，前正中线旁开4寸。",
        "quickFind": "仰卧，气海旁开6横指，再向下0.2寸处。",
        "massage": "常用拇指指腹轻轻揉按，每次1~3分钟，对消化系统有很好的保养作用。",
        "xueweiName": "腹结"
      },
      {
        "detailTitle": "大横：促进消化又减肥",
        "detailDescription": "大，大小之大；横，横竖之横。穴位在内应横行于大肠。",
        "cure": "调理肠胃，温中驱寒。主治腹胀、腹痛、痢疾、腹泻、便秘、高脂血症。",
        "position": "在腹部，脐中旁开4寸。",
        "quickFind": "肚脐水平旁开4寸（锁骨中线上）处即是。",
        "massage": "每天早晚用中指指腹按压，每次3~5分钟，可促进肠胃消化，防治腰腹肥胖。",
        "xueweiName": "大横"
      },
      {
        "detailTitle": "腹哀：肝胆疼痛就找它",
        "detailDescription": "腹，腹部；哀，伤痛。本穴善治腹部各种伤痛。",
        "cure": "健脾和胃，理气调肠。主治肝胆疾病、腹痛、消化不良、便秘、痢疾。",
        "position": "在上腹部，脐上3寸，前正中线旁开4寸。",
        "quickFind": "肚脐沿前正中线向上量4横指，再水平旁开6横指（锁骨中线上）处即是。",
        "massage": "两掌平放于腹哀处，稍加用力后顺时针方向揉动，可辅助治疗胆结石、胆囊炎等肝胆疾病引起的疼痛、恶心。",
        "xueweiName": "腹哀"
      },
      {
        "detailTitle": "食窦：食积反胃有良效",
        "detailDescription": "食，食物；窦，孔窦。穴在乳头外下方，深部有储藏乳汁的孔窦。本穴能促进食物营养的吸收，为补益之孔穴。",
        "cure": "消食导滞，宣肺平喘，健脾和中，利水消肿。主治食积、反胃、胸膜炎、胸胁胀痛。",
        "position": "在胸部，第5肋间隙，前正中线旁开6寸。",
        "quickFind": "仰卧，乳头旁开3横指，再向下1个肋间隙处即是。",
        "massage": "将中间三指并拢，以指腹揉按食窦，每次1~3分钟，可治心脏疾病引起的胸痛、肋间神经痛、心悸等疾病。",
        "xueweiName": "食窦"
      },
      {
        "detailTitle": "天溪：哺乳期间可催乳",
        "detailDescription": "天，天空，指上天而言；溪，沟溪。穴当肋间如沟溪处。",
        "cure": "宽胸通乳，理气止咳。主治胸部疼痛、咳嗽、胸胁胀痛、乳房肿痛。",
        "position": "在胸部，第4肋间隙，前正中线旁开6寸。",
        "quickFind": "仰卧，乳头旁开3横指处，乳头所在肋间隙即是。",
        "massage": "将中间三指并拢，以指腹揉按天溪，每次1~3分钟，可治乳房发育不良或产后母乳不畅等。",
        "xueweiName": "天溪"
      },
      {
        "detailTitle": "胸乡：胸胁胀痛不用愁",
        "detailDescription": "胸，胸部；乡，指部位。穴在胸部，能治胸部疾病。",
        "cure": "宣肺止咳，理气止痛。主治胸部疼痛、咳嗽、胸胁胀痛、肋间神经痛。",
        "position": "在胸部，第3肋间隙，前正中线旁开6寸。",
        "quickFind": "仰卧，乳头旁开3横指，再向上1个肋间隙处即是。",
        "massage": "将中间三指并拢，以指腹揉按胸乡，每次1~3分钟，可治心脏疾病引起的胸痛、肋间神经痛、咳嗽等症。",
        "xueweiName": "胸乡"
      },
      {
        "detailTitle": "周荣：心平气顺身体棒",
        "detailDescription": "周，周身；荣，荣养。本穴可调和营气，荣养周身。",
        "cure": "宣肺平喘、理气化痰。主治胸胁胀满、胁肋痛、咳嗽、食欲不振。",
        "position": "在胸部，第2肋间隙，前正中线旁开6寸。",
        "quickFind": "仰卧，乳头旁开3横指，再向上2个肋间隙处即是。",
        "massage": "中间三指并拢，以指腹揉按穴位1~3分钟，每天早晚各1次。可缓解咳嗽或者胸胁胀满。长期坚持对呼吸系统有很好的保养作用。",
        "xueweiName": "周荣"
      },
      {
        "detailTitle": "大包：肺部保健关键穴",
        "detailDescription": "大，大小之大；包，包容。穴属脾之大络。脾土居中，与各脏腑有着最广泛的联系。",
        "cure": "宽胸利胁，行气止痛，止咳平喘。主治肺炎、胸膜炎、哮喘、气喘、全身胀痛。",
        "position": "在胸外侧区，第6肋间隙，在腋中线上。",
        "quickFind": "正坐侧身或仰卧，腋窝顶点与第11肋骨端连线的中点处即是。",
        "massage": "每天早晚用中指指尖揉按大包，每次1~3分钟，有利于清除穴位内部的瘀血，消除肿块，调理肺气，对肺部具有改善和养护功能。",
        "xueweiName": "大包"
      },
      {
        "detailTitle": "极泉：治冠心病常用穴",
        "detailDescription": "极，高大之意；泉，水泉。穴在腋窝高处，局部凹陷如泉。",
        "cure": "宽胸宁神。主治冠心病、心痛、四肢不举、乳汁分泌不足。",
        "position": "在腋窝中央，腋动脉搏动处。",
        "quickFind": "上臂外展，腋窝顶点可触摸到动脉搏动，按压有酸胀感处即是。",
        "massage": "每天早晚用中指按摩左右极泉各1~3分钟，可辅助治疗冠心病等各种心脏疾病。",
        "xueweiName": "极泉"
      },
      {
        "detailTitle": "青灵：祛除疼痛无烦恼",
        "detailDescription": "青，生发之象；灵，神灵。心为君主之官，通灵，具有脉气生发之象。",
        "cure": "理气止痛，宽胸宁心。主治头痛、肩臂红肿、腋下肿痛、全身冷颤。",
        "position": "在臂前部，肘横纹上3寸，肱二头肌的内侧沟中。",
        "quickFind": "伸臂，确定少海与极泉位置，从少海沿两者连线量4横指处即是。",
        "massage": "常用手掌拍打或用拇指指腹按揉青灵，每次1~3分钟，可预防肋痛、肩臂疼痛以及心绞痛等循环系统疾病。",
        "xueweiName": "青灵"
      },
      {
        "detailTitle": "少海：常按少海疼痛无",
        "detailDescription": "少，幼小；海，海洋。少，指手少阴经。此为心经合穴，脉气至此，犹如水流入海。",
        "cure": "理气通络，益心安神。主治心痛、牙痛、肘臂挛痛、眼充血、鼻充血。",
        "position": "在肘前部，横平肘横纹，肱骨内上髁前缘。",
        "quickFind": "屈肘90°，肘横纹内侧端凹陷处。",
        "massage": "每天早晚用拇指指腹按压少海，每次1~3分钟，可调理前臂麻木、肘关节周围软组织疾病。",
        "xueweiName": "少海"
      },
      {
        "detailTitle": "灵道：癫痫止抽就用它",
        "detailDescription": "灵，神灵；道，通道。心主神灵。穴在尺侧腕屈肌腱桡侧端，犹如通向神灵之道。",
        "cure": "宁心，安神，通络。主治心脏疾病、胃痛、目赤肿痛、癫痫。",
        "position": "在前臂内侧，腕掌侧远端横纹上1.5寸，尺侧腕屈肌腱的桡侧缘。",
        "quickFind": "仰掌用力握拳，沿尺侧肌腱内侧的凹陷，从腕横纹向上量2横指处即是。",
        "massage": "癫痫发作时抽搐的患者，平常多揉灵道，可以防治抽搐。",
        "xueweiName": "灵道"
      },
      {
        "detailTitle": "通里：有效缓解肘臂痛",
        "detailDescription": "通，通往；里，内里。心经络脉由本穴别出，与小肠经互为表里而相通。",
        "cure": "清热安神，通经活络。主治肘臂肿痛、头痛、头昏、心悸、扁桃体炎。",
        "position": "在前臂前区，腕掌侧远端横纹上1寸，尺侧腕屈肌腱的桡侧缘。",
        "quickFind": "仰掌用力握拳，沿尺侧肌腱内侧的凹陷，从腕横纹向上量1横指处即是。",
        "massage": "可治坐骨神经痛，一侧坐骨神经痛就揉另一侧通里。",
        "xueweiName": "通里"
      },
      {
        "detailTitle": "阴郄：骨蒸盗汗有特效",
        "detailDescription": "阴，阴阳之阴；郄，孔隙。此为手少阴经之郄穴。",
        "cure": "宁心安神，清心除烦。主治胃痛、吐血、心痛、盗汗、失语。",
        "position": "在前臂前区，腕掌侧远端横纹上0.5寸，尺侧腕屈肌腱的桡侧缘。",
        "quickFind": "仰掌用力握拳，沿尺侧肌腱内侧的凹陷，从腕横纹向上量半横指处。",
        "massage": "按摩阴郄，对骨蒸盗汗（晚上睡觉心里烦躁，易做噩梦，一出汗就醒，醒时不出汗）有特效。",
        "xueweiName": "阴郄"
      },
      {
        "detailTitle": "神门：安神固本之要穴",
        "detailDescription": "神，心神；门，门户。心藏神。此为心经之门户。",
        "cure": "补益心气，通经活络。主治心烦、失眠、痴呆、头痛、心悸、目眩、手臂疼痛、冠心病。",
        "position": "在腕前区，腕掌侧远端横纹尺侧端，尺侧腕屈肌腱的桡侧缘。",
        "quickFind": "微握掌，另手四指握住手腕，屈拇指，指甲尖所到凹陷处即是。",
        "massage": "每天早晚用拇指指甲尖垂直掐按，每次1〜3分钟，可调理心烦、失眠、糖尿病、高血压等症。",
        "xueweiName": "神门"
      },
      {
        "detailTitle": "少府：养心护肾此穴灵",
        "detailDescription": "少，幼小；府，处所。穴属手少阴心经，为脉气所溜之处。",
        "cure": "清心泻热，理气活络。主治心悸、胸痛、手小指拘挛、臂神经痛。",
        "position": "在手掌，横平第5掌指关节近端，第4、第5掌骨之间。",
        "quickFind": "半握拳，小指指尖所指处即是。",
        "massage": "常用拇指指尖按压少府，每次3~5分钟，可调节脏腑、活血润肤。",
        "xueweiName": "少府"
      },
      {
        "detailTitle": "少冲：昏迷急救用此穴",
        "detailDescription": "少，幼小；冲，冲动。本穴是手少心阴经井穴，脉气由此涌出并沿经脉上行。",
        "cure": "生发心气，清热熄风，醒神开窍。主治癫狂、热病、中风昏迷、目黄、胸痛。",
        "position": "在手指，小指末节桡侧，指甲根角侧上方0.1寸（指寸）。",
        "quickFind": "伸小指，沿指甲底部与指桡侧引线交点处即是。",
        "massage": "每天早晚用拇指指甲尖垂直掐按，每次3~5分钟，有利于心脏健康。",
        "xueweiName": "少冲"
      },
      {
        "detailTitle": "少泽：专治头痛与昏迷",
        "detailDescription": "少，幼小；泽，沼泽。穴在小指上，脉气初生之处，如始于小泽。",
        "cure": "清热利咽，通乳开窍。主治头痛、颈项痛、中风昏迷、乳汁不足。",
        "position": "在手指，小指末节尺侧，距指甲根角侧上方0.1寸（指寸）。",
        "quickFind": "伸小指，沿指甲底部与指尺侧引线交点处即是。",
        "massage": "用指甲尖垂直掐按少泽1~3分钟，也可把5根牙签捆在一起，点剌穴位100下，可治头痛、中风昏迷、产后无乳等症。",
        "xueweiName": "少泽"
      },
      {
        "detailTitle": "前谷：口腔溃疡泻火治",
        "detailDescription": "前，前后之前；谷，山谷。第5掌指关节前凹陷如谷，穴在其处。",
        "cure": "清利头目，安神定志，通经活络。主治头项急痛、口疮、手指痒麻、臂痛不得举。",
        "position": "在手指，第5掌指关节尺侧远端赤白肉际凹陷中。",
        "quickFind": "握拳，小指掌指关节前有一皮肤皱裳突起，其尖端处即是。",
        "massage": "常用拇指指腹按揉前谷，每次1~3分钟，对上肢麻痹有良好的调理作用。",
        "xueweiName": "前谷"
      },
      {
        "detailTitle": "后溪：颈椎腰椎病痛除",
        "detailDescription": "后，前后之后；溪，山洼流水之沟。第5掌指关节后凹陷如沟。指穴位于第5掌骨之后方。",
        "cure": "清心安神，通血活络。主治颈肩痛、肘臂痛、汗多、落枕、急性腰扭伤。",
        "position": "在手内侧，第5掌指关节尺侧近端赤白肉际凹陷中。",
        "quickFind": "握拳，小指掌指关节后有一皮肤皱罢突起，其尖端处即是。",
        "massage": "以一手握另一手掌背，弯曲拇指，垂直下压后溪，每次掐按1~3分钟，可有效治疗颈椎痛、闪腰、颈腰部慢性劳损等症。",
        "xueweiName": "后溪"
      },
      {
        "detailTitle": "腕骨：胆囊疾病多按揉",
        "detailDescription": "腕，腕部；骨，骨头。穴在腕部骨间。",
        "cure": "利湿，止咳。主治黄疸、疟疾、手腕无力、落枕、前臂痛、头痛、耳鸣。",
        "position": "在手内侧，第5掌骨基底与三角骨之间的赤白肉际凹陷中。",
        "quickFind": "微握拳，掌心向胸，由后溪向腕部推，摸到两骨结合凹陷处。",
        "massage": "用拇指指腹按压腕骨，每次1~3分钟，长期坚持对头项强痛、肩关节疼痛均有良好的调理作用。",
        "xueweiName": "腕骨"
      },
      {
        "detailTitle": "阳谷：主治眩晕与耳鸣",
        "detailDescription": "阳，阴阳之阳；谷，山谷。外为阳，腕外骨隙形如山谷，穴当其处。",
        "cure": "明目安神，通经活络。主治头痛，臂、腕外侧痛，耳鸣，耳聋。",
        "position": "在腕部，尺骨茎突与三角骨之间的凹陷中。",
        "quickFind": "屈腕，在手背腕外侧摸到两骨结合凹陷处即是。",
        "massage": "用拇指指腹按压阳谷，每次1~3分钟，可协调脏腑功能，增强机体抗病能力。",
        "xueweiName": "阳谷"
      },
      {
        "detailTitle": "养老：晚年体健靠养老",
        "detailDescription": "养，赡养；老，老人。本穴善治目花、耳聋、腰酸和肩痛等老年人常见病症。",
        "cure": "清头明目，舒筋活络。主治老年痴呆、目视不明、耳聋、急性腰痛。",
        "position": "在前臂外侧，腕背横纹上1寸，尺骨头桡侧凹陷中。",
        "quickFind": "屈腕掌心向胸，沿小指侧隆起高骨往桡侧推，触及一骨缝处即是。",
        "massage": "用食指指尖垂直下压养老1~3分钟，可辅助治疗高血压、老年痴呆、头昏眼花、耳聋、腰酸腿痛等老年病。",
        "xueweiName": "养老"
      },
      {
        "detailTitle": "支正：头晕目眩找支正",
        "detailDescription": "支，支别；正，正经。小肠之络脉由此别离正经，走向心经。",
        "cure": "安神定志，清热解表，通经活络。主治头痛、目眩、腰背酸痛、四肢无力、糖尿病。",
        "position": "在前臂外侧，腕背侧远端横纹上5寸，尺骨尺侧与尺侧腕屈肌之间。",
        "quickFind": "屈肘俯掌，确定阳谷与小海位置，二者连线中点向下1横指处即是。",
        "massage": "每天用拇指指腹揉按支正1~3分钟，可辅助治疗头晕、目眩以及手麻、颈椎压迫症。",
        "xueweiName": "支正"
      },
      {
        "detailTitle": "小海：贫血眩晕求小海",
        "detailDescription": "小，微小，指小肠经；海，海洋。此穴为小肠经合穴，气血至此犹如水流入海。",
        "cure": "安神定志，清热通络。主治目眩、耳聋、颊肿、颈项痛、贫血眩晕。",
        "position": "在肘外侧，尺骨鹰嘴与肱骨内上髁之间凹陷中。",
        "quickFind": "屈肘，肘尖最高点与肘部内侧高骨最高点间凹陷处即是。",
        "massage": "拇指指腹垂直下压小海1~3分钟，可改善贫血者下蹲后站立时导致的眼前昏黑及眩晕感。",
        "xueweiName": "小海"
      },
      {
        "detailTitle": "肩贞：肩周炎的必用穴",
        "detailDescription": "肩，肩部，指穴所在之部位；贞，第一。此为小肠经入肩的第一穴。",
        "cure": "清头聪耳，通经活络。主治肩周炎、肩胛痛、手臂麻痛、耳鸣。",
        "position": "在肩关节后下方，腋后纹头直上1寸。",
        "quickFind": "正坐垂臂，从腋后纹头向上量1横指处即是。",
        "massage": "以中指指腹按压肩贞，每次左右各揉按1~3分钟，可治肩胛痛、手臂麻木、耳鸣、耳聋等。",
        "xueweiName": "肩贞"
      },
      {
        "detailTitle": "臑俞：预防治疗肩周炎",
        "detailDescription": "臑，上臂肌肉隆起处；俞，穴。穴在臑部，为经气输注之处。",
        "cure": "舒筋活络，化痰消肿。主治肩臂酸痛无力、肩肿、颈淋巴结核。",
        "position": "在肩后部，腋后纹头直上，肩胛冈下缘凹陷中。",
        "quickFind": "手臂内收，腋后纹末端直上与肩胛冈下缘交点即是。",
        "massage": "用中指指腹按压臑俞，每次1~3分钟，长期坚持对上肢和肩关节都有很好的保养作用，还可有效预防上肢不遂、肩周炎等。",
        "xueweiName": "臑俞"
      },
      {
        "detailTitle": "天宗：健胸美体按天宗",
        "detailDescription": "天，天空，指上部；宗，指“本”，含中心之意。意为穴在肩胛冈中点下窝正中。",
        "cure": "舒筋活络，理气消肿。主治颈椎病、肩胛疼痛、肩周炎、颊颔肿、肘酸痛、乳房胀痛、气喘、小儿脊柱侧弯。",
        "position": "在肩胛区，肩胛冈下缘与肩胛骨下角连线上1/3与下2/3交点凹陷中。",
        "quickFind": "以对侧手，由颈下过肩，手伸向肩胛骨处，中指指腹所在处即是。",
        "massage": "常用中指指腹按揉天宗，每次1~3分钟，或用艾条灸5~10分钟，可使颈肩气血旺盛、胸部气血畅通。",
        "xueweiName": "天宗"
      },
      {
        "detailTitle": "秉风：肩胛疼痛就灸它",
        "detailDescription": "秉，承受；风，风邪。穴在易受风邪之处。",
        "cure": "散风活络，止咳化痰。主治肩胛疼痛不举、颈强不得回顾、咳嗽。",
        "position": "在肩胛区，肩胛冈中点上方冈上窝中。",
        "quickFind": "举臂，天宗直上，肩胛部凹陷处即是。",
        "massage": "按揉秉风3~5分钟，或用艾条灸5~10分钟，可缓解肩胛疼痛。",
        "xueweiName": "秉风"
      },
      {
        "detailTitle": "曲垣：常按此穴防衰老",
        "detailDescription": "曲，弯曲；垣，矮墙。肩胛冈弯曲如墙，穴当其处。",
        "cure": "舒筋活络，疏风止痛。主治肩胛拘挛疼痛、上肢酸麻、咳嗽。",
        "position": "在肩胛区，肩胛冈内侧端上缘凹陷中。",
        "quickFind": "低头，后颈部最突起椎体往下数2个椎体，即第2胸椎棘突，与臑俞连线中点处即是。",
        "massage": "每天早晚用中指指腹按揉曲垣1~3分钟，对眼部疲劳、上肢不适等症状有很好的调理作用，还可延缓身体衰老。",
        "xueweiName": "曲垣"
      },
      {
        "detailTitle": "肩外俞：肩背疼痛刮痧除",
        "detailDescription": "肩，肩部；外，外侧；俞，穴。穴在肩部，约当肩胛骨内侧缘之稍外方。",
        "cure": "舒筋活络，祛风止痛。主治肩背酸痛、颈项僵硬、上肢冷痛、偏头痛。",
        "position": "在脊柱区，第1胸椎棘突下，后正中线旁开3寸。",
        "quickFind": "在背部，先找到第1胸椎棘突，在其下方旁开4横指处即是。",
        "massage": "按揉肩外俞3~5分钟，或用艾条灸5〜10分钟，可治疗肩背疼痛、颈项强急等肩背颈项疾病。",
        "xueweiName": "肩外俞"
      },
      {
        "detailTitle": "肩中俞：肩背僵硬按之消",
        "detailDescription": "肩，肩部；中，中间；俞，穴。穴在肩部，约当肩胛骨内侧缘之里。",
        "cure": "解表宣肺。主治咳嗽、肩背酸痛、颈项僵硬、发热恶寒。",
        "position": "在脊柱区，第7颈椎棘突下，后正中线旁开2寸。",
        "quickFind": "低头，后颈部最突起椎体旁开3横指处即是。",
        "massage": "按揉肩中俞3~5分钟，可缓解颈肩疼痛。",
        "xueweiName": "肩中俞"
      },
      {
        "detailTitle": "天窗：五官疾病就找它",
        "detailDescription": "天，天空，指上部；窗，窗户。穴在头部，位于上，主治耳病，可通耳窍，如开天窗。",
        "cure": "熄风宁神，利咽聪耳。主治头痛、耳鸣、咽喉肿痛、痔疮。",
        "position": "在颈部，横平喉结，胸锁乳突肌的后缘。",
        "quickFind": "转头，从耳下向喉咙中央走行的绷紧的肌肉后缘与喉结相平处即是。",
        "massage": "按揉天窗3~5分钟，或用艾条灸5~10分钟，可治耳鸣、耳聋等耳部疾病。",
        "xueweiName": "天窗"
      },
      {
        "detailTitle": "天容：落枕不适艾灸消",
        "detailDescription": "天，天空，指上部；容，隆盛。穴在头部，位于上方，为经气隆盛之处。",
        "cure": "清热利咽，消肿降逆。主治头痛、耳鸣、耳聋、咽喉肿痛、哮喘。",
        "position": "在颈部，下颌角后方，胸锁乳突肌前缘凹陷中。",
        "quickFind": "耳垂下方的下颌角后方凹陷处即是。",
        "massage": "用中指指腹按揉天容3~5分钟，能缓解落枕带来的不适，用艾条灸天容5~10分钟，可治耳鸣、耳聋、咽喉肿痛等五官疾病。",
        "xueweiName": "天容"
      },
      {
        "detailTitle": "颧髎：色斑粉刺一扫光",
        "detailDescription": "颧，颧部；髎，骨隙。穴在颧部骨隙中。",
        "cure": "祛风镇惊，清热消肿。主治面痛、口眼隅斜、三叉神经痛、牙龈肿痛。",
        "position": "在面部，颧骨下缘，目外眦直下凹陷中。",
        "quickFind": "在面部，颧骨最高点下缘凹陷处即是。",
        "massage": "常按摩颧髎，每次1~3分钟，对面部有很好的保养作用，可提升气色，振奋精神，还可以预防面神经麻痹、三叉神经痛等面部疾病。",
        "xueweiName": "颧髎"
      },
      {
        "detailTitle": "听宫：耳聋耳鸣就找它",
        "detailDescription": "听，听闻；宫，宫里。听宫，指耳窍。穴在耳部，可治耳病，有通耳窍之功。",
        "cure": "聪耳开窍。主治耳鸣、耳聋、中耳炎、耳部疼痛、聋哑、牙痛、面瘫。",
        "position": "在面部，耳屏正中与下颌骨踝突之间的凹陷中。",
        "quickFind": "微张口，耳屏与下颌关节之间凹陷处即是。",
        "massage": "常用的按摩手法是一压一放，力度适中，每次双侧同时按压1~3分钟。可治疗耳鸣、耳聋，也可用于辅助治疗面瘫、牙痛等头面疾病，有活络通窍、聪耳明目的功效。",
        "xueweiName": "听宫"
      },
      {
        "detailTitle": "睛明：眼睛明亮的法宝",
        "detailDescription": "睛，眼睛；明，明亮。穴在眼区，有明目之功。",
        "cure": "泻热明目，祛风通络。主治目视不明、近视、夜盲、急性腰扭伤。",
        "position": "在面部，目内眦内上方眶内侧壁凹陷中。",
        "quickFind": "正坐合眼，手指置于内侧眼角稍上方，按压有一凹陷处即是。",
        "massage": "睛明是治疗所有眼病的关键穴位，按摩时用拇指指端按揉睛明，每次双侧同时按揉2分钟左右。",
        "xueweiName": "睛明"
      },
      {
        "detailTitle": "攒竹：刮一刮治黑眼圈",
        "detailDescription": "攒，簇聚；竹，竹子。穴在眉头，眉毛丛生，犹如竹子簇聚。",
        "cure": "泻热清目，祛风通络。主治头痛、口眼歪斜、目赤肿痛、近视、夜盲症。",
        "position": "在面部，眉头凹陷中，额切迹处。",
        "quickFind": "皱眉，眉毛内侧端有一隆起处即是。",
        "massage": "可用食指中节由内向外沿眉毛刮抹眼眶，稍用力，对治疗眼睛红肿、肿痛等热证效果通常较好，也可疏筋活络，舒眉展目。",
        "xueweiName": "攒竹"
      },
      {
        "detailTitle": "眉冲：目赤肿痛找眉冲",
        "detailDescription": "眉，眉毛；冲，直上。穴在前发际，眉毛的直上方。",
        "cure": "散风清热，镇痉宁神。主治眩晕、头痛、鼻塞、目视不明、目赤肿痛。",
        "position": "在头部，额切际直上入发际0.5寸。",
        "quickFind": "手指自眉毛向上推，入发际0.5寸处按压有痛感处即是。",
        "massage": "常用食指指腹按揉眉冲或用刮廖板刮拭，可治目赤肿痛、目视不明等眼部疾病，有疏风泻热的效果。",
        "xueweiName": "眉冲"
      },
      {
        "detailTitle": "曲差：治疗鼻疾有特效",
        "detailDescription": "曲，弯曲；差，不齐。本脉自眉冲曲而向外，至本穴又曲而向后，表面参差不齐。",
        "cure": "清热明目，安神利窍。主治头痛、鼻塞、鼻出血、心中烦闷、眼病。",
        "position": "在头部，前发际正中直上0.5寸，旁开1.5寸。",
        "quickFind": "前发际正中直上0.5寸，再旁开量2横指，取前发际中点至额角发迹连线的内1/3与外2/3交界处即是。",
        "massage": "用食指指腹按压曲差，每次左右各1~3分钟，可缓解鼻塞、流鼻涕、鼻炎等症状。",
        "xueweiName": "曲差"
      },
      {
        "detailTitle": "五处：小儿惊风不可怕",
        "detailDescription": "五，第五；处，处所。此为足太阳之脉第五穴所在之处。",
        "cure": "清热散风，明目镇痉。主治小儿惊风、头痛、目眩、目视不明、癫痫。",
        "position": "在头部，前发际正中直上1寸，旁开1.5寸。",
        "quickFind": "前发际正中直上1横指，再旁开量2横指处即是。",
        "massage": "遇到小儿惊风时，用食指指腹按压五处，左右同时按压3分钟，能迅速缓解小儿惊风症状，使孩子及时得到救治。",
        "xueweiName": "五处"
      },
      {
        "detailTitle": "承光：放松身心需常按",
        "detailDescription": "承，承受；光，光明。穴在头顶部，容易承受光线。",
        "cure": "清热明目，疏风散热。主治头痛、口眼歪斜、鼻塞、目眩、目视不明。",
        "position": "在头部，前发际正中直上2.5寸，旁开1.5寸。",
        "quickFind": "先取百会，再取百会至前发际的中点，再旁开量2横指处即是。",
        "massage": "以食指指腹按压承光，每次左右各1~3分钟，对头痛、目眩、鼻塞等症有特殊的疗效。",
        "xueweiName": "承光"
      },
      {
        "detailTitle": "通天：鼻内畅通无阻碍",
        "detailDescription": "通，通达；天，天空，指上部。穴在头部，上通巅顶。",
        "cure": "清热除湿，通利鼻窍。主治颈项强硬、头痛、头重、鼻塞、口眼隅斜。",
        "position": "在头部，前发际正中直上4寸，旁开1.5寸处。",
        "quickFind": "先取承光，其直上2横指处即是。",
        "massage": "用食指按压通天，每次3分钟左右，也可用刮物疗法，可治疗头痛、鼻塞、鼻出血、鼻窦炎等疾病。",
        "xueweiName": "通天"
      },
      {
        "detailTitle": "络却：消除抑郁精神好",
        "detailDescription": "络，联络；却，返回。膀胱经脉气由此入里联络于脑，然后又返回体表。",
        "cure": "清热安神，平肝熄风。主治口嘀、眩晕、鼻塞、目视不明、抑郁症。",
        "position": "在头部，前发际正中直上5.5寸，旁开1.5寸。",
        "quickFind": "先取承光，其直上4横指处即是。",
        "massage": "用食指按压络却，每天早晚各1次，每次3分钟左右，也可用刮痧疗法，可治疗头晕、目视不明、耳鸣等症。",
        "xueweiName": "络却"
      },
      {
        "detailTitle": "玉枕：头痛头晕就刮它",
        "detailDescription": "玉，玉石；枕，枕头。古称枕骨为“玉枕骨”，穴在其上。",
        "cure": "清热明目，通经活络。主治头痛、眩晕、目痛不能远视、鼻塞。",
        "position": "在头部，后发际正中直上2.5寸，旁开1.3寸。",
        "quickFind": "沿后发际正中向上轻推，触及枕骨，由此旁开2横指，在骨性隆起的外上缘有一凹陷处即是。",
        "massage": "头痛时，可点按玉枕3分钟或用刮痧板由上向下刮拭此穴，刮至头皮发热，头痛就会缓解很多。",
        "xueweiName": "玉枕"
      },
      {
        "detailTitle": "天柱：头脑清醒就靠它",
        "detailDescription": "天，天空；柱，支柱。上部为天。颈椎古称“柱骨”，穴在其旁。",
        "cure": "清头明目，强健筋骨。主治头痛、颈项僵硬、肩背疼痛、落枕、哮喘。",
        "position": "在颈后部，横平第颂椎棘突上际，斜方肌外缘凹陷中。",
        "quickFind": "后发际正中旁开2横指处即是。",
        "massage": "每天坚持按压天柱，每次连叩9下，对治疗头痛、视力模糊、头脑不清有显著疗效。",
        "xueweiName": "天柱"
      },
      {
        "detailTitle": "大杼：颈椎不适的克星",
        "detailDescription": "大，大小之大；杼，即梭。第1胸椎较大，棘突如梭，穴在其旁。",
        "cure": "强筋骨，清邪热。主治咳嗽、肩背痛、喘息、胸胁支满。",
        "position": "在上背部，当第1胸椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推1个椎体，下缘旁开2横指处。",
        "massage": "用中指指腹按压大杼，每次左右各按揉1~3分钟，可治咳嗽、发热、肩背痛等疾病。",
        "xueweiName": "大杼"
      },
      {
        "detailTitle": "风门：防治感冒莫忘它",
        "detailDescription": "风，风邪；门，门户。穴居易为风邪侵入之处，并善治风邪之症，故被认为是风邪出入之门户。",
        "cure": "宣肺解表，益气固表。主治伤风咳嗽、发热、头痛、哮喘、呕吐、感冒。",
        "position": "在上背部，第2胸椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推2个椎体，其下缘旁开2横指处即是。",
        "massage": "用中指指腹按压风门，每次左右各按揉1~3分钟，可有效治疗各种风寒感冒、发热、咳嗽、哮喘、支气管炎等疾病。",
        "xueweiName": "风门"
      },
      {
        "detailTitle": "肺俞：经常摩擦防哮喘",
        "detailDescription": "肺，肺脏；俞，输注。本穴是肺气转输于后背体表的部位。",
        "cure": "宣肺解表，清热理气。主治咳嗽、哮喘、胸满喘逆、酒糟鼻、耳聋、小儿感冒。",
        "position": "在上背部，第3胸椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推3个椎体，下缘旁开2横指处。",
        "massage": "用手掌反复摩擦肺俞，可以很快缓解哮喘。",
        "xueweiName": "肺俞"
      },
      {
        "detailTitle": "厥阴俞：保护心脏的卫士",
        "detailDescription": "厥阴，两阴交会之意，在此指心包络；俞，输注。本穴是心包络之气转输于后背体表的部位。",
        "cure": "宽胸理气，活血止痛。主治胃痛、呕吐、心痛、心悸、胸闷。",
        "position": "在上背部，第4胸椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推4个椎体，下缘旁开2横指处。",
        "massage": "常用按摩棒轻轻拍打厥阴俞30~60下，可缓解胸闷、心痛、心悸等症。",
        "xueweiName": "厥阴俞"
      },
      {
        "detailTitle": "心俞：养心安神多建功",
        "detailDescription": "心，心脏；俞，输注。本穴是心气转输于后背体表的部位。",
        "cure": "宽胸理气，通络安神。主治胸背痛、心悸、失眠、健忘、呕吐。",
        "position": "在上背部，第5胸椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往上推2个椎体，其下缘旁开2横指处即是。",
        "massage": "按摩心俞可缓解心惊气促、心动过速、心绞痛等心血管疾病症状。",
        "xueweiName": "心俞"
      },
      {
        "detailTitle": "督俞：肠胃疾病的克星",
        "detailDescription": "督，督脉；俞，输注。本穴是督脉之气转输于后背体表的部位。",
        "cure": "理气止痛，强心通脉。主治发热、恶寒、心痛、腹痛、腹胀、肠鸣、冠心病、心绞痛、打嗝。",
        "position": "在上背部，第6胸椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往上推1个椎体，其下缘旁开2横指处即是。",
        "massage": "重按督俞，可缓解心绞痛，或用刮痂板由上而下刮拭，也可用艾条灸5~10分钟，可治腹胀、腹痛等胃肠疾病。",
        "xueweiName": "督俞"
      },
      {
        "detailTitle": "膈俞：止呕打嗝有特效",
        "detailDescription": "膈，横膈；俞，输注。本穴是膈气转输于后背体表的部位。",
        "cure": "理气宽胸，活血通脉。主治咳血、便血、心痛、心悸、胸痛、胸闷、呕吐、打嗝、荨麻疹。",
        "position": "在背部，第7胸椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，其下缘旁开2横指处即是。",
        "massage": "每天饭前按揉3次，每次200下，可治中风病人进食难、吃饭呛、喝水呛等症。",
        "xueweiName": "膈俞"
      },
      {
        "detailTitle": "肝俞：清肝明目就靠它",
        "detailDescription": "肝，肝脏；俞，输注。本穴是肝气转输于后背体表的部位。",
        "cure": "疏肝利胆，理气明目。主治黄疸、肝炎、目视不明、痛经、眩晕、腹泻。",
        "position": "在背部，第9胸椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往下推2个椎体，其下缘旁开2横指处即是。",
        "massage": "双手拇指分别按压在双侧肝俞上做旋转运动，由轻到重至不能承受为止，每次10~30分钟，可缓解眼红、眼痛等症状。",
        "xueweiName": "肝俞"
      },
      {
        "detailTitle": "胆俞：功效利胆与护胆",
        "detailDescription": "胆，胆腑；俞，输注。本穴是胆腑之气转输于后背体表的部位。",
        "cure": "疏肝利胆，清热化湿。主治胃脘部及肚腹胀满、呕吐、黄疸。",
        "position": "在背部，第10胸椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往下推3个椎体，其下缘旁开2横指处即是。",
        "massage": "用双手拇指点压胆俞，局部有酸、胀、麻感为佳，每分钟100次，每日3次，可治胆经疾病。",
        "xueweiName": "胆俞"
      },
      {
        "detailTitle": "脾俞：不思饮食就按它",
        "detailDescription": "脾，脾脏；俞，输注。本穴是脾气转输于后背体表的部位。",
        "cure": "健脾和胃，利湿升清。主治腹胀、呕吐、腹泻、胃痛、神经性皮炎、小儿咳嗽、小儿发热。",
        "position": "在下背部，第11胸椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推3个椎体，其上缘旁开2横指处即是。",
        "massage": "当吃饭没胃口时，不妨按按脾俞，很快就会感觉有点饿了。",
        "xueweiName": "脾俞"
      },
      {
        "detailTitle": "胃俞：养胃和胃就靠它",
        "detailDescription": "胃，胃腑；俞，输注。本穴是胃气转输于后背体表的部位。",
        "cure": "和胃健脾，理中降逆。主治胃痛、呕吐、腹泻、痢疾、小儿疳积。",
        "position": "在下背部，第12胸椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推2个椎体，其上缘旁开2横指处即是。",
        "massage": "双手握拳，将拳背第2、第3掌指关节放于脾俞、胃俞上，适当用力揉按0.5-1分钟，有和胃降逆、健脾助运之功效。",
        "xueweiName": "胃俞"
      },
      {
        "detailTitle": "三焦俞：腰椎疼痛不怕了",
        "detailDescription": "三焦，三焦腑；俞，输注。本穴是三焦之气转输于后背体表的部位。",
        "cure": "调理三焦，利水强腰。主治水肿、小便不利、遗尿、腹水、肠鸣腹泻。",
        "position": "在腰部，第1腰椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推1个椎体，其上缘旁开2横指处即是。",
        "massage": "常用食指指腹点揉按压三焦俞，每次3〜5分钟，可缓解腰痛，保护腰椎。",
        "xueweiName": "三焦俞"
      },
      {
        "detailTitle": "肾俞：护肾强肾第一穴",
        "detailDescription": "肾，肾脏；俞，输注。本穴是肾气转输于后背体表的部位。",
        "cure": "益肾助阳，利水强腰。主治遗精、阳痿、月经不调、小便不利、水肿闭经。",
        "position": "在腰部，第2腰椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "肚脐水平线与脊柱相交椎体处，其下缘旁开2横指处即是。",
        "massage": "每天按揉肾俞50~100次，可补肾强身。艾灸肾俞是补肾最有效的方法，每次灸5~15分钟，可治肾疾导致的腰痛、腿痛。",
        "xueweiName": "肾俞"
      },
      {
        "detailTitle": "气海俞：提高性致除腰痛",
        "detailDescription": "气海，元气之海；俞，输注。本穴前应气海，是元气转输于后背体表的部位。",
        "cure": "益肾壮阳，调经止痛。主治痛经、痔疮、腰痛、腿膝不利。",
        "position": "在腰部，第3腰椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "肚脐水平线与脊柱相交椎体处，往下推1个椎体，其下缘旁开2横指处即是。",
        "massage": "常用按摩棒按摩气海俞，能防治腰背酸痛、腰膝无力、阳痿等症。",
        "xueweiName": "气海俞"
      },
      {
        "detailTitle": "大肠俞：腰酸腰痛多按揉",
        "detailDescription": "大肠，大肠腑；俞，输注。本穴是大肠之气转输于后背体表的部位。",
        "cure": "理气降逆，调和肠胃。主治腹痛、腹胀、便秘、痢疾、腰脊强痛。",
        "position": "在腰部，第4腰椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "两侧髂嵴连线与脊柱交点，旁开量2横指处即是。",
        "massage": "用拇指指端往里向下叩按，以小腹舒适为宜，可治腹痛、腹泻等大肠疾病。",
        "xueweiName": "大肠俞"
      },
      {
        "detailTitle": "关元俞：生殖系统守护神",
        "detailDescription": "关，关藏；元，元气；俞，输注。本穴前应关元，是关藏的元阴元阳之气转输于后背体表的部位。",
        "cure": "培补元气，调理下焦。主治腹泻、前列腺炎、夜尿症、慢性盆腔炎、痛经。",
        "position": "在腰骶部，第5腰椎棘突下，后正中线旁开1.5寸。",
        "quickFind": "两侧髂嵴连线与脊柱交点，往下推1个椎体，旁开量2横指处即是。",
        "massage": "经常按揉关元俞，可缓解生殖系统疾病。",
        "xueweiName": "关元俞"
      },
      {
        "detailTitle": "小肠俞：促进营养消化吸收",
        "detailDescription": "小肠，小肠腑；俞，输注。本穴是小肠之气转输于后背体表的部位。",
        "cure": "通调二便，清热利湿。主治腰痛、痢疾、腹泻、疝气、痔疮、盆腔炎。",
        "position": "在髂部，横平第1骶后孔，骶正中嵴旁1.5寸。",
        "quickFind": "两侧器靖连线与脊柱交点，往下推2个椎体，旁开量2横指处即是。",
        "massage": "在小肠俞附近刮痧，每次5分钟；或用艾条灸小肠俞10~15分钟，可治遗尿、遗精等生殖系统疾病。",
        "xueweiName": "小肠俞"
      },
      {
        "detailTitle": "膀胱俞：小便不利常寻按",
        "detailDescription": "膀胱，膀胱腑；俞，输注。本穴是膀胱之气转输于后背体表的部位。",
        "cure": "清热利湿，通经活络。主治小便赤涩、癃闭、夜尿症、遗精、坐骨神经痛。",
        "position": "在骶部，横平第2骶后孔，骶正中嵴旁1.5寸。",
        "quickFind": "两侧髂嵴连线与脊柱交点，往下推3个椎体，旁开量2横指处即是。",
        "massage": "在膀胱俞附近刮痧，每次3分钟，每周1次，可治小便不利、遗尿等膀胱功能失调病症。",
        "xueweiName": "膀胱俞"
      },
      {
        "detailTitle": "中膂俞：调理不孕与不育",
        "detailDescription": "中，中间；膂，挟脊肌肉；俞，输注。本穴位约居人体的中部，是挟脊肌肉之气转输于后背体表的部位。",
        "cure": "益肾温阳，调理下焦。主治腰脊强痛、痢疾、肾虚、坐骨神经痛。",
        "position": "在骶部，横平第3骶后孔，骶正中嵴旁1.5寸。",
        "quickFind": "两侧骼嵴连线与脊柱交点，往下推4个椎体，旁开量2横指处即是。",
        "massage": "按揉中膂俞100次，或用艾灸，每次灸3~5次，可治腹泻疝气。",
        "xueweiName": "中膂俞"
      },
      {
        "detailTitle": "白环俞：主治男女生殖病",
        "detailDescription": "白，白色；环，物名；俞，穴。本穴可治妇女白带等病。",
        "cure": "益肾固精，调理经带。主治月经不调、遗精、腰腿痛、下肢瘫痪。",
        "position": "在骶部，横平第4骶后孔，骶正中嵴旁1.5寸。",
        "quickFind": "两侧髂嵴连线与脊柱交点，往下推5个椎体，旁开量2横指处即是。",
        "massage": "遗精、月经不调可用艾条灸白环俞，每次3~5分钟，每日或隔日1次；每日按揉100次，亦有效。",
        "xueweiName": "白环俞"
      },
      {
        "detailTitle": "八髎：生殖系统的要穴",
        "detailDescription": "髎，骨隙。本穴位当骶后孔。",
        "cure": "补益下焦，强腰利湿。主治月经不调、带下、遗精、阳痿、腰骶痛。",
        "position": "在第1、第2、第3、第4骶后孔中，分别为上髎、次髎、中髎、下髎。",
        "quickFind": "俯卧，术者用食指、中指、无名指、小指，按骶骨第1~4假棘突上，然后向外侧移行约1横指，有凹陷处取之。四指位置即为上髎、次髎、中髎、下髎。",
        "massage": "在八髎附近找到痛点按揉，可治生殖系统方面的疾病；或每天擦热八髎穴。",
        "xueweiName": "八髎"
      },
      {
        "detailTitle": "会阳：治疗痔疮与便血",
        "detailDescription": "会，交会；阳，阴阳之阳。穴属阳经，与阳脉之海的督脉相交。",
        "cure": "清热利湿，益肾固带。主治腹泻、痔疮、便血、阳痿、阴部汗湿瘙痒。",
        "position": "在骶尾部，尾骨尖旁开0.5寸。",
        "quickFind": "俯卧，顺着脊柱向下摸到尽头，旁开0.5寸处即是。",
        "massage": "双手向后，手掌心朝向背部，用中指指腹揉按会阳，有酸痛感为佳，每次左右各揉按1~3分钟，可治腹泻、痢疾、痔疮、便血等症。",
        "xueweiName": "会阳"
      },
      {
        "detailTitle": "承扶：腿痛痔疮常找它",
        "detailDescription": "承，承受；扶，佐助。本穴位于股部上段，当肢体分界的臀沟中点，有佐助下肢承受头身重量的作用。",
        "cure": "通便消痔，舒筋活络。主治下肢瘫痪、坐骨神经痛、痔疮。",
        "position": "在股后部，臀下横纹的中点。",
        "quickFind": "俯卧，臀下横纹正中点，按压有酸胀感处即是。",
        "massage": "用食指、中指、无名指指腹向上按摩承扶，每次左右（或双侧同时）各按摩1~3分钟。可缓解腰腿痛、下肢瘫痪、痔疮、生殖器官疼痛等症。",
        "xueweiName": "承扶"
      },
      {
        "detailTitle": "殷门：强健腰腿有绝招",
        "detailDescription": "殷，深厚、正中；门，门户。穴位局部肌肉深厚，为膀胱经气通过之门户。",
        "cure": "舒筋通络，强腰健膝。主治腰、骶、臀、股部疼痛，下肢瘫痪。",
        "position": "在股后区，臀下横纹下6寸，股二头肌与半腱肌之间。",
        "quickFind": "先找到承扶、膝盖后面凹陷中央的月国横纹中点，二者连线的中点上1横指处即是。",
        "massage": "用手按摩，或用小木槌等器物敲打殷门，力度适中。对腰背疼痛和椎间盘突出症状效果明显。",
        "xueweiName": "殷门"
      },
      {
        "detailTitle": "浮郄：缓解小腿抽筋快",
        "detailDescription": "浮，顺流；郄，空隙。本经之气从股后顺流下入的穴隙。",
        "cure": "舒筋通络。主治腰、髄、臀、股部疼痛，坐骨神经痛，下肢瘫痪。",
        "position": "在膝后部，腘横纹上1寸，股二头肌腱的内侧缘。",
        "quickFind": "先找到委阳，向上1横指处即是。",
        "massage": "用中指指腹点揉浮郄3~5分钟，可缓解腓肠肌痉挛（即小腿肚转筋）带来的不适。",
        "xueweiName": "浮郄"
      },
      {
        "detailTitle": "委阳：腰背疼痛按委阳",
        "detailDescription": "委，弯曲；阳，阴阳之阳。外属阳，穴在腘窝横纹委中外侧。",
        "cure": "舒筋活络，通利水湿。主治小便淋沥、便秘、腰背部疼痛。",
        "position": "在膝部腘横纹上，股二头肌腱内侧缘。",
        "quickFind": "膝盖后面凹陷中央的腘横纹外侧，股二头肌腱内侧即是。",
        "massage": "用大拇指点到委阳上，用力向内揉按，每次左右各1~3分钟。可降血压，治腰背痛、脑后头痛、足跟痛。",
        "xueweiName": "委阳"
      },
      {
        "detailTitle": "委中：即刻缓解腰背痛",
        "detailDescription": "委，弯曲；中，中间。穴在胭横纹中点。",
        "cure": "舒筋活络，泻热清暑，凉血解毒。主治腰脊痛、坐骨神经痛、膝关节炎、半身不遂、皮肤瘙痒、发热。",
        "position": "在膝后部，腘横纹中点。",
        "quickFind": "膝盖后面凹陷中央的腘横纹中点即是。",
        "massage": "用力掐按委中20~30次，可缓解急性腰痛。",
        "xueweiName": "委中"
      },
      {
        "detailTitle": "附分：颈肩不适就按它",
        "detailDescription": "附，依附；分，分离。膀胱经自项而下，分为两行；本穴为第二行之首穴，附于第一行之旁。",
        "cure": "舒筋活络，疏风散邪。主治肩背拘急疼痛、颈项强痛、坐骨神经痛。",
        "position": "在上背部，第2胸椎棘突下，后正中线旁开3寸。",
        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推2个椎体，其下缘旁开4指处。",
        "massage": "用力按揉或用刮方板从上向下刮拭附分，或艾灸附分10~15分钟，可治颈项强痛、肩背拘急。",
        "xueweiName": "附分"
      },
      {
        "detailTitle": "魄户：咳嗽哮喘求魄户",
        "detailDescription": "魄，气之灵；户，门户。肺藏魄；本穴与肺俞平列，如肺气出入门户。",
        "cure": "理气降逆，舒筋活络。主治咳嗽、气喘、支气管炎、肺结核、颈项僵硬、肩背痛。",
        "position": "在上背部，第3胸椎棘突下，后正中线旁开3寸。",
        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推3个椎体，其下缘旁开4指处。",
        "massage": "用力按揉魄户，可治咳嗽、气喘等肺疾。",
        "xueweiName": "魄户"
      },
      {
        "detailTitle": "膏肓：强肾保健常施灸",
        "detailDescription": "膏，膏脂；肓，肓膜。在此指心下膈上的膏脂肓膜；因近于心包，故被看做心包组成部分。穴与厥阴俞平列，因名膏肓。",
        "cure": "补虚益损，调理肺气。主治肺痔、咳嗽、气喘、盗汗、健忘、遗精。",
        "position": "在上背部，第4胸椎棘突下，后正中线旁开3寸。",
        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推4个椎体，其下缘旁开4横指处。",
        "massage": "颈肩痛时，可用刮痧板从上向下刮拭膏肓；若是咳嗽、气喘等肺疾，可艾灸膏肓，每次灸10-15分钟。",
        "xueweiName": "膏肓"
      },
      {
        "detailTitle": "神堂：胸闷心慌用力按",
        "detailDescription": "心藏神；穴如心神所居之殿堂。",
        "cure": "宽胸理气，宁心安神。主治心悸、失眠、肩背痛、哮喘、心脏病。",
        "position": "在背部，第5胸椎棘突下，后正中线旁开3寸。",
        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往上推2个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
        "massage": "用双手拇指直接点压神堂，可治咳嗽、气喘、脊背强痛等；经常用按摩槌敲打神堂，可畅通气血，调理肺、胃功能。",
        "xueweiName": "神堂"
      },
      {
        "detailTitle": "譩譆：肩背酸痛不要怕",
        "detailDescription": "譩譆，叹息声。取穴时，令患者发譩譆声，穴位局部能动应手指。",
        "cure": "宣肺理气，通络止痛。主治咳嗽、气喘、目眩、肩背痛、季胁痛。",
        "position": "在背部，第6胸椎棘突下，后正中线旁开3寸处。",
        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往上推1个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
        "massage": "肩背痛时，可从上向下刮拭譩譆；经常用按摩槌敲打刺激譩譆，可调理背部肌肉疼痛。",
        "xueweiName": "譩譆"
      },
      {
        "detailTitle": "膈关：敲打叩击降胃气",
        "detailDescription": "膈，横膈；关，关隘。本穴与膈俞平列，喻之为治疗横膈疾病的关隘。",
        "cure": "宽胸理气，和胃降逆。主治饮食不下、呕吐、胸中噎闷、脊背强痛。",
        "position": "在背部，第7胸椎棘突下，后正中线旁开3寸。",
        "quickFind": "肩胛骨下角水平连线与肩胛骨脊柱缘的垂直线交点即是。",
        "massage": "经常用按摩槌敲打刺激膈关，可防治呕吐、打嗝、胃痛等症；胸闷、呕吐时，可用艾条灸膈关，每次灸10-15分钟。",
        "xueweiName": "膈关"
      },
      {
        "detailTitle": "魂门：点压缓解胸肋痛",
        "detailDescription": "肝藏魂；穴如肝气出入之门户。",
        "cure": "疏肝理气，降逆和胃。主治胸胁胀痛、呕吐、肠鸣腹泻、背痛。",
        "position": "在背部，第9胸椎棘突下，后正中线旁开3寸处。",
        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往下推2个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
        "massage": "用拇指直接点压魂门1~3分钟，可治胸胁疼痛、呕吐、腹泻、背痛等症。经常用按摩槌敲打刺激魂门，可保肝利胆。",
        "xueweiName": "魂门"
      },
      {
        "detailTitle": "阳纲：消炎利胆就刮痧",
        "detailDescription": "阳，阴阳之阳；纲，纲要。胆属阳；穴与胆俞平列，为治疗胆病的要穴。",
        "cure": "疏肝利胆，健脾和中。主治腹泻、黄疸、腹痛、大便泻利、小便赤涩。",
        "position": "在下背部，第10胸椎棘突下，后正中线旁开3寸。",
        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往下推3个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
        "massage": "经常用按摩槌敲打的方式剌激，可调理肝、胆、胃疾病引起的疼痛；用刮痧板从上向下刮拭阳纲，可治肠鸣、腹痛、腹泻等胃肠疾病。",
        "xueweiName": "阳纲"
      },
      {
        "detailTitle": "意舍：艾灸调理糖尿病",
        "detailDescription": "意，意念；舍，宅舍。脾藏意；穴与脾俞平列，如脾气之宅舍。",
        "cure": "健脾和胃，利胆化湿。主治腹胀、背痛、食欲不振、腹泻、呕吐、纳呆。",
        "position": "在下背部，第11胸椎棘突下，后正中线旁开3寸处。",
        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推3个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
        "massage": "常按揉意舍，可助健脾；用艾灸方法，每次灸10~15分钟，可辅助治疗糖尿病。",
        "xueweiName": "意舍"
      },
      {
        "detailTitle": "胃仓：增进食欲常按它",
        "detailDescription": "胃，胃腑；仓，粮仓。穴犹如粮仓。",
        "cure": "和胃健脾，消食导滞。主治胃痛、小儿食积、腹胀、便秘、水肿。",
        "position": "在下背部，第12胸椎棘突下，后正中线旁开3寸处。",
        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推2个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
        "massage": "常按揉胃仓可开胃；用艾灸的方法，每次灸10~15分钟，可治腹胀、食积等脾胃病症。",
        "xueweiName": "胃仓"
      },
      {
        "detailTitle": "肓门：腹部不适就按它",
        "detailDescription": "肓，肓膜；门，门户。穴与三焦俞平列，如肓膜之气出入的门户。",
        "cure": "理气和胃，清热消肿。主治痞块、心下痛、妇人乳疾、上腹痛、便秘。",
        "position": "在腰部，第1腰椎棘突下，后正中线旁开3寸处。",
        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推1个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
        "massage": "腹痛、便秘，可用中指指腹揉按肓门，每次3~5分钟。经常揉按也可预防消化不良。",
        "xueweiName": "肓门"
      },
      {
        "detailTitle": "志室：肾虚常按是绝招",
        "detailDescription": "志，意志；室，房室。肾藏志；穴与肾俞平列，如肾气聚集之房室。",
        "cure": "益肾固精，清热利湿，强壮腰膝。主治遗精、阴痛水肿、小便不利、腰脊强痛。",
        "position": "在腰部，第2腰椎棘突下，后正中线旁开3寸处。",
        "quickFind": "肚脐水平线与脊柱相交椎体处，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
        "massage": "用力按揉志室，可补肾强腰；也可以用艾灸法，每次灸5~10分钟。",
        "xueweiName": "志室"
      },
      {
        "detailTitle": "胞肓：腰脊疼痛多刮擦",
        "detailDescription": "胞，囊袋；肓，肓膜。胞，在此主要指膀胱；穴与膀胱俞平列，故名。",
        "cure": "补肾强腰，通利二便。主治小便不利、腰脊痛、腹胀、肠鸣、便秘。",
        "position": "横平第2骶后孔，正中靖旁开3寸。",
        "quickFind": "两侧髂嵴连线与脊柱交点，往下推3个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
        "massage": "用中指揉按1〜3分钟，可改善腰膝寒冷；腰脊强痛时可从上向下刮拭胞肓。",
        "xueweiName": "胞肓"
      },
      {
        "detailTitle": "秩边：便秘痔疾不用怕",
        "detailDescription": "秩，秩序；边，边缘。膀胱经背部诸穴，排列有序；本穴居其最下缘。",
        "cure": "舒筋活络，强壮腰膝，调理下焦。主治腰骶痛、下肢痿痹、痔疮、小便不利。",
        "position": "在骶区，横平第4骶后孔，骶正中嵴旁开3寸。",
        "quickFind": "两侧髂嵴连线与脊柱交点，往下推5个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
        "massage": "点按秩边，多防治腰腿疼痛，可用艾灸法，每次灸10〜15分钟，可治小便不利、便秘、痔疮、膀胱炎等病。",
        "xueweiName": "秩边"
      },
      {
        "detailTitle": "合阳：腰脚疼痛就揉它",
        "detailDescription": "合，汇合；阳，阴阳之阳。本经自上而下分成两支，高而为阳。",
        "cure": "舒筋通络，调经止带，强健腰膝。主治腰脊痛、下肢酸痛、崩漏、子宫出血、带下。",
        "position": "在小腿后部，腘横纹下2寸，腓肠肌内、外侧头之间。",
        "quickFind": "膝盖后面凹陷中央的腘横纹中点直下量3横指处即是。",
        "massage": "从上向下刮擦合阳及其周围，可治疗腰痛、坐骨神经痛、痔疮。",
        "xueweiName": "合阳"
      },
      {
        "detailTitle": "承筋：小腿痉挛揉承筋",
        "detailDescription": "承，承受；筋，筋肉。穴在腓肠肌处；这是小腿以下承受其以上定位的主要筋肉。",
        "cure": "舒筋活络，强健腰膝，清泻肠热。主治腰痛、小腿痛、急性腰扭伤、腿抽筋、痔疮。",
        "position": "小腿后侧，腘横纹下5寸，腓肠肌两肌腹之间。",
        "quickFind": "俯卧，小腿用力，后面肌肉明显隆起，中央处按压有酸胀感处即是。",
        "massage": "用手轻握小腿侧部，拇指在小腿后，四指在腿侧，以拇指指腹揉按，每次左右各揉按1~3分钟，可治疗痔疮和小腿痉挛。",
        "xueweiName": "承筋"
      },
      {
        "detailTitle": "承山：腿脚抽筋不再来",
        "detailDescription": "承，承受；山，山巅。腓肠肌之二肌腹高突如山，穴在其下，有承受之势。",
        "cure": "理气止痛，舒筋活络，消痔。主治痔疮、便秘、腰背疼、腿抽筋、下肢瘫痪。",
        "position": "在小腿后侧，腓肠肌两肌腹与肌腱交角处。",
        "quickFind": "俯卧，膝盖后面凹陷中央的腘横纹中点与外踝尖连线的中点处即是。",
        "massage": "用拇指指腹按摩承山，力度由轻到重，然后用手掌在穴位四周搓擦，令皮肤感到发热，以此方法可治疗小腿抽筋。",
        "xueweiName": "承山"
      },
      {
        "detailTitle": "飞扬：迅速缓解腿疲劳",
        "detailDescription": "飞，飞翔；扬，向上扬。外为阳，穴在小腿外侧，本经从此处飞离而去络肾经。",
        "cure": "清热安神，舒筋活络。主治腰腿痛、小腿酸痛、头痛、脚气。",
        "position": "在小腿后侧，昆仑直上7寸，腓肠肌外下缘与跟腱移行处。",
        "quickFind": "先找到承山，其下1横指再旁开1横指处。",
        "massage": "用食指、中指指腹揉按飞扬1~3分钟，可治头痛、目眩、腰腿疼痛等疾病。",
        "xueweiName": "飞扬"
      },
      {
        "detailTitle": "跗阳：脚踝肿痛揉揉它",
        "detailDescription": "跗，足背；阳，阴阳之阳。外为阳，上为阳；穴在小腿外侧足背外上方。",
        "cure": "舒筋活络，退热散风。主治腰、骶、胯、股后外侧疼痛。",
        "position": "在小腿后外侧，昆仑直上3寸，腓骨与跟腱之间。",
        "quickFind": "平足外踝向上量4横指，按压有酸胀感处即是。",
        "massage": "用拇指指节刮按跗阳1~3分钟，对外踝肿痛、脚麻痹等病症具有明显疗效。",
        "xueweiName": "跗阳"
      },
      {
        "detailTitle": "昆仑：脚踝疼痛多拿捏",
        "detailDescription": "昆仑，山名。外踝高突，比作昆仑，穴在其后。",
        "cure": "安神清热，舒筋活络。主治头痛、腰骶疼痛、外踝部红肿、足部生疮。",
        "position": "在踝部，外踝尖与跟腱之间凹陷中。",
        "quickFind": "外踝尖与跟腱之间凹陷处即是。",
        "massage": "拇指弯曲，用指节由上向下轻轻刮按1~3分钟，对腿足红肿、脚腕疼痛、脚踝疼痛等具有疗效。",
        "xueweiName": "昆仑"
      },
      {
        "detailTitle": "仆参：牙槽脓肿有奇效",
        "detailDescription": "仆，仆从；参，参拜。穴在足跟外侧，参拜时此处易显露。",
        "cure": "舒筋活络，强壮腰膝，散热化气。主治牙槽脓肿、下肢痿弱、足跟痛、精神病。",
        "position": "昆仑直下，跟骨外侧，赤白肉际处。",
        "quickFind": "昆仑垂直向下量1横指处。",
        "massage": "牙槽脓肿的初期，按压仆参会有疼痛感。常按此穴，一般不太严重的患者都会好转。",
        "xueweiName": "仆参"
      },
      {
        "detailTitle": "申脉：安神宁心治失眠",
        "detailDescription": "申，伸展的意思；脉，经脉。指其可治经脉之屈伸不利、气郁而呻等症，且可内应膀胱之本府也。",
        "cure": "镇惊安神，止痫宁心。主治失眠，癫狂，痫症，中风，偏、正头痛，眩晕。",
        "position": "在踝部，外踝下缘与跟骨之间凹陷中。",
        "quickFind": "正坐垂足着地，外踝垂直向下可触及一凹陷，按压有酸胀感处即是。",
        "massage": "按摩申脉可缓解头痛、眩晕、腰腿酸痛等症状；每天用拇指指腹揉按1~3分钟，可增强人体对寒冷的耐受性。",
        "xueweiName": "申脉"
      },
      {
        "detailTitle": "金门：急性腰痛就按它",
        "detailDescription": "金，阳之称；门，门户。穴是阳维脉的始发点，故又被喻为进入阳维脉的门户。",
        "cure": "通经活络，安神开窍。主治腰痛、足部扭伤、晕厥、牙痛、偏头痛。",
        "position": "第5跖骨粗隆后方，骰骨外侧凹陷中。",
        "quickFind": "正坐垂足着地，脚趾上翘可见一骨头凸起，外侧凹陷处即是。",
        "massage": "在金门痛点处点按2分钟，可即时缓解急性腰痛；常用拇指指腹揉按金门，每次1~3分钟，可调理头晕目眩等症状。",
        "xueweiName": "金门"
      },
      {
        "detailTitle": "京骨：长按多掐保健康",
        "detailDescription": "京骨，是第5跖骨粗隆的古称。穴在第5跖骨粗隆外侧。",
        "cure": "清热止痉，明目舒筋。主治头痛、眩晕、膝痛、鼻塞、小儿惊风。",
        "position": "在足背外侧，第5跖骨粗隆前下方，赤白肉际处。",
        "quickFind": "沿小趾长骨往后推，可摸到一凸起，下方皮肤颜色深浅交界处即是。",
        "massage": "用拇指指端轻轻掐揉京骨，以有酸痛感为宜，可治疗头痛、眩晕、鼻塞。",
        "xueweiName": "京骨"
      },
      {
        "detailTitle": "束骨：推按束骨防感冒",
        "detailDescription": "束骨，为第5跖骨小头之古称。穴在第5跖骨小头外下方。",
        "cure": "通经活络，清头明目。主治头痛、目赤、耳聋、痔疮、下肢后侧痛。",
        "position": "在足背外侧，第5跖趾关节的近端，赤白肉际处。",
        "quickFind": "沿小趾向上摸，摸到小趾与足部相连接的关节，关节后方皮肤颜色交界处即是。",
        "massage": "用按摩棒按压束骨，每次100下，每天3次，可治疗头痛、项强、目眩等头部疾病。",
        "xueweiName": "束骨"
      },
      {
        "detailTitle": "足通谷：温阳散寒治阳虚",
        "detailDescription": "足，足部；通，通过；谷，山谷。穴在足部，该处凹陷如谷，脉气由此而通过。",
        "cure": "清热安神，清头明目。主治头痛、头重、目眩、鼻塞、颈项痛。",
        "position": "在足趾，第5跖趾关节的远端，赤白肉际处。",
        "quickFind": "沿小趾向上摸，摸到小趾与足掌相连接的关节，关节前方皮肤颜色交界处即是。",
        "massage": "常按足通谷，可治呼吸系统、循环系统、消化系统病症。",
        "xueweiName": "足通谷"
      },
      {
        "detailTitle": "至阴：纠正胎位第一穴",
        "detailDescription": "至，到达；阴，阴阳之阴。阴，在此指足少阴肾经。此穴为足太阳膀胱经末穴，从这里可到达足少阴肾经。",
        "cure": "理气活血，清头明目。主治头痛、鼻塞、遗精、胎位不正、难产。",
        "position": "在足趾，小趾末节外侧，趾甲根角侧后方0.1寸（指寸）。",
        "quickFind": "足小趾外侧，趾甲外侧缘与下缘各作一垂线，其交点处即是。",
        "massage": "掐按至阴可纠正胎位不正，或艾灸此穴，每日灸1次，每次10~15分钟，以足小趾皮肤潮红为度。灸前排空小便，松开腰带，以利胎儿活动。",
        "xueweiName": "至阴"
      },
      {
        "detailTitle": "涌泉：人体生命之源泉",
        "detailDescription": "涌，外涌而出也；泉，泉水也。穴居足心陷中，经气自下而上，如涌出之泉水。",
        "cure": "苏厥开窍，滋阴益肾，平肝熄风。主治休克、中暑、晕厥、癔病、喉痹、鼻出血、心烦、腰痛、高血压、低血压、尿潴留、遗精、头晕、气管炎、扁桃体炎、小儿腹泻、小儿厌食、神经衰弱。",
        "position": "在足底，屈足卷趾时足心最凹陷处。",
        "quickFind": "卷足，足底前1/3处可见有一凹陷处，按压有酸痛感处即是。",
        "massage": "经常按摩剌激涌泉，使整个足底发热，可补肾健身，还可改善疲乏无力、神经衰弱。",
        "xueweiName": "涌泉"
      },
      {
        "detailTitle": "然谷：滋阴补肾助睡眠",
        "detailDescription": "然，然骨；谷，山谷。穴在然骨（舟骨粗隆）下陷中，如居山谷。",
        "cure": "清热利湿，益气固肾。主治咽喉疼痛、阳痿、月经不调、胸胁胀满。",
        "position": "在足内侧，足舟骨粗隆下方，赤白肉际处。",
        "quickFind": "坐位垂足，内踝前下方明显骨性标志一骨前下方凹陷处即是。",
        "massage": "经常按揉然谷，可固肾缩尿，防治老年人尿频；用艾条灸然谷5〜15分钟，可以清肾经虚火，常用于月经不调、带下、遗精、咽喉肿痛、小便不利等症。",
        "xueweiName": "然谷"
      },
      {
        "detailTitle": "太溪：大补肾气除百病",
        "detailDescription": "太，甚大；溪，沟溪。穴在内踝与跟腱之间凹陷中，如巨大的沟溪。",
        "cure": "滋阴益肾，壮阳强腰。主治扁桃体炎、慢性咽炎、闭经、失眠、冠心病、早泄。",
        "position": "在踝区，内踝尖与跟腱之间的凹陷中。",
        "quickFind": "坐位垂足，由足内踝向后推至与跟腱之间凹陷处即是。",
        "massage": "用拇指指腹由上往下刮太溪，每日早晚左右足各刮1~3分钟，可调节和缓解肾炎、膀胱炎、遗尿、遗精等病症。",
        "xueweiName": "太溪"
      },
      {
        "detailTitle": "大钟：强腰壮骨疗效好",
        "detailDescription": "大，大小之大；钟，同“踵”，即足跟。穴在足跟，其骨较大，故名大钟。",
        "cure": "益肾平喘，调理二便。主治咽喉肿痛、腰脊强痛、呕吐、哮喘、便秘。",
        "position": "在足跟部，内踝后下方，跟骨上缘，跟腱附着部前缘凹陷中。",
        "quickFind": "先找到太溪，向下量半横指，再向后平推至凹陷处即是。",
        "massage": "拿捏大钟，可防治腰痛；用艾灸的方法，每次灸5~15分钟，可治气喘、支气管炎。",
        "xueweiName": "大钟"
      },
      {
        "detailTitle": "水泉：艾灸痛经疗效佳",
        "detailDescription": "水，水液；泉，水泉。水泉有水源之意，肾主水。穴属本经郄穴，能治小便淋沥。",
        "cure": "清热益肾，疏经活络。主治小便不利、足跟痛、痛经、闭经、腹痛。",
        "position": "在足跟区，太溪直下1寸，跟骨结节内侧凹陷中。",
        "quickFind": "先找到太溪，直下用拇指量1横指，按压有酸胀感处即是。",
        "massage": "按揉水泉，可防治足跟痛；女性痛经，可在经期每天早晚各用艾条灸1次，每次10-15分钟，可止痛。",
        "xueweiName": "水泉"
      },
      {
        "detailTitle": "照海：月经不调的救星",
        "detailDescription": "照，光照；海，海洋。穴属肾经，气盛如海，意为肾中真阳，可光照周身。",
        "cure": "滋阴清热，调经止痛。主治咽喉肿痛、气喘、便秘、月经不调、遗精、失眠。",
        "position": "在内踝尖下1寸，内踝下缘边际凹陷中。",
        "quickFind": "坐位垂足，由内踝尖垂直向下推，至下缘凹陷处，按压有酸痛感处即是。",
        "massage": "常用拇指指腹轻轻向下揉按，每次1~3分钟，有补肾、养肝、健脾的功效。",
        "xueweiName": "照海"
      },
      {
        "detailTitle": "复溜：滋补肾阴数它强",
        "detailDescription": "复，同“伏”，深伏；溜，流动。穴居照海之上，在此指经气至“海”入而复出并继续溜注之意。",
        "cure": "补肾益阴，清热利水。主治水肿、腹胀、腰脊强痛、盗汗、自汗。",
        "position": "在小腿内侧，内踝尖上2寸，跟腱的前缘。",
        "quickFind": "先找到太溪，直上量3横指，跟腱前缘处，按压有酸胀感处即是。",
        "massage": "用拇指指腹由下往上推按复溜1~3分钟，可缓解腹泻、盗汗、四肢乏力、腰脊强痛。",
        "xueweiName": "复溜"
      },
      {
        "detailTitle": "交信：调经养血止崩漏",
        "detailDescription": "交，交会；信，信用。信，五常之一，属土，指脾。本经脉气在本穴交会脾经。",
        "cure": "益肾调经，调理二便。主治淋病、月经不调、子宫脱垂、便秘、痛经。",
        "position": "在小腿内侧，内踝尖上2寸，胫骨内侧缘后际凹陷中。",
        "quickFind": "先找到太溪，直上量3横指，再前推至胫骨后凹陷处即是。",
        "massage": "弯曲拇指，用拇指指腹垂直揉按交信，有轻微酸胀感为宜，每次左右各揉按1~3分钟，先左后右，可治月经不调、痛经、崩漏等妇科疾病。",
        "xueweiName": "交信"
      },
      {
        "detailTitle": "筑宾：腿脚无力好帮手",
        "detailDescription": "筑，强健；宾，同“膑”，泛指膝和小腿。穴在小腿内侧，有使腿膝强健的作用。",
        "cure": "调理下焦，宁心安神。主治脚软无力、肾炎、膀胱炎、腓肠肌痉挛。",
        "position": "在小腿内侧，太溪直上5寸，比目鱼肌与跟腱之间。",
        "quickFind": "先找到太溪，直上量7横指，按压有酸胀感处即是。",
        "massage": "用食指指腹揉按筑宾，力度适中，可改善小腿痉挛、脚软无力等不适症状。",
        "xueweiName": "筑宾"
      },
      {
        "detailTitle": "阴谷：遗尿遗精选阴谷",
        "detailDescription": "阴，阴阳之阴；谷，山谷。内为阴。穴在膝关节内侧，局部凹陷如谷。",
        "cure": "益肾调经，理气止痛。主治小便难、遗精、早泄、阴囊湿痒、妇人带漏。",
        "position": "在膝后区，胭横纹上，半腱肌肌腱外侧缘。",
        "quickFind": "微屈膝，在胭窝横纹内侧可触及两条筋，两筋之间凹陷处即是。",
        "massage": "用食指指腹揉按阴谷，力度适中，每次揉按1~3分钟，可治疗阳痿、早泄、遗精、前列腺炎等男性功能障碍疾病。",
        "xueweiName": "阴谷"
      },
      {
        "detailTitle": "横骨：男性疾病按摩除",
        "detailDescription": "横骨，为耻骨之古称。穴在横骨上缘上方，故称横骨。",
        "cure": "益肾助阳，调理下焦。主治腹痛、外生殖器肿痛、遗精、闭经、盆腔炎。",
        "position": "在下腹部，脐中下5寸，前正中线旁开0.5寸。",
        "quickFind": "仰卧，耻骨联合上缘中点，再旁开半横指处即是。",
        "massage": "用拇指指腹从上向下推摩，每次3~5分钟。可治小便不利、遗尿、遗精等泌尿生殖系统疾病。",
        "xueweiName": "横骨"
      },
      {
        "detailTitle": "大赫：生殖健康的福星",
        "detailDescription": "大，大小之大；赫，显赫。显赫有盛大之意。本穴为足少阴冲脉之会，乃下焦元气充盛之处。",
        "cure": "益肾助阳，调经止带。主治遗精、月经不调、痛经、不孕、带下。",
        "position": "在下腹部，脐中下4寸，前正中线旁开0.5寸。",
        "quickFind": "仰卧，依上法找到横骨，向上1横指处即是。",
        "massage": "用拇指指腹从上向下推摩大赫，每次3~5分钟。可治生殖系统、泌尿系统疾病。",
        "xueweiName": "大赫"
      },
      {
        "detailTitle": "气穴：调理冲任效果好",
        "detailDescription": "气，气血之气，在此指肾气；穴，土室。穴在关元旁，为肾气藏聚之室。",
        "cure": "调理冲任，益肾暧胞。主治月经不调、痛经、带下、遗精、阳痿。",
        "position": "脐中下3寸，前正中线旁开0.5寸。",
        "quickFind": "肚脐下4横指，再旁开半横指处。",
        "massage": "用拇指指腹从上向下推摩气穴，每次3~5分钟。可有效治疗生殖疾病。",
        "xueweiName": "气穴"
      },
      {
        "detailTitle": "四满：腹痛腹冷不怕了",
        "detailDescription": "四，第四；满，充满。此乃肾经入腹的第四穴，可治腹部胀满。",
        "cure": "理气调经，利水消肿。主治痛经、不孕症、遗精、水肿、小腹痛、便秘。",
        "position": "脐中下2寸，前正中线旁开0.5寸。",
        "quickFind": "仰卧，肚脐下飛指，再旁开半横指处即是。",
        "massage": "按揉四满可治腹痛、便秘、腹泻、月经不调等疾病；或艾条灸，每次5~15分钟。",
        "xueweiName": "四满"
      },
      {
        "detailTitle": "中注：经常按摩促消化",
        "detailDescription": "中，中间；注，灌注。肾经之气由此灌注中焦。",
        "cure": "调经止带，通调腑气。主治腹胀、呕吐、腹泻、痢疾、腰腹疼痛。",
        "position": "在下腹部，脐中下1寸，前正中线旁开0.5寸。",
        "quickFind": "仰卧，肚脐下半横指，再旁开半横指处即是。",
        "massage": "按揉中注可治腹痛、便秘、腹泻、月经不调等疾病；可用艾条灸中注，每次5~15分钟。",
        "xueweiName": "中注"
      },
      {
        "detailTitle": "肓俞：告别便秘的痛苦",
        "detailDescription": "肓，肓膜：俞，输注。肾经之气由此灌注中焦。",
        "cure": "理气止痛，润肠通便。主治绕脐腹痛、腹胀、呕吐、腹泻、痢疾、便秘。",
        "position": "在腹中部，脐中旁开0.5寸。",
        "quickFind": "仰卧，肚脐旁开半横指处即是。",
        "massage": "用拇指指腹从上向下推摩肓俞，每次3~5分钟，用艾条灸肓俞，每次5~15分钟。可治腹痛、便秘、腹泻、月经不调、疝气等疾病。",
        "xueweiName": "肓俞"
      },
      {
        "detailTitle": "商曲：解决腹痛的烦恼",
        "detailDescription": "商，五音之一，属金；曲，弯曲。商为金音，大肠属金，本穴内对大肠弯曲处。",
        "cure": "健脾和胃，消积止痛。主治绕脐腹痛、腹胀、呕吐、腹泻、痢疾、便秘。",
        "position": "在上腹部，脐中上2寸，前正中线旁开0.5寸。",
        "quickFind": "仰卧，肚脐上璃指，再旁开半横指处即是。",
        "massage": "用拇指指腹从上向下推摩商曲，每次3~5分钟，或用艾条灸商曲，每次5~15分钟。可治胃痛、便秘、腹泻等胃肠疾病。",
        "xueweiName": "商曲"
      },
      {
        "detailTitle": "石关：脾胃虚寒按石关",
        "detailDescription": "石，石头；关，重要。石有坚实之意。本穴为治腹部坚实病症的要穴。",
        "cure": "降逆止呕、温经散寒。主治闭经、带下、脾胃虚寒、腹痛。",
        "position": "在上腹部，脐中上3寸，前正中线旁开0.5寸。",
        "quickFind": "仰卧，肚脐上4横指，再旁开半横指处即是。",
        "massage": "两手中指指腹相互叠加，用力按压石关，有酸胀的感觉为宜，每次揉按3~5分钟，可治呕吐、腹痛、妇人不孕等脾胃虚寒之证。",
        "xueweiName": "石关"
      },
      {
        "detailTitle": "阴都：有效缓解胃痛",
        "detailDescription": "阴，阴阳之阴；都，会聚。穴在腹部，为水谷聚焦之处。",
        "cure": "调理胃肠，宽胸降逆。主治腹胀、肠鸣、腹痛、哮喘、便秘、妇人不孕。",
        "position": "在上腹部，脐中上4寸，前正中线旁开0.5寸。",
        "quickFind": "仰卧，胸剑联合与肚脐连线中点，再旁开半横指处即是。",
        "massage": "中间三指指腹摩阴都、中脘，可治胃胀、胃痛、恶心等。",
        "xueweiName": "阴都"
      },
      {
        "detailTitle": "腹通谷：胃痛呕吐不用怕",
        "detailDescription": "腹，腹部；通，通过；谷，水谷。穴在腹部，为通过水谷之处。",
        "cure": "健脾和胃，宽胸安神。主治腹痛，腹胀，呕吐，胸痛，急、慢性胃炎。",
        "position": "在上腹部，脐中上5寸，前正中线旁开0.5寸。",
        "quickFind": "仰卧，胸剑联合处，直下量4横指，再旁开半横指处即是。",
        "massage": "按揉腹通谷，可治胃痛、呕吐、腹痛、腹胀等胃肠疾病。",
        "xueweiName": "腹通谷"
      },
      {
        "detailTitle": "幽门：腹胀腹泻双调节",
        "detailDescription": "幽，隐藏在腹部深处；门，门户。胃之下口称幽门。穴之深部，邻近幽门。",
        "cure": "健脾和胃，降逆止呕。主治腹痛、呕吐、胃痛、胃溃疡、消化不良。",
        "position": "在上腹部，脐中上6寸，前正中线旁开0.5寸。",
        "quickFind": "仰卧，胸剑联合处，直下量3横指，再旁开半横指处即是。",
        "massage": "按揉幽门，可治呕吐、腹痛、腹胀、腹泻等胃肠疾病。",
        "xueweiName": "幽门"
      },
      {
        "detailTitle": "步廊：乳房保健关键穴",
        "detailDescription": "步，步行；廊，走廊。穴当中庭旁；经气自此，如步行于庭堂之两廊。",
        "cure": "宽胸理气，止咳平喘。主治咳嗽、哮喘、胸痛、乳痈、胸膜炎。",
        "position": "在胸部，第5肋间隙，前正中线旁开2寸。",
        "quickFind": "仰卧，平乳头的肋间隙的下一肋间，由前正中线旁开戏指处即是。",
        "massage": "急性乳腺炎患者可自步廊向乳头方向推抹50~100次。",
        "xueweiName": "步廊"
      },
      {
        "detailTitle": "神封：缓解气喘与咳嗽",
        "detailDescription": "神，指心；封，领属。穴之所在为心之所属。",
        "cure": "宽胸理肺，降逆止呕。主治咳嗽、哮喘、呕吐、胸痛、乳痈、胸膜炎。",
        "position": "在胸部，第4肋间隙，前正中线旁开2寸。",
        "quickFind": "仰卧，平乳头的肋间隙中，由前正中线旁开飛指处即是。",
        "massage": "用中指指腹揉按神封3~5分钟，可缓解跑步后或搬重物后造成的气喘。",
        "xueweiName": "神封"
      },
      {
        "detailTitle": "灵墟：风寒咳嗽找灵墟",
        "detailDescription": "灵，指心；墟，土堆。本穴内应心脏，外当肌肉隆起处，其隆起犹如土堆。",
        "cure": "疏肝宽胸，肃降肺气，壮阳益气。主治咳嗽、哮喘、胸痛、乳痈、胸膜炎、心悸。",
        "position": "在胸部，第3肋间隙，前正中线旁开2寸。",
        "quickFind": "仰卧，自乳头垂直向上推1个肋间隙，该肋间隙中，由前正中线旁开3横指处即是。",
        "massage": "治疗风寒咳嗽，常按揉灵墟，每次10~15分钟，具有止咳化痰的功效。",
        "xueweiName": "灵墟"
      },
      {
        "detailTitle": "神藏：艾灸一下咳喘除",
        "detailDescription": "神，指心；藏，匿藏。穴当心神匿藏之处。",
        "cure": "宽胸理气，降逆平喘。主治咳嗽、哮喘、胸痛、支气管炎、呕吐。",
        "position": "在胸部，第2肋间隙，前正中线旁开2寸。",
        "quickFind": "仰卧，自乳头垂直向上推2个肋间隙，该肋间隙中，由前正中线旁开3横指处即是。",
        "massage": "轻轻按揉神藏，可治咳嗽、气喘等肺疾。",
        "xueweiName": "神藏"
      },
      {
        "detailTitle": "彧中：定喘顺气好帮手",
        "detailDescription": "彧，通“郁”；中，中间。郁有茂盛之意，穴当肾气行于胸中大盛之处。",
        "cure": "宽胸理气，止咳化痰。主治咳嗽、胸胁胀满、不嗜食、咽喉肿痛。",
        "position": "在胸部，第1肋间隙，前正中线旁开2寸。",
        "quickFind": "仰卧，自锁骨下缘垂直向下推1个肋骨，就是第1肋间隙，由前正中线旁开預指处即是。",
        "massage": "生气或疲累后，胸胁部有时会感到疼痛，而且不断咳嗽，此时可以用拇指指腹点按彧中，有助于止痛、定咳、顺气。",
        "xueweiName": "彧中"
      },
      {
        "detailTitle": "俞府：推揉胜过止咳药",
        "detailDescription": "俞，输注；府，通“腑”。肾之经气由此输入内脏。",
        "cure": "止咳平喘，和胃降逆。主治咳嗽、哮喘、呕吐、胸胁胀满、不嗜食。",
        "position": "在胸部，锁骨下缘，前正中线旁开2寸。",
        "quickFind": "仰卧，锁骨下可触及一凹陷，在此凹陷中，前正中线旁开3横指处即是。",
        "massage": "经常推揉、拍打俞府可调气散结，延缓呼吸器官衰老。",
        "xueweiName": "俞府"
      },
      {
        "detailTitle": "天池：乳腺增生的克星",
        "detailDescription": "天，天空；池，池塘。穴在乳旁，乳房之泌乳，有如水自天池而出。",
        "cure": "活血化瘀，宽胸理气。主治咳嗽、胸痛、胸闷、乳汁分泌不足、乳腺炎。",
        "position": "在胸部，第4肋间隙，前正中线旁开5寸。",
        "quickFind": "仰卧，自乳头沿水平线向外侧旁开1横指，按压有酸胀感处即是。",
        "massage": "中指指腹垂直下压揉按天池，持续3~5分钟为宜，可治乳腺增生、乳腺炎等疾病。",
        "xueweiName": "天池"
      },
      {
        "detailTitle": "天泉：增强心脏之活力",
        "detailDescription": "天，天空；泉，泉水。源于天地的经气由此而下，如泉水从天而降。",
        "cure": "宽胸理气，活血通脉。主治心痛、打嗝、上臂内侧痛、胸背痛。",
        "position": "在臂前区，腋前纹头下2寸，肱二头肌的长、短头之间。",
        "quickFind": "伸肘仰掌，腋前纹头直下3横指，在肱二头肌肌腹间隙中，按压有酸胀感处即是。",
        "massage": "心脏供血不足者，可每天坚持用中指指腹揉天泉，每次1~3分钟。",
        "xueweiName": "天泉"
      },
      {
        "detailTitle": "曲泽：胸闷心慌多按揉",
        "detailDescription": "曲，弯曲；泽，沼泽。经气流注至此，入曲肘浅凹处，犹如水进沼泽。",
        "cure": "清心镇痛，和胃降逆。主治胃痛、呕吐、腹泻、风疹、心痛、心悸。",
        "position": "在肘前区，肘横纹上，肱二头肌腱的尺侧缘凹陷中。",
        "quickFind": "肘微弯，肘弯里可摸到一条大筋，内侧横纹上可触及凹陷处即是。",
        "massage": "用拇指垂直按压曲泽1~3分钟，可治心火上升引起的心痛、心悸等心血管疾病。",
        "xueweiName": "曲泽"
      },
      {
        "detailTitle": "郄门：心绞痛的应急穴",
        "detailDescription": "郄，孔隙；门，门户。此为本经部穴，乃本经经气出入之门户。",
        "cure": "宁心安神，清营止血。主治心胸部疼痛、心悸、呕血、鼻塞。",
        "position": "在前臂前区，腕掌侧远端横纹上5寸，掌长肌腱与桡侧腕屈肌腱之间。",
        "quickFind": "微屈腕握拳，曲池与大陵连线中点下1横指处即是本穴。",
        "massage": "患者自己可用右手拇指按定左手部门，然后左手腕向内转动45°再返回，以每分钟60次的速度重复该动作，按摩1分钟，可治心悸、心动过速、心绞痛等症。",
        "xueweiName": "郄门"
      },
      {
        "detailTitle": "间使：治疗打嗝之要穴",
        "detailDescription": "间，间隙；使，臣使。穴属心包经，位于两筋之间隙，心包为臣使之官，故名。",
        "cure": "宽胸和胃，清心安神，理气镇痛。主治打嗝、呕吐、中风、月经不调、尊麻疹。",
        "position": "在前臂前区，腕掌侧远端横纹上3寸，掌长肌腱与桡侧腕屈肌腱之间。",
        "quickFind": "微屈腕握拳，从腕横纹向上量很指，两条索状筋之间即是。",
        "massage": "用拇指指腹用力按压间使，有酸胀感为宜，一般按摩3~5分钟，即可消除打嗝症状。",
        "xueweiName": "间使"
      },
      {
        "detailTitle": "内关：心脏健康的卫士",
        "detailDescription": "内，内外之内；关，关隘。穴在前臂内侧要处，犹如关隘。",
        "cure": "宁心安神，和胃降逆，理气镇痛。主治心痛、心悸、失眠、癫痫、胃痛、呕吐、打嗝、哮喘、高血压、低血压、冠心病、汗多、神经性皮炎、小儿惊风。",
        "position": "在前臂前区，腕掌侧远端横纹上2寸，掌长肌腱与桡侧腕屈肌腱之间。",
        "quickFind": "微屈腕握拳，从腕横纹向上量飛指，两条索状筋之间即是内关。",
        "massage": "用左手拇指指尖按压右侧内关10~15分钟，每日2~3次；再用右手按压左侧内关，反复操作。可改善风湿性心脏病、心肌炎、冠心病、心绞痛、心律不齐等症状。",
        "xueweiName": "内关"
      },
      {
        "detailTitle": "大陵：牙肿口臭不见了",
        "detailDescription": "大，大小之大；陵，丘陵。掌根突起部如同丘陵，穴在其腕侧凹陷中。",
        "cure": "宁心安神，和营通络，宽胸和胃。主治身热、头痛、扁桃体炎、咽炎、肾虚、失眠。",
        "position": "在腕前区，腕掌侧远端横纹中，掌长肌腱与楼侧腕屈肌腱之间。",
        "quickFind": "微屈腕握拳，从腕横纹上，两条索状筋之间即是。",
        "massage": "用拇指指尖垂直掐按大陵，每天早晚两侧各掐按1~3分钟。以治疗心胸痛、胃炎、扁桃体炎等疾病。",
        "xueweiName": "大陵"
      },
      {
        "detailTitle": "劳宫：开窍醒神解疲劳",
        "detailDescription": "劳，劳动；宫，中央。手司劳动，劳指手。穴在手掌部的中央。",
        "cure": "清心泻热，开窍醒神，消肿止痒。主治热病、汗多、心烦、口腔溃疡、中风昏迷、高脂血症。",
        "position": "在掌区，横平第3掌指关节近端，第2、第3掌骨之间偏于第3掌骨。",
        "quickFind": "握拳屈指，中指尖所指掌心处，按压有酸痛感处即是。",
        "massage": "用拇指指腹揉按劳宫，每次1~3分钟，可治腹泻，用拇指尖掐按可治中风昏迷、中暑等急症。",
        "xueweiName": "劳宫"
      },
      {
        "detailTitle": "中冲：晕车中暑一按消",
        "detailDescription": "中，中间；冲，冲动，涌出。穴在中指端，心包经之井穴，经气由此涌出，沿经脉上行。",
        "cure": "苏厥开窍，清心泻热。主治心痛、心悸、中风、中暑、目赤、舌痛、小儿惊风。",
        "position": "在手指，中指末端最高点。",
        "quickFind": "俯掌，在手中指尖端的中央取穴。",
        "massage": "用较重的手法掐中冲；或用硬物，如发夹，捻按中冲约10秒钟，可治疗晕车、中风昏迷、中暑等症状。",
        "xueweiName": "中冲"
      },
      {
        "detailTitle": "关冲：远离更年期烦恼",
        "detailDescription": "关，通“弯”，指无名指；冲，冲要。穴在无名指端，经气由此涌出，沿经上行。",
        "cure": "泻热开窍，清利喉舌，活血通络。主治头痛、咽喉肿痛、视物不明、肘痛。",
        "position": "在手指，第4指末节尺侧，指甲根角侧上方0.1寸（指寸）。",
        "quickFind": "沿手无名指指甲底部与侧缘引线的交点处即是。",
        "massage": "用拇指指尖掐按关冲1~3分钟，可缓解更年期症状，如心慌气短、性欲减退等。",
        "xueweiName": "关冲"
      },
      {
        "detailTitle": "液门：清火散热有奇效",
        "detailDescription": "液，水液；门，门户。此为本经荥穴，属水，有通调水道之功，犹如水气出入之门户。",
        "cure": "清头目，利三焦，通络止痛。主治手背红肿、五指拘挛、腕部无力、热病。",
        "position": "在手背，当第4、第5指间，指蹊缘后方赤白肉际处。",
        "quickFind": "抬臂俯掌，手背部第4、第5指指缝间掌指关节前可触及一凹陷处即是。",
        "massage": "每天早晚用拇指指腹按揉液门200次左右，可缓解头痛、目眩、咽喉肿痛、眼睛赤涩、龋齿等病症。",
        "xueweiName": "液门"
      },
      {
        "detailTitle": "中渚：颈肩背痛常用穴",
        "detailDescription": "中，中间；渚，水中小块陆地。穴在五输流注穴之中间，经气如水循渚而行。",
        "cure": "清热通络，开窍益聪。主治前臂疼痛、脂溢性皮炎、头痛、目眩、耳聋。",
        "position": "在手背，第4、第5掌骨间，第4掌指关节近端凹陷中。",
        "quickFind": "抬臂俯掌，手背部第4、第5指指缝间掌指关节后可触及凹陷处即是。",
        "massage": "每次按摩左右中渚各1~3分钟，可治肢体关节肿痛以及屈伸不利之症。",
        "xueweiName": "中渚"
      },
      {
        "detailTitle": "阳池：驱走手脚的寒冷",
        "detailDescription": "阳，阴阳之阳；池，池塘。穴在腕背凹陷中，经气至此如水入池塘。",
        "cure": "清热通络，通调三焦，益阴增液。主治腕关节肿痛、手足怕冷、口干、糖尿病。",
        "position": "在腕后区，腕背侧远端横纹上，指总伸肌腱的尺侧缘凹陷中。",
        "quickFind": "抬臂垂腕，背面，由第4掌骨向上推至腕关节横纹，可触及凹陷处即是。",
        "massage": "用中指指腹按摩阳池，可改善女性在经期、孕期和产褥期出现的手脚冰凉状况。",
        "xueweiName": "阳池"
      },
      {
        "detailTitle": "外关：缓解腰痛治风湿",
        "detailDescription": "外，内外之外；关，关隘。穴在前臂外侧要处，犹如关隘。",
        "cure": "清热解表，通经活络。主治感冒、头痛、三叉神经痛、颈椎病、落枕。",
        "position": "在前臂外侧，腕背侧远端横纹上2寸，尺骨与桡骨间隙中点。",
        "quickFind": "抬臂俯掌，掌腕背横纹中点直上3横指，前臂两骨头之间的凹陷处即是。",
        "massage": "用拇指揉、点外关，力量由轻到重，以穴位下有酸胀感为度，可治腰痛、手臂疼痛、偏头痛、风湿等症。",
        "xueweiName": "外关"
      },
      {
        "detailTitle": "支沟：排除体内的毒素",
        "detailDescription": "支，通“肢”；沟，沟渠。支，在此指上肢。穴在上肢尺骨与桡骨间沟中。",
        "cure": "清利三焦，通腑降逆。主治胸胁痛、腹胀、便秘、心绞痛、上肢瘫痪。",
        "position": "在前臂外侧，腕背侧远端横纹上3寸，尺骨与桡骨间隙中点。",
        "quickFind": "抬臂俯掌，掌腕背横纹中点直上4横指，前臂两骨头之间的凹陷处即是。",
        "massage": "按揉支沟3~5分钟，可清除体内堆积宿便，防止便秘、腹胀。",
        "xueweiName": "支沟"
      },
      {
        "detailTitle": "会宗：温通经脉治耳鸣",
        "detailDescription": "会，会合；宗，集聚。此为三焦经郄穴，是经气会聚之处。",
        "cure": "清利三焦，安神定志，疏通经络。主治偏头痛、耳聋、耳鸣、咳喘胸满、臂痛。",
        "position": "在前臂外侧，腕背侧远端横纹上3寸，尺骨的桡侧缘。",
        "quickFind": "抬臂俯掌，掌腕背横纹中点直上4横指，拇指侧按压有酸胀感处即是。",
        "massage": "常用食指指腹揉按会宗，有温通经脉的功效，可预防听力和视力减退。",
        "xueweiName": "会宗"
      },
      {
        "detailTitle": "三阳络：治疗耳聋与牙痛",
        "detailDescription": "三阳，指手三阳经；络，联络。本穴联络手之三条阳经。",
        "cure": "舒筋通络，开窍镇痛。主治前臂酸痛、耳聋、牙痛、脑血管病后遗症。",
        "position": "在前臂外侧，腕背侧远端横纹上4寸，尺骨与桡骨间隙中点。",
        "quickFind": "先找到支沟，直上1横指，前臂两骨头之间凹陷处即是。",
        "massage": "用拇指指甲垂直下压三阳络，揉按3分钟，先左后右，可有效缓解牙痛。",
        "xueweiName": "三阳络"
      },
      {
        "detailTitle": "四渎：咽喉肿痛有特效",
        "detailDescription": "四，四个；渎，河流。古称长江、黄河、淮河、济水为四渎。经气至此，渗灌更广，故喻称四渎。",
        "cure": "开窍聪耳，清利咽喉。主治咽喉肿痛、耳聋、耳鸣、头痛、下牙痛、眼疾。",
        "position": "在前臂外侧，肘尖下5寸，尺骨与桡骨间隙中。",
        "quickFind": "先找到阳池，其与肘尖连线的中点上1横指处即是。",
        "massage": "经常对四渎进行点按，每次~3分钟，可以预防耳鸣、耳聋，对偏头痛、牙痛也有很好的调理作用。",
        "xueweiName": "四渎"
      },
      {
        "detailTitle": "天井：淋巴结核不用怕",
        "detailDescription": "天，天空；井，水井。喻上为天。穴在上肢鹰嘴窝，其陷如井。",
        "cure": "行气散结，安神通络。主治前臂酸痛、淋巴结核、落枕、偏头痛。",
        "position": "在肘后侧，肘尖上1寸凹陷中。",
        "quickFind": "屈肘，肘尖直上1横指凹陷处即是。",
        "massage": "用一手轻握另一手肘下，弯曲中指以指尖垂直向上按摩天井，每天早晚各按1次，每次左右各1~3分钟。可治疗麦粒肿、淋巴结核。",
        "xueweiName": "天井"
      },
      {
        "detailTitle": "清冷渊：着急上火就揉它",
        "detailDescription": "清泠，清凉；渊，深水。本穴具有清三焦之热的作用，犹如入清凉深水之中。",
        "cure": "疏散风寒，通经止痛。主治前臂及肩背部酸痛不举、头项痛、眼疾。",
        "position": "在臂后侧，肘尖与肩峰角连线上，肘尖上2寸。",
        "quickFind": "屈肘，肘尖直上3横指凹陷处即是。",
        "massage": "用中指指腹揉清泠渊1~3分钟，可缓解着急上火、嗓子痛、牙痛、眼睛。",
        "xueweiName": "清冷渊"
      },
      {
        "detailTitle": "消泺：有效治疗各种痛",
        "detailDescription": "消，消除；泺，小水、沼泽。本穴属三焦经，具有通调水道的作用。",
        "cure": "清热安神，活络止痛。主治颈项强急肿痛、臂痛、头痛、牙痛。",
        "position": "在臂后侧，肘尖与肩峰角连线上，肘尖上5寸。",
        "quickFind": "先取肩髎，其与肘尖连线上，肘尖上7横指处即是。",
        "massage": "四指并拢向消泺施加压力，一压一松，持续3~5分钟为宜，可治头痛、颈项强痛、臂痛、牙痛等疾病。",
        "xueweiName": "消泺"
      },
      {
        "detailTitle": "臑会：专治肩膀疼与痛",
        "detailDescription": "臑，上臂肌肉隆起处；会，交会。穴在上臂肌肉隆起处，为三焦经和阳维脉之交会处。",
        "cure": "化痰散结，通络止痛。主治肩胛肿痛、肩臂酸痛。",
        "position": "在臂后侧，平腋后纹头，三角肌的后下缘。",
        "quickFind": "先取肩髎，其与肘尖连线上，肩髎下4横指处即是。",
        "massage": "经常拿捏臑会，每次1〜3分钟，可以预防肩关节炎、上肢麻痹等症。",
        "xueweiName": "臑会"
      },
      {
        "detailTitle": "肩髎：缓解肩痛与臂痛",
        "detailDescription": "肩，肩部；髎，骨隙。穴在肩部骨隙中。",
        "cure": "祛风湿，通经络。主治肩胛肿痛、肩臂痛、中风偏瘫、尊麻疹。",
        "position": "在肩部，肩峰角与肱骨大结节两骨间凹陷中。",
        "quickFind": "外展上臂，肩膀后下方凹陷处即是。",
        "massage": "用拇指、食指和中指拿捏肩髎3~5分钟，每天早晚各1次。可缓解臂痛不能举、胁肋疼痛等症状。",
        "xueweiName": "肩髎"
      },
      {
        "detailTitle": "天髎：治疗颈项强直痛",
        "detailDescription": "天，天空；髎，骨隙。上为天。穴在肩胛冈上方之骨隙中。",
        "cure": "祛风除湿，通经止痛。主治肩臂痛、颈项僵硬疼痛、胸中烦满。",
        "position": "在肩胛骨上角处，当肩井与曲垣之间的中点，横平第1胸椎棘突。",
        "quickFind": "肩胛骨上角，其上方的凹陷处即是。",
        "massage": "用中指指腹揉按天髎，以有酸胀感为宜，可治肩臂痛、颈项僵硬疼痛。",
        "xueweiName": "天髎"
      },
      {
        "detailTitle": "天牖：缓解颈肩酸与痛",
        "detailDescription": "天，天空；牖，窗。上为天，穴在侧颈部上方，本穴能开上窍，故喻为天窗。",
        "cure": "清头明目，通经活络。主治头痛、头晕、颈肩酸痛、目痛、耳鸣、喉痛。",
        "position": "在项后，横平下颌角，胸锁乳突肌的后缘凹陷中。",
        "quickFind": "乳突后方直下平下颌角的凹陷处即是。",
        "massage": "常用中指指腹轻轻按摩天牖，每次3~5分钟，对肩颈不适有良好的调理作用。",
        "xueweiName": "天牖"
      },
      {
        "detailTitle": "翳风：快速止嗝就按它",
        "detailDescription": "翳，遮蔽；风，风邪。穴当耳垂后方，为遮蔽风邪之处。",
        "cure": "聪耳通窍，散内泻热。主治打嗝、中耳炎、三叉神经痛、牙痛、颊肿、失眠。",
        "position": "在颈部，耳垂后方，乳突下端前方凹陷中。",
        "quickFind": "头偏向一侧，将耳垂下压，所覆盖范围中的凹陷处即是。",
        "massage": "用手指尖大力按压翳风，一般5分钟内就可以止嗝。",
        "xueweiName": "翳风"
      },
      {
        "detailTitle": "瘈脉：小儿惊风疗效佳",
        "detailDescription": "瘈，瘈疭，指络脉。穴在耳后络脉，有治瘈疭的作用。",
        "cure": "熄风解痉，活络通窍。主治头痛、耳聋、耳鸣、小儿惊风、呕吐。",
        "position": "在头部，乳突中央，角孙至翳风沿耳轮弧形连线的上2/3与下1/3交点处。",
        "quickFind": "沿翳风和角孙做耳轮连线，连线的上2/3与下1/3交点处即是。",
        "massage": "将食指和中指并拢轻轻贴于耳后根处，顺时针方向按摩瘈脉1~3分钟，每天早晚各1次。可治头痛、耳鸣、耳聋等症。",
        "xueweiName": "瘈脉"
      },
      {
        "detailTitle": "颅息：头痛耳鸣揉颅息",
        "detailDescription": "颅，头颅；息，安宁。穴在头颅部，可安脑宁神。",
        "cure": "通窍聪耳，泻热镇惊。主治耳鸣、头痛、耳聋、小儿惊风、呕吐。",
        "position": "在头部，角孙至翳风沿耳轮弧形连线的上1/3与下2/3交点处。",
        "quickFind": "先找到翳风和角孙，二者之间做耳轮连线，连线的上1/3与下1/3交点处即是。",
        "massage": "将食指和中指贴于耳后根处按摩1~3分钟，可治头痛、耳鸣、耳聋、中耳炎等症。",
        "xueweiName": "颅息"
      },
      {
        "detailTitle": "角孙：保护眼睛不受伤",
        "detailDescription": "角，角隅；孙，孙络。穴在颞额部，相当于耳上角对应处，而有孙络。",
        "cure": "清热消肿，散风止痛。主治目赤肿痛、牙痛、头痛、颈项僵硬。",
        "position": "在侧头部，耳尖正对发际处。",
        "quickFind": "在头部，将耳郭折叠向前，找到耳尖，耳尖直上入发际处即是。",
        "massage": "用拇指指腹揉按角孙，每次1~3分钟，对白内障、目生翳膜、齿龈肿痛等疾病疗效明显。",
        "xueweiName": "角孙"
      },
      {
        "detailTitle": "耳门：保护耳朵有绝招",
        "detailDescription": "耳，耳窍；门，门户。穴在耳前，犹如耳之门户。",
        "cure": "开窍聪耳，泻热活络。主治耳鸣、耳聋、耳道流脓、中耳炎、牙痛。",
        "position": "在耳前，耳屏上切迹与下颌骨髁突之间的凹陷中。",
        "quickFind": "耳屏上缘的前方，张口有凹陷处即是。",
        "massage": "每天早晚各揉按耳门1次，每次1~3分钟，可改善和治疗耳鸣、中耳炎、耳道炎、重听等耳部疾病。",
        "xueweiName": "耳门"
      },
      {
        "detailTitle": "耳和髎：五官疾病不苦恼",
        "detailDescription": "耳，耳窍；和，调和；髎，骨隙。穴当耳前骨的前表陷隙中，可调耳和声。",
        "cure": "祛风通络，解痉止痛。主治牙关拘急、口眼歪斜、头重痛、耳鸣。",
        "position": "在头部，鬓发后缘，耳郭根的前方，颞浅动脉的后缘。",
        "quickFind": "在头侧部，鬓发后缘作垂直线，耳郭根部作水平线，二者交点处即是。",
        "massage": "常用中指指腹轻轻按摩耳和髎，每次3~5分钟，可预防面部痉挛，调理头重、中风后遗症等疾病。",
        "xueweiName": "耳和髎"
      },
      {
        "detailTitle": "丝竹空：头痛头晕都点它",
        "detailDescription": "丝竹，即细竹；空，空隙。眉毛，状如细竹。穴在眉梢之凹陷处。",
        "cure": "清头明目，散骨镇惊。主治头痛、头晕、目赤肿痛、视神经萎缩。",
        "position": "在面部，眉梢凹陷中。",
        "quickFind": "在面部，眉毛外侧缘眉梢凹陷处。",
        "massage": "用拇指指腹向内揉按左右丝竹空，每次1〜3分钟，有酸、胀、痛的感觉为宜，可治各种头痛、头晕、目眩、目赤疼痛等疾病。",
        "xueweiName": "丝竹空"
      },
      {
        "detailTitle": "瞳子髎：治疗眼花特效穴",
        "detailDescription": "瞳子，即瞳孔；髎，骨隙。穴在小眼角外方骨隙中，横对瞳孔。",
        "cure": "平肝熄风，明目退翳。主治目痛、角膜炎、青光眼、视神经萎缩等。",
        "position": "在面部，目外眦外侧0.5寸凹陷中。",
        "quickFind": "正坐，目外眦旁，眼眶外侧缘处。",
        "massage": "用两手拇指用力垂直揉按瞳子髎，每天早晚各揉按1次，每次1~3分钟。可治目赤肿痛、角膜炎、屈光不正、青光眼等症。",
        "xueweiName": "瞳子髎"
      },
      {
        "detailTitle": "听会：改善耳鸣与耳聋",
        "detailDescription": "听，听觉；会，聚会。穴在耳前，功司耳闻，为耳部经气聚会之处。",
        "cure": "开窍聪耳，通经活络。主治头痛、下颌关节炎、口眼歪斜、耳鸣、耳聋。",
        "position": "在面部，耳屏间切迹与下颌骨髁突之间的凹陷中。",
        "quickFind": "正坐，耳屏下缘前方，张口有凹陷处即是。或先取下关，向上推至额弓上缘的凹陷中即是。",
        "massage": "耳聋耳鸣时，用拇指指尖垂直按压听会，每次用，直到症状缓和为止。",
        "xueweiName": "听会"
      },
      {
        "detailTitle": "上关：口眼歪斜可按它",
        "detailDescription": "",
        "cure": "聪耳镇痉，散风活络。主治头痛、眩晕、偏风、口眼斜、耳鸣、耳聋。",
        "position": "在面部，额弓上缘中央凹陷中。",
        "quickFind": "正坐，耳屏往前量2横指，耳前额骨弓上侧凹陷处即是。",
        "massage": "用中指指腹轻轻揉按上关1~3分钟，可治疗耳鸣、耳聋、牙痛、口眼歪斜等病。",
        "xueweiName": "上关"
      },
      {
        "detailTitle": "颔厌：五官疾病不苦恼",
        "detailDescription": "颔，下颔；厌，顺从。穴在颛额处，随咀嚼顺从下颌运动。",
        "cure": "清热散风，通络止痛。主治头痛、眩晕、偏头痛、颈项痛、耳鸣、耳聋。",
        "position": "在头部，从头维至曲鬓的弧形连线的上1/4与下3/4的交点处。",
        "quickFind": "先找到头维和曲鬓，两穴连线的上1/4处即是。",
        "massage": "用中指指腹垂直揉按颔厌，以有胀痛的感觉为宜，每天早晚各揉按1次，每次1~3分钟，可治五官科疾病。",
        "xueweiName": "颔厌"
      },
      {
        "detailTitle": "悬颅：集中精力不走神",
        "detailDescription": "悬，悬挂；颅，头颅。穴在颞颥部，如悬挂在头颅之两侧。",
        "cure": "通络消肿，清热散风。主治偏头痛、目外眦红肿、牙痛、神经衰弱。",
        "position": "在头部，头维至曲鬓的弧形连线的中点处。",
        "quickFind": "先找到头维和曲鬓，两穴连线的中点处即是。",
        "massage": "许多孩子在学习的时候容易分心，注意力不集中，家长可以帮助孩子多揉揉悬颅，每次1~3分钟，有助于孩子集中注意力。",
        "xueweiName": "悬颅"
      },
      {
        "detailTitle": "悬厘：偏头痛的终结者",
        "detailDescription": "悬，悬垂；厘，同“毛”，指头发。穴在颞颥颗蔽部，位于悬垂的长发之中。",
        "cure": "通络止痛，清热散风。主治热病汗不出、头痛、眩晕、三叉神经痛。",
        "position": "在头部，从头维至曲鬓的弧形连线（其弧度与鬓发弧度相应）的上3/4与下1/4的交点处。",
        "quickFind": "先找到头维和曲鬓，两穴连线的下1/4处即是。",
        "massage": "头晕目眩时，用食指和中指轻轻揉按悬厘，不适很快就能缓解；重按悬厘，可止偏头痛。",
        "xueweiName": "悬厘"
      },
      {
        "detailTitle": "曲鬓：牙痛颊肿就揉它",
        "detailDescription": "曲，弯曲；鬓，鬓发。穴在耳上鬓发边际的弯曲处。",
        "cure": "清热止痛，活络通窍。主治头痛、眩晕、口眼㖞斜、牙痛、颊肿。",
        "position": "鬓角发际后缘与耳尖水平线的交点处。",
        "quickFind": "在耳前鬓角发际后缘作垂直线，与耳尖水平线相交处即是。",
        "massage": "用中指指腹垂直揉按曲鬓1~3分钟，可治疗头痛、牙痛、颊肿等症。",
        "xueweiName": "曲鬓"
      },
      {
        "detailTitle": "率谷：艾灸可治偏头痛",
        "detailDescription": "率，统率；谷，山谷。穴在耳上，为以“谷”命名诸穴的最高者，如诸谷的统帅。",
        "cure": "平肝熄风，疏经活络。主治头痛、眩晕、小儿惊风、胃寒、呕吐。",
        "position": "在头部，耳尖直上入发际1.5寸。",
        "quickFind": "角孙直上2横指处。",
        "massage": "头痛时，依头痛的程度，每天用清艾条悬灸率谷3~5次，每次15分钟，或由前向后推抹率谷50-100次，可止偏头痛。",
        "xueweiName": "率谷"
      },
      {
        "detailTitle": "天冲：牙龈肿痛找天冲",
        "detailDescription": "天，天空；冲，冲出。天，指头部，穴在其两侧，胆经气血在本穴冲向巅顶。",
        "cure": "祛风定惊，清热消肿，益气补阳。主治头痛、眩晕、癫痫、呕吐、牙龈肿痛。",
        "position": "在头部，耳根后缘直上，入发际2寸。",
        "quickFind": "耳根后缘，直上入发际团黄指处即是。",
        "massage": "头痛、牙龈肿痛时，可用中指指腹轻轻按摩天冲，很快就能止痛，效果非常好。",
        "xueweiName": "天冲"
      },
      {
        "detailTitle": "浮白：专治头发白与花",
        "detailDescription": "浮，浮浅；白，光明。穴位于体表浮浅部位，有清头明目之功。",
        "cure": "理气散结，散风止痛。主治头痛、发白、颈项强痛、胸痛、打嗝、耳聋。",
        "position": "在头部，耳后乳突的后上方，天冲与完骨弧形连线（其弧度与鬓发弧度相应）的上1/3与下2/3交点处。",
        "quickFind": "先找到天冲和完骨，二者弧形连线上1/3处即是。",
        "massage": "用中指指腹每天早晚各揉按浮白1~3分钟，可治经常熬夜不睡觉或者经常失眠而引起的头发白。",
        "xueweiName": "浮白"
      },
      {
        "detailTitle": "头窍阴：耳鸣耳聋不担忧",
        "detailDescription": "头，头部；窍，空窍；阴，阴阳之阴。肝肾属阴，开窍于耳目。穴在头部，可治疗耳目之疾。",
        "cure": "平肝镇痛，开窍聪耳。主治头痛、眩晕、耳鸣、耳聋、牙痛、口苦。",
        "position": "在头部，当天冲与完骨的弧形连线（其弧度与耳郭弧度相应）的上2/3与下1/3交点处。",
        "quickFind": "先找到天冲和完骨，二者弧形连线下1/3处即是。",
        "massage": "每天早晚各揉按头窍阴1次，每次1~3分钟，可改善和治疗耳鸣、耳聋等耳部疾病。",
        "xueweiName": "头窍阴"
      },
      {
        "detailTitle": "完骨：常按可改善贫血",
        "detailDescription": "完骨，即颞骨乳突。穴在耳后颞骨乳突下缘。",
        "cure": "通络宁神，祛风清热。主治头痛、眩晕、耳鸣、耳聋、失眠、失语症。",
        "position": "在头部，耳后乳突的后下方凹陷中。",
        "quickFind": "耳后明显突起，其下方凹陷处即是。",
        "massage": "每天用拇指指腹揉按完骨1~3分钟，对五官疾病具有明显的治疗效果。",
        "xueweiName": "完骨"
      },
      {
        "detailTitle": "本神：头痛目眩就按它",
        "detailDescription": "本，根本；神，神志。穴在前发际神庭旁。内为脑之所在；脑为元神之府，主神志，为人之根本。",
        "cure": "祛风定惊，安神止痛。主治头痛、眩晕、颈项强直、中风、小儿惊风。",
        "position": "前发际上0.5寸，头正中线旁开3寸。",
        "quickFind": "正坐，从外眼角直上入发际半横指，按压有酸痛感处即是。",
        "massage": "每天早晚各按摩本神1次，每次1~3分钟，可有效治疗头痛、目眩等疾病。",
        "xueweiName": "本神"
      },
      {
        "detailTitle": "阳白：眼部不适按按它",
        "detailDescription": "阳，阴阳之阳；白，光明。头为阳，穴在头面部，有明目之功。",
        "cure": "清头明目，祛风泻热。主治头痛、颈项强直、角膜痒痛、近视、面瘫。",
        "position": "在头部，眉上1寸，瞳孔直上。",
        "quickFind": "正坐，眼向前平视，自眉中直上1横指处即是。",
        "massage": "将中指指腹置于阳白上，垂直揉按1~3分钟，能有效治疗眼疾。",
        "xueweiName": "阳白"
      },
      {
        "detailTitle": "头临泣：头痛鼻塞及时了",
        "detailDescription": "头，头部；临，调治；泣，流泪。穴在头部，可调治迎风流泪等病。",
        "cure": "聪耳明目，安神定志。主治头痛、目眩、目赤肿痛、耳鸣、耳聋。",
        "position": "在头部，前发际上0.5寸，瞳孔直上。",
        "quickFind": "正坐，眼向前平视，自眉中直上半横指处即是。",
        "massage": "每天早晚各揉按头临泣1~3分钟，可改善和治疗头痛、目痛、鼻塞、鼻窦炎等疾病。",
        "xueweiName": "头临泣"
      },
      {
        "detailTitle": "目窗：擦亮眼睛看更清",
        "detailDescription": "目，眼睛；窗，窗户。穴在眼的上方，善治眼疾，犹如眼目之窗。",
        "cure": "明目开窍，祛风定惊。主治头痛、头晕、小儿惊风、白内障、近视。",
        "position": "在头部，前发际上1.5寸，瞳孔直上。",
        "quickFind": "正坐，眼向前平视，自眉中直上，前发际直上2横指处即是。",
        "massage": "将中指指腹置于目窗上垂直揉按，每天早晚各1次，每次1~3分钟，可有效治疗目痛、目眩、近视、远视等眼疾。",
        "xueweiName": "目窗"
      },
      {
        "detailTitle": "正营：专治头痛与头晕",
        "detailDescription": "正，正当；营，同“荣”。正营，惶恐不安的意思。本穴主治惶恐不安等神志病。",
        "cure": "平肝明目，疏风止痛。主治头痛、头晕、目痛、眩晕、呕吐、惶恐不安。",
        "position": "在头部，前发际上2.5寸，瞳孔直上。",
        "quickFind": "取前发际到百会的中点作一水平线，再找到目窗作一垂直线，两线交点处即是。",
        "massage": "头痛头晕时，用手指指腹掐揉正营，可快速缓解。",
        "xueweiName": "正营"
      },
      {
        "detailTitle": "承灵：面部痉挛按按它",
        "detailDescription": "承，承受；灵，神灵。脑主神灵，故脑上顶骨又称天灵骨，穴就在其外下方。",
        "cure": "通利官窍，散风清热。主治头痛、眩晕、目痛、风寒、鼻塞、鼻出血。",
        "position": "在头部，前发际上4寸，瞳孔直上。",
        "quickFind": "先找到百会，向前1横指作一水平线，再找到目窗作一垂直线，两线交点处即是。",
        "massage": "经常用中指指腹按压承灵，每次1~3分钟，对面部痉挛有良好的调理作用。",
        "xueweiName": "承灵"
      },
      {
        "detailTitle": "脑空：后脑疼痛不要怕",
        "detailDescription": "脑，脑髓；空，空窍。穴在枕骨外侧，内通脑窍，主治脑病。",
        "cure": "散风清热，醒脑宁神。主治头痛、耳聋、癫痫、眩晕、身热、颈强、惊悸。",
        "position": "横平枕外隆凸的上缘，风池直上。",
        "quickFind": "在后脑勺摸到隆起的最高骨，上缘外约飛指凹陷处即是。",
        "massage": "用双手拇指指腹揉按脑空，每次不少于30下，对头痛、耳聋等症有明显疗效。",
        "xueweiName": "脑空"
      },
      {
        "detailTitle": "风池：疏风散寒治感冒",
        "detailDescription": "风，风邪；池，池塘。穴在枕骨下，局部凹陷如池，乃祛风之要穴。",
        "cure": "平肝熄风，祛风散毒。主治外感发热、头痛、眩晕、等麻疹、黄褐斑、小儿脊柱侧弯、高血压。",
        "position": "在项后，枕骨之下，胸锁乳突肌上端与斜方肌上端之间的凹陷中。",
        "quickFind": "正坐，后头骨下两条大筋外缘陷窝中，与耳垂齐平处即是。",
        "massage": "以双手拇指指腹由下往上揉按风池，以有酸胀感为宜。每次按压不少于30下，可治各种头痛。",
        "xueweiName": "风池"
      },
      {
        "detailTitle": "肩井：治疗落枕与肩痛",
        "detailDescription": "肩，肩部；井，水井。穴在肩上，局部凹陷如井。",
        "cure": "祛风清热，活络消肿。主治肩臂疼痛、落枕、颈椎病、肩周炎、抑郁症、乳房胀痛、小儿脊柱侧弯、更年期综合征。",
        "position": "在肩胛区，第7颈椎棘突与肩峰最外侧点连线的中点。",
        "quickFind": "先找到大椎，再找到锁骨肩峰端，二者连线中点即是。",
        "massage": "按摩肩井，可缓解落枕和肩酸背痛等症；拿捏肩井，可发汗解表治感冒。",
        "xueweiName": "肩井"
      },
      {
        "detailTitle": "渊腋：腋窝汗多不用愁",
        "detailDescription": "渊，深潭；腋，腋部。穴在腋下。",
        "cure": "理气宽胸，消肿止痛。主治胸满、胁痛、腋下汗多、腋下肿、臂痛不举。",
        "position": "在胸外侧，第4肋间隙中，在腋中线上。",
        "quickFind": "正坐举臂，从腋横纹水平沿腋中线直下儂指处即是。",
        "massage": "用食指或中指点按渊腋，每次3~5分钟，对治疗腋下汗多特别有效。",
        "xueweiName": "渊腋"
      },
      {
        "detailTitle": "辄筋：养肝护肝好帮手",
        "detailDescription": "辄，车耳，马车的护轮板；筋，筋肉。两侧胁肋肌肉隆起，形如车耳，穴在其处。",
        "cure": "降逆平喘，理气止痛。主治咳嗽、气喘、呕吐、肋间神经痛。",
        "position": "在胸外侧，第4肋间隙中，腋中线前1寸。",
        "quickFind": "正坐举臂，从渊腋向前下量1横指处即是。",
        "massage": "每天用食指指腹揉按辄筋1~3分钟，可有效治疗气喘、胸胁痛、呕吐等疾病。",
        "xueweiName": "辄筋"
      },
      {
        "detailTitle": "日月：主治胆囊的疾病",
        "detailDescription": "日，太阳；月，月亮。日为阳，指胆；月为阴，指肝。此为治肝胆疾病的要穴。",
        "cure": "利胆疏肝，降逆和胃。主治肋间神经痛、肝炎、抑郁症、口苦、胆囊炎。",
        "position": "在胸部，第7肋间隙，前正中线旁开4寸。",
        "quickFind": "正坐或仰卧，自乳头垂直向下推3个肋间隙，按压有酸胀感处即是。",
        "massage": "日月以治疗胆囊炎、胆结石、胆绞痛等胆本身疾病为主。稍用力指压，效果较好。",
        "xueweiName": "日月"
      },
      {
        "detailTitle": "京门：健脾温阳止腹泻",
        "detailDescription": "京，同“原”字；门，门户。此为肾之募穴。穴之所在为肾气出入的门户。",
        "cure": "补肾通淋，健脾温阳。主治胁肋痛、腹胀、腹泻、腰痛、尿黄、肾炎。",
        "position": "在上腹部，第12肋骨游离端下际。",
        "quickFind": "章门后2横指处即是。",
        "massage": "用拇指指腹按揉京门，对腹胀、腹泻、肠鸣等胃肠疾病有良好疗效。",
        "xueweiName": "京门"
      },
      {
        "detailTitle": "带脉：调经止带效果好",
        "detailDescription": "带，腰带；脉，经脉。穴属胆经，交会在带脉之上。",
        "cure": "健脾利湿，调经止带。主治月经不调、赤白带下、闭经、痛经、不孕。",
        "position": "在侧腹部，第11肋骨游离端垂线与脐水平线的交点上。",
        "quickFind": "腋中线与肚脐水平线相交处即是。",
        "massage": "月经不调、白带异常者可在每天早上起床后，手握空拳，敲击带脉100次。",
        "xueweiName": "带脉"
      },
      {
        "detailTitle": "五枢：妇科疾病的福音",
        "detailDescription": "五，五个；枢，枢纽。五为中数，少阳主枢；意指穴在人身体中部的枢要之处。",
        "cure": "调经止带，调理下焦。主治月经不调、子宫内膜炎、痛经。",
        "position": "在下腹部，横平脐下3寸，骼前上棘内侧。",
        "quickFind": "从肚脐向下4指处作水平线，与骼前上棘相交处即是。",
        "massage": "常按揉五枢，可治痛经、带下、月经不调等妇科病症。",
        "xueweiName": "五枢"
      },
      {
        "detailTitle": "维道：消除四肢的浮肿",
        "detailDescription": "维，维系；道，通道。本穴为胆经与带脉之会，带脉维系诸经。",
        "cure": "调理冲任，利水止痛。主治四肢浮肿、盆腔炎、附件炎、子宫脱垂。",
        "position": "在下腹部，骼前上棘内下0.5寸。",
        "quickFind": "先找到五枢，其前下半横指处即是。",
        "massage": "以两手拇指自上向下摩动维道，每次左右各按摩1~3分钟，以减轻腰背疼痛、腰肌劳损、下肢瘫痹、膝关节炎等慢性病带来的不适。",
        "xueweiName": "维道"
      },
      {
        "detailTitle": "居髎：针对腰腿疼与痛",
        "detailDescription": "居，居处；髎，近骨之凹陷处。穴居髋骨上凹陷处。",
        "cure": "舒筋活络，益肾强腰。主治腰腿痹痛、月经不调、白带过多。",
        "position": "在臀区，骼前上棘与股骨大转子最凸点连线的中点处。",
        "quickFind": "骼前上棘是侧腹隆起的骨性标志，股骨大转子是骼部最隆起处，二者连线中点即是。",
        "massage": "两手拇指自上向下摩动居髎，每次左右各按摩1~3分钟，可治腰腿痹痛、瘫痪等症。",
        "xueweiName": "居髎"
      },
      {
        "detailTitle": "环跳：腰腿疼痛先按它",
        "detailDescription": "环，环曲；跳，跳跃。穴在髀枢中，髀枢为环曲跳跃的枢纽。",
        "cure": "祛风化湿，强健腰膝。主治腰胯疼痛、腰痛、下肢痿痹、坐骨神经痛。",
        "position": "在臀区，股骨大转子最凸点与骶管裂孔连线上的外1/3与内2/3交点处。",
        "quickFind": "侧卧上腿弯曲，拇指横纹按在股骨大转头上，拇指指向脊柱，指尖所在凹陷处即是。",
        "massage": "常用拇指指端用力揉按环跳，每次1~3分钟，可防治下肢痿痹、膝关节痛等下肢疾病。",
        "xueweiName": "环跳"
      },
      {
        "detailTitle": "风市：常按常揉远中风",
        "detailDescription": "风，风邪；市，集市。集市有集散之意，此为疏散风邪之要穴。",
        "cure": "祛风化湿，通经活络。主治眩晕、中风、半身不遂、下肢痿痹、神经性皮炎、皮肤瘙痒、脂溢性皮炎、寻麻疹。",
        "position": "在大腿外侧中线上，当臀下横纹与腘横纹之间中点处。",
        "quickFind": "直立垂手，手掌并拢伸直，中指指尖处即是。",
        "massage": "以中指指腹垂直下压风市，以有酸、胀、麻感为宜，每次左右各按3~5分钟，先左后右，可治中风、半身不遂、下肢麻痹等症。",
        "xueweiName": "风市"
      },
      {
        "detailTitle": "中渎：常按消除胆结石",
        "detailDescription": "中，中间；渎，小的沟渠。穴在股外侧两筋之间，如在沟渎之中。",
        "cure": "祛风散寒，疏通经络。主治胆结石、下肢痿痹、半身不遂、坐骨神经痛。",
        "position": "在股部，腘横纹上5寸，骼胫束后缘。",
        "quickFind": "先找到风市，直下量3横指处即是。",
        "massage": "胆囊有问题的人，按该穴肯定很痛，每天坚持敲打对胆囊有保健和调理作用。",
        "xueweiName": "中渎"
      },
      {
        "detailTitle": "膝阳关：治疗膝痛有特效",
        "detailDescription": "膝，膝部；阳，阴阳之阳；关，机关。外为阳。穴在膝关节外侧。",
        "cure": "疏利关节，祛风化湿。主治膝关节肿痛、胭筋挛急、小腿麻木。",
        "position": "在膝部，股骨外上髁后上缘，股二头肌腱与器胫束之间的凹陷中。",
        "quickFind": "屈膝90°，膝上外侧有一高骨，其上方有一凹陷处即是。或阳陵泉直上4横指处。",
        "massage": "用中指指腹揉按膝阳关，有胀痛的感觉，可改善和治疗膝关节肿痛、挛急及小腿麻木等下肢疾病。",
        "xueweiName": "膝阳关"
      },
      {
        "detailTitle": "阳陵泉：胆囊发炎先按它",
        "detailDescription": "阳，阴阳之阳；陵，丘陵；泉，水泉。外为阳，膝外侧腓骨小头隆起如陵，穴在其下陷中，犹如水泉。",
        "cure": "利胆舒肝，强健腰膝。主治耳鸣、耳聋、口苦、坐骨神经痛、腿抽筋、甲状腺肿大、脂溢性皮炎、白瘢风、乳房胀痛、胆囊炎。",
        "position": "在小腿外侧，腓骨头前下方凹陷中。",
        "quickFind": "屈膝90°，膝关节外下方，腓骨小头前下方凹陷处即是。",
        "massage": "按摩阳陵泉，能增加胆囊的运动和排空能力，减轻胆囊内压力，缓解胆囊炎等症。",
        "xueweiName": "阳陵泉"
      },
      {
        "detailTitle": "阳交：急性疼痛找阳交",
        "detailDescription": "阳，阴阳之阳；交，交会。外为阳，穴在小腿外侧，与膀胱经交会。",
        "cure": "疏肝理气，安神定志。主治膝痛、足胫痿痹、面部浮肿、坐骨神经痛。",
        "position": "在小腿外侧，外踝尖上7寸，腓骨后缘。",
        "quickFind": "腘横纹头与外踝尖连线上，中点向下1横指，腓骨后缘处即是。",
        "massage": "用拇指指腹揉按阳交，每次1~3分钟，可治突发头痛、乳腺痛、坐骨神经痛等症。",
        "xueweiName": "阳交"
      },
      {
        "detailTitle": "外丘：止痛能手",
        "detailDescription": "夕卜，内外之外；丘，丘陵。穴在外踝上方，局部肌肉隆起如丘。",
        "cure": "舒肝理气，通络安神。主治癫疾呕沫、腹痛、脚气、小腿抽筋。",
        "position": "在小腿外侧，外踝尖上7寸，腓骨前缘。",
        "quickFind": "腘横纹头与外踝尖连线中点向下1横指，腓骨前缘处即是。",
        "massage": "按揉外丘最好采取指压带揉动的方式，每次约3分钟。可缓解急性胆囊疼痛、头痛等症。",
        "xueweiName": "外丘"
      },
      {
        "detailTitle": "光明：提高视力按光明",
        "detailDescription": "光明，即明亮的意思。为胆经络穴，主治眼病，使之重见光明。",
        "cure": "舒肝明目，活络消肿。主治目赤肿痛、视物不明、偏头痛、精神病。",
        "position": "在小腿外侧，外踝尖上5寸，腓骨前缘。",
        "quickFind": "先找到外丘，沿腓骨前缘向下3横指处即是。",
        "massage": "用中指指腹垂直按压光明，每日早晚各揉按1次，每次1~3分钟，可治近视眼、老年白内障、青光眼、视神经疾病等症。",
        "xueweiName": "光明"
      },
      {
        "detailTitle": "阳辅：熬夜头晕就按它",
        "detailDescription": "阳，阴阳之阳；辅，辅助。外为阳，辅，指辅骨，即腓骨。穴在小腿外侧用腓骨前。",
        "cure": "清热散风，疏通经络。主治胸胁痛、下肢外侧痛、膝下浮肿。",
        "position": "在小腿外侧，外踝尖上4寸，腓骨前缘。",
        "quickFind": "腘横纹头与外踝尖连线的下1/4，腓骨前缘。",
        "massage": "用拇指指腹，用力上下推动阳辅穴1~2分钟，每5分钟按摩1次，共按摩4~5次，可治疗熬夜出现的头晕、口苦等症状。",
        "xueweiName": "阳辅"
      },
      {
        "detailTitle": "悬钟：降低血压效果好",
        "detailDescription": "悬，悬挂；钟，钟铃。穴当外踝上，是古时小儿悬挂脚铃处。别名绝骨。",
        "cure": "舒肝益肾，平肝熄风。主治颈项僵硬、半身不遂、头晕、耳鸣、高血压。",
        "position": "在小腿外侧，外踝尖上3寸，腓骨前缘。",
        "quickFind": "外踝尖直上4横指处，腓骨前缘处即是。",
        "massage": "每天睡前艾灸悬钟1次，每次8分钟，可治疗高血压病人低压值偏高；经常按揉此穴，可强健筋骨，补髓充脑。",
        "xueweiName": "悬钟"
      },
      {
        "detailTitle": "丘墟：清醒头脑按丘墟",
        "detailDescription": "丘，小土堆；墟，大土堆。本穴在外踝（如墟）与跟骨滑车突（如丘）之间。",
        "cure": "健脾利湿，泻热退黄，舒筋活络。主治胸胁痛、髋关节疼痛、下肢酸痛。",
        "position": "在踝部，外踝的前下方，趾长伸肌腱的外侧凹陷中。",
        "quickFind": "脚掌用力背伸，足背可见明显趾长伸肌腱，其外侧、足外踝前下方凹陷处即是。",
        "massage": "用拇指指腹按压丘墟，每天早上按揉200次。对目赤肿痛、颈项痛、胸胁痛等疾病有良好的治疗效果。",
        "xueweiName": "丘墟"
      },
      {
        "detailTitle": "足临泣：呵护女性乳房佳",
        "detailDescription": "足，足部；临，调治；泣，流泪。穴在足部，可调治迎风流泪等眼疾。",
        "cure": "舒肝熄风，化痰消肿。主治头痛、目赤肿痛、牙痛、乳痈、胁肋痛、白带过多。",
        "position": "在足背，第4、第5跖骨底结合部的前方，第5趾长伸肌腱外侧凹陷中。",
        "quickFind": "坐位，小趾向上翘起，小趾长伸肌腱外侧凹陷中，按压有酸胀感处即是。",
        "massage": "用拇指指腹揉按足临泣，以有酸胀、微痛的感觉为宜，可治疗女性乳房疾病，如乳腺炎、乳腺增生等。",
        "xueweiName": "足临泣"
      },
      {
        "detailTitle": "地五会：足趾麻木就找它",
        "detailDescription": "地，土地；五，五个；会，会合。地在下，指足部。足部胆经穴有五，本穴居其中。",
        "cure": "舒肝消肿，通经活络。主治头痛、目眩、目赤肿痛、腋部肿痛、耳聋。",
        "position": "第4、第5跖骨间，第4跖趾关节近端凹陷中。",
        "quickFind": "小趾向上翘起，小趾长伸肌腱内侧缘处。",
        "massage": "经常用拇指指腹按揉地五会，对足趾麻木等不适有很好的调理作用。",
        "xueweiName": "地五会"
      },
      {
        "detailTitle": "侠溪：头痛目眩按一按",
        "detailDescription": "侠，通“夹”字；溪，沟溪。穴在第4、第5趾的夹缝间，局部犹如沟溪。",
        "cure": "平肝熄风，消肿止痛。主治头痛、耳鸣、贫血、肋间神经痛、高血压。",
        "position": "第4、第5趾间，趾蹊缘后方赤白肉际处。",
        "quickFind": "坐位，在足背部第4、第5趾之间连接处的缝纹头处即是。",
        "massage": "头痛目眩、耳鸣时，可按揉侠溪来缓冲。",
        "xueweiName": "侠溪"
      },
      {
        "detailTitle": "足窍阴：点刺可治头牙痛",
        "detailDescription": "足，足部；窍，孔窍；阴，阴阳之阴。肾肝属阴，开窍于耳目。穴在足部，治疗耳目之疾。",
        "cure": "疏肝解郁，通经活络。主治偏头痛、目赤肿痛、耳鸣、耳聋、胸胁痛。",
        "position": "第4趾末节外侧，趾甲根角侧后方0.1寸。",
        "quickFind": "坐位，第4趾趾甲外侧缘与下缘各作一垂线，其交点处即是。",
        "massage": "头痛和牙痛时，用5根牙签捆在一起点刺足窍阴，每次100下。",
        "xueweiName": "足窍阴"
      },
      {
        "detailTitle": "大敦：快速止血的能手",
        "detailDescription": "大，大小之大；敦，敦厚。大，指大趾。穴在大趾外侧，肌肉敦厚。",
        "cure": "回阳救逆，调经通淋。主治闭经、崩漏、遗尿、月经过多、睾丸炎。",
        "position": "在足趾，大趾末节外侧，趾甲根角侧后方0.1寸（指寸）。",
        "quickFind": "坐位，大趾趾甲外侧缘与下缘各作一垂线，其交点处即是。",
        "massage": "经常用手指点按大敦，可缓解出血症。",
        "xueweiName": "大敦"
      },
      {
        "detailTitle": "行间：改善目赤与头痛",
        "detailDescription": "行，运行；间，中间。穴在第1、第2跖趾关节的前方陷中，经气运行其间。",
        "cure": "清肝泻热，凉血安神，熄风活络。主治目赤、头痛、高血压、阳痿、痛经、甲状腺肿大。",
        "position": "在足背，第1、第2跖趾间，跖趾缘后方赤白肉际处。",
        "quickFind": "坐位，在足背部第1、第2两趾之间连接处的缝纹头处即是。",
        "massage": "一边用中指指腹强压行间，一边吐气，有轻微疼痛感，重复按压2〜3分钟，可缓解头痛、耳鸣耳聋、失眠。",
        "xueweiName": "行间"
      },
      {
        "detailTitle": "太冲：清肝火又消怒气",
        "detailDescription": "太，大；冲，重要部位，穴在足背，脉气盛大。为肝经要穴。",
        "cure": "平肝泻热，舒肝养血，清利下焦。失眠、头痛、腰痛、全身胀痛、甲状腺肿大、肝炎、闭经、胆囊炎、胆结石。",
        "position": "在足背，当第1、第2跖骨间，跖骨底结合部前方凹陷中。",
        "quickFind": "足背，沿第1、第2趾间横纹向足背上推，感觉到有一凹陷处即是。",
        "massage": "按揉太冲，对除焦虑有特效。",
        "xueweiName": "太冲"
      },
      {
        "detailTitle": "中封：保养精血之要穴",
        "detailDescription": "中，中间；封，聚土成堆，穴在两踝之间，如土堆之中。",
        "cure": "清泻肝胆，通利下焦，舒筋通络。主治内踝肿痛、足冷、小腹痛、喘干、肝炎。",
        "position": "在内踝前，胫骨前肌腱的内侧缘凹陷处。",
        "quickFind": "坐位，拇趾上翘，足背可见一大筋，其内侧、足内踝前下方凹陷处即是。",
        "massage": "用拇指指端用力按中封，每次3分钟，以有酸胀感为宜，可调理男性肾虚。",
        "xueweiName": "中封"
      },
      {
        "detailTitle": "蠡沟：治疗瘙痒有奇效",
        "detailDescription": "蠡，贝壳；沟，水沟。腓肠肌外形酷似贝壳，穴在其前方沟中。",
        "cure": "疏肝理气，调经止带。主治疝气、遗尿、阴痛阴痒、月经不调、崩漏。",
        "position": "在小腿内侧，内踝尖上5寸，胫骨内侧面的中央。",
        "quickFind": "坐位，内踝尖垂直向上量7横指，胫骨内侧凹陷处即是。",
        "massage": "多揉蠡沟可治阴囊湿疹、阴道瘙痒等湿热病。",
        "xueweiName": "蠡沟"
      },
      {
        "detailTitle": "中都：急性疼痛揉中都",
        "detailDescription": "中，中间；都，会聚。穴在小腿内侧中间，为肝经之气深聚之处。",
        "cure": "疏肝理气，调经止血。主治疝气、痢疾、小腹痛、遗精、崩漏。",
        "position": "在小腿内侧，内踝尖上7寸，胫骨内侧面的中央。",
        "quickFind": "坐位，内踝尖与阴陵泉连线之中点上半横指处即是。",
        "massage": "用中指指腹揉中都，可缓解急性肋骨痛、急性肝区痛、急性眼睛胀痛。",
        "xueweiName": "中都"
      },
      {
        "detailTitle": "膝关：膝部疼痛就揉它",
        "detailDescription": "膝，膝部；关，关节。穴在膝关节附近。",
        "cure": "散风祛湿，疏通关节。主治膝髌肿痛、膝关节痛、下肢痿痹。",
        "position": "在膝部，胫骨内侧髁的下方，阴陵泉后1寸。",
        "quickFind": "先找到阴陵泉，向后量1横指，可触及一凹陷处即是。",
        "massage": "用拇食二指的指腹拿捏膝关3~5分钟，可以有效缓解膝部和下肢疼痛。",
        "xueweiName": "膝关"
      },
      {
        "detailTitle": "曲泉：乳腺增生就找它",
        "detailDescription": "曲，弯曲；泉，水泉。穴在腘窝横纹内侧端；屈膝时局部呈凹陷如泉。",
        "cure": "清利湿热，通调下焦。主治月经不调、子宫脱垂、乳腺增生、阳痿。",
        "position": "在膝部，腘横纹内侧端，半腱肌肌腱内缘凹陷中。",
        "quickFind": "膝内侧，屈膝时可见膝关节内侧面横纹端，其横纹头凹陷处即是。",
        "massage": "常用手指敲击左腿曲泉，能疏肝解郁，有效防治乳腺增生。",
        "xueweiName": "曲泉"
      },
      {
        "detailTitle": "阴包：生殖泌尿它统管",
        "detailDescription": "阴，阴阳之阴；包，通“胞”。穴在大腿内侧，主子宫疾病。",
        "cure": "调经止痛，利尿通淋。主治月经不调、腰骶痛、小便难、遗尿。",
        "position": "在股前区，髌底上4寸，股内肌与缝匠肌之间。",
        "quickFind": "大腿内侧，膝盖内侧上端的骨性标志，直上6横指处即是。",
        "massage": "用拇指指腹轻揉阴包，可增强生殖器官的功能，也可预防女性乳腺疾病。",
        "xueweiName": "阴包"
      },
      {
        "detailTitle": "足五里：通利小便见效快",
        "detailDescription": "足，下肢；五，数词；里，古代有以里为寸之说。穴在下肢，约当箕门上5寸。",
        "cure": "疏肝理气，清利祛热。主治腹胀、小便不通、阴囊湿痒、风痔。",
        "position": "在股前侧，气冲直下3寸，动脉搏动处。",
        "quickFind": "先取气冲，直下4横指处即是。",
        "massage": "按摩足五里，可缓解小便不通畅、阴部湿痒、浑身倦怠无力等症状。",
        "xueweiName": "足五里"
      },
      {
        "detailTitle": "阴廉：调经止带此穴佳",
        "detailDescription": "阴，阴阳之阴；廉，边缘。内为阴。穴在大腿内侧阴器的边缘。",
        "cure": "调经止带，通利下焦。主治月经不调、小腹疼痛、下肢痉挛。",
        "position": "在股前侧，气冲直下2寸。",
        "quickFind": "先取气冲，直下3横指处即是。",
        "massage": "用中指指腹同时揉按两侧阴廉3~5分钟，可治生殖系统疾病。",
        "xueweiName": "阴廉"
      },
      {
        "detailTitle": "急脉：急性腹痛就按它",
        "detailDescription": "急，急促；脉，脉气。肝经气血在此吸热后化为强劲的风气。",
        "cure": "疏理肝胆，通调下焦。主治小腹痛、疝气、阴茎痛、股内侧部疼痛。",
        "position": "在腹股沟区，横平耻骨联合上缘，前正中线旁开2.5寸处。",
        "quickFind": "腹股沟动脉搏动处即是。",
        "massage": "用中指指腹轻揉左右急脉，每次1~3分钟，可改善精力减退、腰腿寒冷。",
        "xueweiName": "急脉"
      },
      {
        "detailTitle": "章门：腹胀按之效如神",
        "detailDescription": "章，同“障“”字；门，门户。穴在季肋下，如同屏障内脏之门户。",
        "cure": "疏肝健脾，理气散结。主治腹痛、腹胀、口干、口苦、呕吐、打嗝、腹泻。",
        "position": "在侧腹部，第11肋游离端的下际。",
        "quickFind": "正坐，屈肘合腋，肘尖所指处，按压有酸胀感处即是。",
        "massage": "腹痛、腹胀时用拇指指腹轻柔地按摩，一般持续3~5分钟，即可缓解。",
        "xueweiName": "章门"
      },
      {
        "detailTitle": "期门：疏肝理气化瘀积",
        "detailDescription": "期，周期；门，门户。两侧胁肋如敞开之门户。",
        "cure": "疏肝健脾，理气活血。主治乳房胀痛、肋间神经痛、肝炎、抑郁症。",
        "position": "在胸部，第6肋间隙，前正中线旁开4寸。",
        "quickFind": "正坐或仰卧，自乳头垂直向下推2个肋间隙，按压有酸胀感处即是。",
        "massage": "每天按揉期门2次，每次200下。可治各种妇科疾病和男科前列腺肥大。",
        "xueweiName": "期门"
      },
      {
        "detailTitle": "会阴：生殖疾病按之效",
        "detailDescription": "会，交会；阴，在此指下部两阴窍。两阴之间名会阴，穴当其中。",
        "cure": "醒神镇惊，通调二阴。主治阴痒、阴痛、便秘、闭经、昏迷。",
        "position": "在会阴部。男性在阴囊根部与肛门连线的中点，女性在大阴唇后联合与肛门连线的中点。",
        "quickFind": "仰卧屈膝，在会阴部，取两阴连线的中点即是。",
        "massage": "用中指指腹揉按会阴1~3分钟，有酸胀感为宜。可调理男性生殖器官疾病。",
        "xueweiName": "会阴"
      },
      {
        "detailTitle": "曲骨：畅通小便按按它",
        "detailDescription": "曲，弯曲；骨，骨头。曲骨，指耻骨，穴在耻骨联合上缘。",
        "cure": "调经止带，通利小便。主治遗精、阳痿、前列腺炎、月经不调、痛经。",
        "position": "在下腹部，耻骨联合上缘，前正中线上。",
        "quickFind": "在下腹部，正中线上，从下腹部向下摸到一横着走行的骨性标志上缘。",
        "massage": "中指指腹揉按曲骨3~5分钟，可治疗和调理小便不利、月经不调等疾病。",
        "xueweiName": "曲骨"
      },
      {
        "detailTitle": "中极：解除尿频与尿痛",
        "detailDescription": "中，中间；极，正是。穴位正是在人体上下左右之中间。",
        "cure": "益肾通经。主治尿频、遗精、月经不调、痛经、前列腺炎、夜尿症。",
        "position": "在下腹部，脐中下4寸，前正中线上。",
        "quickFind": "在下腹部，正中线上，耻骨联合上缘1横指处即是。",
        "massage": "中指指腹揉按中极，每次1〜3分钟，对男女性生殖系统有保健作用。",
        "xueweiName": "中极"
      },
      {
        "detailTitle": "关元：性保健第一要穴",
        "detailDescription": "关，关藏；元，元气。穴在脐下3寸，为关藏人身元气之处。",
        "cure": "培肾固本，调气回阳。主治虚胖浮肿、月经不调、痛经、遗精、阳痿、不孕不育、小儿发热、白带过多、肠胃疾病、脂肪肝。",
        "position": "在下腹部，脐中下3寸，前正中线上。",
        "quickFind": "在下腹部，正中线上，肚脐中央向下4横指处即是。",
        "massage": "先将手掌温热，敷在穴位上，再指压关元，可增加刺激时的舒适感，常摩揉关元，也可益肾壮阳。",
        "xueweiName": "关元"
      },
      {
        "detailTitle": "石门：治疗水肿就热敷",
        "detailDescription": "石，岩石；门，门户。石有坚实之意。本穴能治下腹坚实之证。",
        "cure": "理气止痛，通利水道。主治闭经、带下、小腹绞痛、水肿、小便不利。",
        "position": "在下腹部，当脐中下2寸，前正中线上。",
        "quickFind": "在下腹部，正中线上，肚脐中央向下3横指处即是。",
        "massage": "对于女性来说，石门不太适宜指压，也最好不要灸，可能引起不孕。可用蘸上姜汁的热毛巾热敷。",
        "xueweiName": "石门"
      },
      {
        "detailTitle": "气海：任脉之补虚要穴",
        "detailDescription": "",
        "cure": "益气助阳，调经固经。主治小腹疾病、肠胃疾病、虚证、遗精。",
        "position": "在下腹部，脐中下1.5寸，前正中线上。",
        "quickFind": "在下腹部，正中线上，肚脐中央向下与关元之间的中点处即是。",
        "massage": "常按揉气海，可补气；用艾条温和灸气海，每次10〜15分钟，可治月经不调、痛经、腹泻、消化不良等。",
        "xueweiName": "气海"
      },
      {
        "detailTitle": "阴交：腹泻不止揉阴交",
        "detailDescription": "阴，阴阳之阴；交，交会。穴在脐下1寸，为任脉、冲脉和肾经交会处。",
        "cure": "调经固带，利水消肿。主治阴部多汗湿痒、月经不调、血崩、带下。",
        "position": "在下腹部，脐中下1寸，前正中线上。",
        "quickFind": "在下腹部，正中线上，肚脐中央向下1横指处即是。",
        "massage": "腹泻、腹胀时，用中指指腹轻揉阴交3~5分钟，不适就会减轻。",
        "xueweiName": "阴交"
      },
      {
        "detailTitle": "神阙：睡前按之补亏虚",
        "detailDescription": "神，神气；阙，宫门。穴在脐中。脐为胎儿气血运行之要道，如神气出入之宫门。",
        "cure": "温阳救逆，利水固脱。主治腹泻、腹胀、月经不调、崩漏、遗精、不孕、小儿腹泻。",
        "position": "在脐区，脐中央。",
        "quickFind": "在脐区，肚脐中央即是。",
        "massage": "经常揉脐，可防治小儿腹泻、疳积等；突然大汗淋漓、唇舌苍白、手脚冰冷之虚脱症，马上温灸神阙可起到急救作用。",
        "xueweiName": "神阙"
      },
      {
        "detailTitle": "水分：水肿腹水常按它",
        "detailDescription": "水，水谷；分，分别。穴在脐上1寸，内应小肠，水谷至此分别清浊。",
        "cure": "通调水道，理气止痛。主治水肿、腹泻、腹痛、绕脐痛、肠鸣。",
        "position": "在上腹部，脐中上1寸，前正中线上。",
        "quickFind": "在上腹部，肚脐中央向上1横指处。",
        "massage": "水肿、腹水时用食指揉按腹部的水分，按至有热感为止。",
        "xueweiName": "水分"
      },
      {
        "detailTitle": "下脘：水肿腹水常按它",
        "detailDescription": "下，下方；脫，胃脱。穴当胃腕之下部。",
        "cure": "健脾和胃，降逆止呕。主治胃痛、腹痛、腹胀、呕吐、打嗝、腹泻。",
        "position": "在上腹部，脐中上2寸，前正中线上。",
        "quickFind": "在上腹部，正中线上，肚脐中央向上3横指处即是。",
        "massage": "按摩时以手掌按揉下脱50~100次，对缓解腹痛，治疗消化不良、呕吐十分有效。",
        "xueweiName": "下脘"
      },
      {
        "detailTitle": "建里：体虚之人温补药",
        "detailDescription": "建，建立；里，里部。当胃院部，有助于建立中焦里气。",
        "cure": "和胃健脾，通降腑气。主治胃痛、呕吐、食欲不振、肠中切痛。",
        "position": "在上腹部，脐中上3寸，前正中线上。",
        "quickFind": "在上腹部，正中线上，肚脐中央向上4横指处即是。",
        "massage": "按压揉摩建里，常用来治疗胃痛、食欲不振、腹痛等病。",
        "xueweiName": "建里"
      },
      {
        "detailTitle": "中脘：胃痛呕吐有奇效",
        "detailDescription": "中，中间；脱，胃脱。穴当胃脱之中部。",
        "cure": "和胃降逆，健脾利水。主治胃痛、小儿厌食、呕吐、高血压、急性肠胃炎、脂肪肝。",
        "position": "在上腹部，脐中上4寸，前正中线上。",
        "quickFind": "在上腹部，肚脐与胸剑联合连线的中点处。",
        "massage": "在中脘或摩或按，可治疗胃痛、呕吐等症。",
        "xueweiName": "中脘"
      },
      {
        "detailTitle": "上脘：增加你的胃动力",
        "detailDescription": "上，上方；脘，胃皖。穴当胃脘之上部。",
        "cure": "和胃降逆，化痰宁神。主治胃痛、呕吐、打嗝、纳呆、痢疾。",
        "position": "在上腹部，脐中上5寸，前正中线上。",
        "quickFind": "在上腹部，中皖上1横指处。",
        "massage": "因吃得太快、吃得太饱，或者其他原因而引起胃胀、呕吐、打嗝等症状时，用拇指指腹揉按上腕3〜5分钟，可有效缓解不适。",
        "xueweiName": "上脘"
      },
      {
        "detailTitle": "巨阙：治胃下垂有良效",
        "detailDescription": "巨，巨大；阙，宫门。此为心之募穴，如心气出入的大门",
        "cure": "安神宁心，宽胸止痛。主治胃痛、心痛、腹胀、脚气、急性肠胃炎。",
        "position": "在上腹部，脐中上6寸，前正中线上。",
        "quickFind": "在上腹部，正中线上，中脘与胸剑联合之间的中点处即是。",
        "massage": "按揉巨阙善治胃下垂，亦可用艾灸法，每次5~10分钟。",
        "xueweiName": "巨阙"
      },
      {
        "detailTitle": "鸠尾：皮肤干燥不用愁",
        "detailDescription": "鸠，鸠鸟；尾，尾巴。胸骨剑突形如鸠鸟之尾，穴在其下。",
        "cure": "安心宁神，宽胸定喘。主治咽喉肿痛、偏头痛、哮喘、呕吐、胃痛。",
        "position": "在上腹部，胸剑结合部下1寸，前正中线上。",
        "quickFind": "从胸剑结合部沿前正中线直下1横指处即是。",
        "massage": "经常用四指叩击鸠尾，可使皮肤富有光泽，气色饱满，精神充沛。",
        "xueweiName": "鸠尾"
      },
      {
        "detailTitle": "中庭：胸满呕吐就找它",
        "detailDescription": "中，中间；庭，庭院。穴在心下，犹如在宫殿前的庭院之中。",
        "cure": "宽胸消胀，降逆止呕。主治心痛、胸满、噎嗝、呕吐、小儿吐乳。",
        "position": "在胸部，胸剑结合中点处，前正中线上。",
        "quickFind": "在胸部，由锁骨往下数第5肋间，平第5肋间，当前正中线上即是。",
        "massage": "由上向下推中庭100次，可治疗胸腹胀满、呕吐、噎嗝等胃气上逆病症。",
        "xueweiName": "中庭"
      },
      {
        "detailTitle": "膻中：乳汁不足就灸它",
        "detailDescription": "膻，袒露；中，中间。胸部袒露出的中间部位古称膻中，穴当其处。",
        "cure": "理气止痛，生津增液。主治胸闷、气短、气管炎、咳喘、呕吐、更年期综合征、产妇乳少、乳房胀痛、小儿咳嗽。",
        "position": "在胸部，横平第4肋间隙，前正中线上。",
        "quickFind": "在胸部，由锁骨往下数第4肋间，平第4肋间，当前正中线上即是。",
        "massage": "每天按揉300-500次膻中，可治疗产后乳汁不足；用艾条灸5~10分钟亦有效。",
        "xueweiName": "膻中"
      },
      {
        "detailTitle": "玉堂：宽胸止痛就按它",
        "detailDescription": "玉，玉石；堂，殿堂。玉有贵重之意。穴在相当于心的部位，因其重要故比之为玉堂。",
        "cure": "宽胸止痛，止咳平喘。主治咳嗽、胸痛、呕吐、哮喘、气短喘息。",
        "position": "在胸部，横平第3肋间隙，前正中线上。",
        "quickFind": "在胸部，由锁骨往下数第3肋间，平第3肋间，当前正中线上即是。",
        "massage": "两手中指指腹相互叠加，用力按压玉堂，有酸胀感。每次3~5分钟，可治呕吐、胸痛、乳房胀痛等气滞引起的疾病。",
        "xueweiName": "玉堂"
      },
      {
        "detailTitle": "紫宫：呼吸顺畅按按它",
        "detailDescription": "紫，紫色；宫，宫殿。紫宫，星名，代表帝王所居之处。穴对心的部位，心为君主之官。",
        "cure": "宽胸理气，止咳平喘。主治咳嗽、气喘、胸胁支满、胸痛、食欲不振。",
        "position": "在胸部，横平第2肋间隙，前正中线上。",
        "quickFind": "在胸部，由锁骨往下数第2肋间，平第2肋间，当前正中线上即是。",
        "massage": "用中间三指按揉紫宫5~15分钟，可治咳嗽、气喘、胸痛、支气管炎、呕吐等症。",
        "xueweiName": "紫宫"
      },
      {
        "detailTitle": "华盖：止咳平喘按华盖",
        "detailDescription": "华盖在此指帝王所用的盖伞。穴位所在相当于肺脏部位；肺布心君之上，犹如心之华盖。",
        "cure": "宽胸利肺，止咳平喘。主治咳嗽、气喘、咽喉肿痛、胸胁支满、胸痛。",
        "position": "在胸部，横平第1肋间隙，前正中线上。",
        "quickFind": "在胸部，由锁骨往下数第1肋间，平第1肋间，当前正中线上即是。",
        "massage": "两手中指指腹相互叠加，用力按压华盖，每次3~5分钟，可治咳嗽、气喘、扁桃体炎等疾病。",
        "xueweiName": "华盖"
      },
      {
        "detailTitle": "璇玑：定喘顺气找璇巩",
        "detailDescription": "璇，同“旋”；巩，同“机”。璇巩，为北斗星的第二至第三星，与紫宫星相对，故名。",
        "cure": "宽胸利肺，止咳平喘。主治咳嗽、气喘、胸胁支满、胸痛、咽喉肿痛。",
        "position": "在胸部，胸骨上窝下1寸，前正中线上。",
        "quickFind": "仰卧，从天突沿前正中线向下1横指处即是。",
        "massage": "用拇指指腹直接点压，有酸、胀、麻感觉时为宜，每次3~5分钟。可治咳嗽、气喘、胸痛、咽喉肿痛等病。",
        "xueweiName": "璇玑"
      },
      {
        "detailTitle": "天突：声音沙哑可缓解",
        "detailDescription": "天，天空；突，突出。穴位于气管上段，喻为肺气上通于天的部位。",
        "cure": "宣通肺气，消痰止咳。主治哮喘、咳嗽、咯吐脓血、暴喑、咽喉肿痛、小儿感冒。",
        "position": "在颈前区，胸骨上窝中央，前正中线上。",
        "quickFind": "仰卧，由喉结直下可摸到一凹窝，中央处即是。",
        "massage": "用中指指腹慢慢按压天突1~2分钟，按摩时要格外轻柔，可治由于咳嗽、咽炎等呼吸系统疾病引起的声音嘶哑。",
        "xueweiName": "天突"
      },
      {
        "detailTitle": "廉泉：中风失语就求它",
        "detailDescription": "廉，清；泉，水泉。舌下两脉古名廉泉，在喉结上缘。廉泉靠近此脉。",
        "cure": "利喉舒舌，消肿止痛。主治舌下肿痛、舌强不语、口舌生疮、口苦。",
        "position": "在颈前区，喉结上方，舌骨上缘凹陷中，前正中线上。",
        "quickFind": "仰坐，从下巴沿颈前正中线向下推，喉结上方可触及舌骨体，上缘中点处即是。",
        "massage": "用拇指指腹点揉廉泉，用力要轻且均匀，反复进行3~5分钟，可调治舌痛、中风失语、慢性咽炎等病症。",
        "xueweiName": "廉泉"
      },
      {
        "detailTitle": "承浆：口腔疾病好助手",
        "detailDescription": "承，承受；浆，水浆。穴在新唇正中的凹陷中，为承受从口流出的水浆之处。",
        "cure": "生津敛液，舒筋活络。主治中风昏迷、口眼歪斜、流涎、牙关紧闭。",
        "position": "在面部，须唇沟的正中凹陷处。",
        "quickFind": "正坐仰靠，颁唇沟正中按压有凹陷处即是。",
        "massage": "用拇指指腹直接点压承浆，局部有酸、胀、麻感，每次1~3分钟。有通经活络、清热利咽的功效。",
        "xueweiName": "承浆"
      },
      {
        "detailTitle": "长强：治疗便秘与痔疮",
        "detailDescription": "长，长短之长；强，强弱之强。肾为生命之源。脊柱长而强韧，穴在其下端。",
        "cure": "宁神镇惊，通便消痔。主治腹泻、便秘、便血、痔疮、脱肛、女性阴道瘙痒、阴囊湿疹。",
        "position": "在尾骨下方，尾骨端与肛门连线的中点处。",
        "quickFind": "仰卧屈膝，在尾骨端下，尾骨端与肛门连线中点处即是。",
        "massage": "正坐，上身前俯，一手伸到臀后，用中指用力揉按长强，每天早晚各揉按1~3分钟。可治疗便秘、痔疮、脱肛，并迅速止泻。",
        "xueweiName": "长强"
      },
      {
        "detailTitle": "腰俞：咽喉腰痛不用怕",
        "detailDescription": "腰，腰部；俞，输注。穴在腰部，是经气输注之处。",
        "cure": "调经清热，散寒除湿。主治腹泻、便秘、痔疮、尾骶痛、月经不调。",
        "position": "在髄区，正对髄管裂孔，后正中线上。",
        "quickFind": "俯卧，后正中线上，顺着脊柱向下，正对骶管裂孔处即是。",
        "massage": "正坐，一手伸到臀后，用中指用力揉按腰俞，每天早晚各揉按1~3分钟，可治腹泻等肠腑疾病，以及月经不调等。",
        "xueweiName": "腰俞"
      },
      {
        "detailTitle": "腰阳关：遗精阳痿不复返",
        "detailDescription": "腰，腰部；阳，阴阳之阳；关，机关。督脉为阳。穴属督脉，位于腰部转动处，如腰之机关。",
        "cure": "祛寒除湿，舒筋活络。主治腰骶痛、下肢痿痹、遗精、阳痿、月经不调。",
        "position": "在腰部脊柱区，第4腰椎棘突下凹陷中，后正中线上。",
        "quickFind": "两侧髂前上棘连线与脊柱交点处，可触及一凹陷处即是。",
        "massage": "左手或右手握拳，以食指掌指关节突起部揉按腰阳关3~5分钟，可治腰膝酸痛、阳痿、早泄等。",
        "xueweiName": "腰阳关"
      },
      {
        "detailTitle": "命门：强腰膝还补肾气",
        "detailDescription": "命，生命；门，门户。肾为生命之源。穴在肾俞之间，相当于肾气出入之门户。",
        "cure": "补肾壮阳。主治遗精、阳痿、不孕、腰脊强痛、下肢痿痹。",
        "position": "在腰部脊柱区，第2腰椎棘突下凹陷中。",
        "quickFind": "肚脐水平线与后正中线交点，按压有凹陷处即是。",
        "massage": "每天按摩命门3分钟，可治疗阳痿、遗精、月经不调、四肢冷等疾病。",
        "xueweiName": "命门"
      },
      {
        "detailTitle": "悬枢：腰脊强痛就按它",
        "detailDescription": "悬，悬挂；枢，枢纽。穴在腰部，仰卧时局部悬起，是腰部活动的枢纽。",
        "cure": "助阳健脾，通调肠气。主治遗精、阳痿、不孕、腰脊强痛、下肢痿痹。",
        "position": "在腰部脊柱区，第1腰椎棘突下凹陷中，后正中线上。",
        "quickFind": "从命门沿后正中线向上推一个椎体，其上缘凹陷处即是。",
        "massage": "常按揉悬枢，可治腹胀、腹泻、消化不良、腰背部疼痛等胃肠疾病。",
        "xueweiName": "悬枢"
      },
      {
        "detailTitle": "脊中：健脾利湿就找它",
        "detailDescription": "脊，脊柱；中，中间。脊柱古作二十一椎；穴在第十一椎下，正当其中。",
        "cure": "健脾利湿，宁神镇惊。主治腹泻、反胃、吐血、痢疾、痔疮、小儿疳积。",
        "position": "在背部脊柱区，第11胸椎棘突下凹陷中，后正中线上。",
        "quickFind": "两侧肩胛下角连线与后正中线相交处向下推4个椎体，其下缘凹陷处即是。",
        "massage": "用拇指指腹常按揉脊中，可治腹胀、腹泻、痔疮、脱肛、便血等肠腑病症。",
        "xueweiName": "脊中"
      },
      {
        "detailTitle": "中枢：健脾胃又促消化",
        "detailDescription": "中，中间；枢，枢纽。穴在第10胸椎下，相当于脊柱中部之枢纽。",
        "cure": "健脾利湿，清热止痛。主治呕吐、腹满、胃痛、食欲不振、腰背痛。",
        "position": "在背部脊柱区，第10胸椎棘突下凹陷中，后正中线上。",
        "quickFind": "两侧肩胛下角连线与后正中线相交处向下推3个椎体，其下缘凹陷处即是。",
        "massage": "常按揉中枢穴，可治腰背疼痛、呕吐、腹胀、胃痛、食欲不振等脾胃疾病。",
        "xueweiName": "中枢"
      },
      {
        "detailTitle": "筋缩：善治筋脉拘挛病",
        "detailDescription": "筋，筋肉；缩，挛缩。本穴能治筋肉挛缩诸病。",
        "cure": "平肝熄风，宁神镇痉。主治抽搐、脊强、四肢不收、筋挛拘急。",
        "position": "在背部脊柱区，第9胸椎棘突下凹陷中，后正中线上。",
        "quickFind": "两侧肩胛下角连线与后正中线相交处向下推2个椎体，其下缘凹陷处即是。",
        "massage": "经常点揉筋缩，可治腰椎间盘突出、筋脉拘挛、小儿抽动症、癫痫等症。",
        "xueweiName": "筋缩"
      },
      {
        "detailTitle": "至阳：快速止痛有绝招",
        "detailDescription": "至，到达；阳，阴阳之阳。本穴与横膈平。经气至此从膈下的阳中之阴到达膈上的阳中之阳。",
        "cure": "利胆退黄，宽胸利膈。主治胃痛、胸胁胀痛、黄疸、腰背疼痛、心悸。",
        "position": "在背部脊柱区，第7胸椎棘突下凹陷中，后正中线上。",
        "quickFind": "两侧肩胛下角连线与后正中线相交处椎体，其下缘凹陷处即是。",
        "massage": "用按摩槌敲打刺激至阳，每次3~5分钟，可即时缓解心绞痛、胃痛和腹痛症状。",
        "xueweiName": "至阳"
      },
      {
        "detailTitle": "灵台：忧郁失眠养心穴",
        "detailDescription": "灵，神灵；台，亭台。穴在神道与心俞两穴之下，故喻为心灵之台。",
        "cure": "清热化湿，止咳定喘。主治咳嗽、气喘、颈项僵硬、背痛、忧郁、失眠。",
        "position": "在背部脊柱区，第6胸椎棘突下凹陷中，后正中线上。",
        "quickFind": "两侧肩胛下角连线与后正中线相交处向上推1个椎体，其下缘凹陷处即是。",
        "massage": "经常用按摩槌，在灵台处轻轻敲打，可以提高睡眠质量。",
        "xueweiName": "灵台"
      },
      {
        "detailTitle": "神道：帮助缓解心绞痛",
        "detailDescription": "神，心神；道，通道。心藏神，穴在心俞旁，如同心神之通道。",
        "cure": "宁神安心，清热平喘。主治失眠、肩背痛、小儿惊风、咳嗽、神经衰弱。",
        "position": "在背部脊柱区，第5胸椎棘突下凹陷中，后正中线上。",
        "quickFind": "两侧肩胛下角连线与后正中线相交处向上推2个椎体，其下缘凹陷处即是。",
        "massage": "用双手中指指腹互相叠加，用力揉按神道3~5分钟，可缓解心脏供血不足，治疗心绞痛、心脏不适。",
        "xueweiName": "神道"
      },
      {
        "detailTitle": "身柱：治疗咳嗽和气喘",
        "detailDescription": "身，身体；柱，支柱。穴在第3胸椎下，上连头项，下通背腰，如一身之支柱。",
        "cure": "宣肺清热，宁神镇咳。主治咳嗽、气喘、腰脊强痛、神经衰弱、牛皮癣。",
        "position": "在上背部脊柱区，第3胸椎棘突下凹陷中，后正中线上。",
        "quickFind": "两侧肩胛骨内侧角连线与后正中线相交处椎体，其下缘凹陷处即是。",
        "massage": "用中指指尖揉按身柱，有剌痛感为宜，每次揉按3~5分钟，可治气喘、感冒、咳嗽、肺结核，以及因咳嗽导致的肩背疼痛等疾病；常按揉捶击此穴，可保健强身。",
        "xueweiName": "身柱"
      },
      {
        "detailTitle": "陶道：常按可愉悦身心",
        "detailDescription": "陶，陶冶；道，通道。比喻脏腑之气汇聚于督脉，由此路上升。",
        "cure": "解表清热，截虐宁神。主治头痛、目眩、闭经、寻麻疹、精神病。",
        "position": "在项背部脊柱区，第1胸椎棘突下凹陷中，后正中线上。",
        "quickFind": "低头，颈背交界椎骨高突处垂直向下推1个椎体，其下缘凹陷处即是。",
        "massage": "陶道是一个能让人快乐的穴位，常按可使人心情安静踏实，精神得到愉悅。",
        "xueweiName": "陶道"
      },
      {
        "detailTitle": "大椎：感冒清热找大椎",
        "detailDescription": "大，巨大；椎，椎骨。古称第一胸椎棘突为大椎，穴适在其上方，故名。",
        "cure": "清热解表，截虐止痫。主治感冒发热、手足怕冷、颈椎病、扁桃体炎、痤疮。",
        "position": "在项背部脊柱区，第7颈椎棘突下凹陷中，后正中线上。",
        "quickFind": "低头，颈背交界椎骨高突处椎体，其下缘凹陷处即是。",
        "massage": "按揉大椎，可治颈项疼痛，在大椎拔罐20~30分钟，可治感冒、头痛、咳嗽、气喘。",
        "xueweiName": "大椎"
      },
      {
        "detailTitle": "哑门：声音沙哑不苦恼",
        "detailDescription": "哑，音哑；门，门户。本穴深刺可以致哑，也可治哑，故比喻为音哑的门户。",
        "cure": "散风熄风，开窍醒神。主治舌缓不语、重舌、失语、大脑发育不全。",
        "position": "在项后，第2颈椎棘突上际凹陷中，后正中线上。",
        "quickFind": "沿脊柱向上，入后发际上半横指处即是。",
        "massage": "哑门特殊，若按摩方法不对，不但治不了病，反而会致失声，所以按摩时要谨慎。",
        "xueweiName": "哑门"
      },
      {
        "detailTitle": "风府：感冒及时擦风府",
        "detailDescription": "风，风邪；府，处所。本穴为治风邪之处。",
        "cure": "散风熄风，通关开窍。主治感冒、颈项强痛、眩晕、咽喉肿痛、中风。",
        "position": "在颈后区，枕外隆突直下，两侧斜方肌之间凹陷中。",
        "quickFind": "沿脊柱向上，入后发际上1横指处即是。",
        "massage": "双手拇指指尖相互叠加向下，用指腹揉按风府，有酸痛、胀麻的感觉。每次揉按1~3分钟，可治风邪而致伤风感冒、发热、鼻塞等疾病。",
        "xueweiName": "风府"
      },
      {
        "detailTitle": "脑户：头痛按之可减轻",
        "detailDescription": "脑，脑髓；户，门户。督脉循脊上行入脑。穴在枕部，相当于脉气入脑的门户。",
        "cure": "醒神开窍，平肝熄风。主治癫狂、痫症、眩晕、头重、头痛、颈项僵硬。",
        "position": "在头部正中线上，枕外隆凸的上缘凹陷中。",
        "quickFind": "正坐或俯卧，在后正中线上，枕外粗隆上缘的凹陷处。",
        "massage": "揉按脑户3~5分钟，可有效缓解工作或心理压力引起的头痛。",
        "xueweiName": "脑户"
      },
      {
        "detailTitle": "强间：让你睡好心情好",
        "detailDescription": "强，强硬；间，中间。穴当顶骨与枕骨结合之中间，能治头项强痛。",
        "cure": "醒神宁心，平肝熄风。主治头痛、颈项强不得回顾、目眩、口㖞、痫症。",
        "position": "在头部正中线上，后发际正中直上4寸。",
        "quickFind": "百会与风府连线的中点。",
        "massage": "用中指指腹揉按强间，每次1~3分钟。可治头痛、目眩、颈项强痛等。",
        "xueweiName": "强间"
      },
      {
        "detailTitle": "后顶：头痛眩晕就按它",
        "detailDescription": "后，后方；顶，头顶。穴在头顶之后方。",
        "cure": "醒神安神，熄风止痉。主治颈项僵硬、头痛、眩晕、心烦、失眠。",
        "position": "在头部正中线上，后发际正中直上5.5寸。",
        "quickFind": "正坐或俯卧，在后正中线上，前、后发际之间的中点。",
        "massage": "用拇指指腹垂直揉按后顶，每天早晚各1次，可治头痛、眩晕、耳鸣等。",
        "xueweiName": "后顶"
      },
      {
        "detailTitle": "百会：长命百岁保健穴",
        "detailDescription": "百，多的意思；会，交会。百会是足三阳经、肝经和督脉等多经之交会处。",
        "cure": "熄风醒脑，升阳固脱。主治中风、惊悸、头痛、头晕、失眠、健忘、耳鸣、眩晕、脱肛、痔疮、低血压。",
        "position": "在头部正中线上，前发际正中直上5寸。",
        "quickFind": "正坐，两耳尖与头正中线相交处，按压有凹陷。",
        "massage": "两手中指叠压，按百会3分钟，长期坚持，可使人开慧增智、益寿延年。",
        "xueweiName": "百会"
      },
      {
        "detailTitle": "前顶：头晕就要按前顶",
        "detailDescription": "前，前方；顶，头顶。穴在头顶直前方。",
        "cure": "熄风醒脑，宁神镇静。主治癫痫、小儿惊风、头痛、头晕。",
        "position": "在头部正中线上，前发际正中直上3.5寸。",
        "quickFind": "正坐，由百会向前2横指即是。",
        "massage": "用双手中指交叠用力向下按揉3~5分钟，有酸胀感，可缓解头痛症状。",
        "xueweiName": "前顶"
      },
      {
        "detailTitle": "囟会：头痛鼻塞不见了",
        "detailDescription": "囟门，囟门；会，在此作“闭合”讲。穴当大囟门的闭合处。",
        "cure": "安神醒脑，清热消肿。主治头痛、鼻塞、目眩、心悸、面肿、鼻塞。",
        "position": "在头部，正中线上，前发际正中直上2寸。",
        "quickFind": "正坐，从前发际正中直上3横指处即是。",
        "massage": "每天早晚各揉按囟会1次，每次1~3分钟，可改善和治疗头痛、眩晕、癫痫、鼻窦炎等疾病。",
        "xueweiName": "囟会"
      },
      {
        "detailTitle": "上星：有效缓解眼疲劳",
        "detailDescription": "上，上方；星，星球。人头像天，穴在头上，如星在天。",
        "cure": "熄风清热，宁神通鼻。主治头痛、眩晕、目赤肿痛、鼻出血、鼻痛、眼疲劳。",
        "position": "在头部，正中线上，前发际正中直上1寸。",
        "quickFind": "正坐，前发际正中直上1横指处即是。",
        "massage": "用拇指指腹垂直向下压按上星，每次1~3分钟。可治各种头痛、头晕、目眩、目赤疼痛以及鼻窦炎、鼻出血等疾病。",
        "xueweiName": "上星"
      },
      {
        "detailTitle": "神庭：头昏呕吐不怕了",
        "detailDescription": "神，神明；庭，前庭。脑为元神之府，神在此指脑。穴在前额部，如脑室之前庭。",
        "cure": "宁神醒脑，降逆平喘。主治失眠、头晕、目眩、鼻塞、流泪、目赤肿痛。",
        "position": "在头部，正中线上，前发际正中直上0.5寸。",
        "quickFind": "正坐，从前发际正中直上1横指，拇指指甲中点处即是。",
        "massage": "用中指指尖掐按神庭，每次3~5分钟，可缓解和调理由重感冒或晕车、晕船引起的头昏、呕吐等症状。",
        "xueweiName": "神庭"
      },
      {
        "detailTitle": "素髎：昏迷急救马上按",
        "detailDescription": "素，鼻茎；缪，骨隙。穴在鼻茎下端的骨隙中。",
        "cure": "清热消肿，通利鼻窍。主治惊风、昏迷、鼻塞、低血压、休克、小儿惊风。",
        "position": "在面部，鼻尖的正中央。",
        "quickFind": "正坐或仰卧，面部鼻尖正中央即是。",
        "massage": "遇到有人因为血压下降而引发休克或者呼吸困难时，可立刻掐按病人素髎，直到症状有所缓和。",
        "xueweiName": "素髎"
      },
      {
        "detailTitle": "水沟：人体急救保命穴",
        "detailDescription": "水，水液；沟，沟渠。穴在人中沟中，人中沟形似水沟。",
        "cure": "醒神开窍，清热熄风。主治晕厥、中暑、惊风、面肿、腰脊强痛。",
        "position": "在面部，人中沟的上1/3与中1/3交点处。",
        "quickFind": "仰卧，面部人中沟上1/3处即是。",
        "massage": "掐水沟（人中），是最常用的急救措施。具体方法是：每分钟掐压人中20~40次，每次持续0.5~1秒。一般病人会很快苏醒，病情较重患者要立刻送医院。",
        "xueweiName": "水沟"
      },
      {
        "detailTitle": "兑端：牙痛鼻塞就找它",
        "detailDescription": "兑，指口；端，尖端。穴在口的上唇尖端。",
        "cure": "宁神醒脑，生津止渴。主治昏迷、牙痛、齿龈痛、鼻塞。",
        "position": "在面部，上唇结节的中点。",
        "quickFind": "仰卧，面部人中沟下端的皮肤与上唇的交界处即是。",
        "massage": "齿龈痛、鼻塞时，可用食指指腹揉按兑端，有很好的缓解和调理作用。",
        "xueweiName": "兑端"
      },
      {
        "detailTitle": "龈交：治疗急性腰扭伤",
        "detailDescription": "龈，齿龈；交，交会。上齿龈中缝，为督脉和任脉的交会处。",
        "cure": "宁神镇痉，清热消肿。主治小儿面疮、鼻塞、鼻息肉、癫狂、心烦。",
        "position": "在上唇内，上唇系带与上牙龈的交点。",
        "quickFind": "唇内的正中线上，上唇系带与上牙龈相接处即是。",
        "massage": "每天用舌头向上唇内侧顶，可刺激到龈交穴，有促进身体水分循环，预防下半身水肿的作用。",
        "xueweiName": "龈交"
      },
      {
        "detailTitle": "印堂：提神醒脑找印堂",
        "detailDescription": "印，泛指图章；堂，厅堂。古代指额部两眉头之间为“阙”，星相家称之为印堂，穴位在其上，故名。",
        "cure": "清头明目，通鼻开窍。失眠、头痛、眩晕、过敏性鼻炎、三叉神经痛。",
        "position": "在头部，两眉毛内侧端中间的凹陷中。",
        "quickFind": "两眉头连线中点处即是。",
        "massage": "若头痛、失眠、血压升高时，印堂就会晦暗，这时可以用中指指腹点按印堂3~5分钟，不适感觉就会得到缓解。",
        "xueweiName": "印堂"
      }
    ];

    // CommonData.jingmaiList.forEach(jingmai => {
    //   jingmai.xueweiList.forEach(xuewei => {
    //     let jjjm = jingmaiList.find(xw => xw.xueweiName === xuewei.xueweiName);
    //     if (jjjm) {
    //       xuewei.xueweiDetail = jjjm;
    //       xuewei.xueweiDetail.jingluoName = jingmai.jingMaiName;
    //       xuewei.xueweiDetail.titleUrl = xuewei.xueweiName;
    //     }
    //   })
    // })

    // console.log(CommonData.jingmaiList);
    // console.log(JSON.stringify(CommonData.jingmaiList));
    // jingmaiList.forEach(jmai =>{
    //   jmai.xueweiName = jmai.detailTitle.split("：")[0];
    // })
  },
  destroyed() {
    // this.scene.dispose();
    // this.engine.dispose();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      console.log(vm);
      if (!vm.firstTimeRefresh) {
        let camera = vm.camera;
        camera.inputs.clear();
        camera.inputs.addPointers();
        camera.attachControl(vm.canvas, true);
        vm.engine.runRenderLoop(function () {
          vm.scene.render();
        });
      }
    })
  },
  // eslint-disable-next-line no-unused-vars
  beforeRouteLeave(to, from, next) {
    this.engine.stopRenderLoop();
    next();
  }
}
</script>

<style>
.box-3d-canvas {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.model-canvas-box {
  height: 100vh;
  overflow: hidden;
}

.main-page-button-main {
  position: absolute;
  bottom: 18vh;
  display: flex;
  justify-content: space-between;
  right: 6%;
  left: 6%;
}

.main-page-jingluo-search-main {
  position: absolute;
  color: white;
  font-size: 4vw;
  right: 2%;
  top: 20%;
  background-image: url("../assets/image/mainPage/JingMaiListBg.png");
  background-size: 100% 100%;
  border: 0;
  height: 117vw;
  width: 25vw;
  /*overflow: scroll;*/
}

.activeElement.main-page-jingluo-search-element {
  color: #0fffff;
}

.main-page-jingluo-search-title {
  background-image: url("../assets/image/mainPage/TitleBg.png");
  background-size: 100% 100%;
  border: 0;
  height: 10.2vw;
  width: 24vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4.2vw;
  font-family: "PingFang", serif;
  color: #0fffff;
}

.main-page-jingluo-search-element {
  border-bottom: dashed;
  border-bottom-color: #c8c8c8;
  color: #c8c8c8;
  font-family: "PingFang", serif;
  font-size: 3.5vw;
  margin: 0 2vw 0 0.6vw;
  padding: 1.2vw;
}

.main-page-jingluo-search-element:last-child {
  border-bottom: none;
}

.main-page-jingluo-search-list {
  height: 105vw;
  overflow: scroll;
}

</style>
